import DeleteIcon from "@mui/icons-material/Delete";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Autocomplete,
  Chip,
  ClickAwayListener,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  FormControlLabel,
  FormGroup,
  InputLabel,
  Menu,
  Select,
  Stack,
  ToggleButton,
  ToggleButtonGroup,
} from "@mui/material";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Checkbox from "@mui/material/Checkbox";
import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";
import MenuItem from "@mui/material/MenuItem";
import Paper from "@mui/material/Paper";
import { alpha } from "@mui/material/styles";
import Switch from "@mui/material/Switch";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import TextField from "@mui/material/TextField";
import Toolbar from "@mui/material/Toolbar";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
import { visuallyHidden } from "@mui/utils";
import { format, parseISO } from "date-fns";
import PropTypes from "prop-types";
import * as React from "react";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import {
  retrieveAllFreightOffersApi,
  retrieveFreightOfferByIdApi,
} from "../../../components/api/FreightOfferApiService";
import {
  retrieveFastShipmentRequestsApi,
  retrieveShipmentRequestByIdApi,
} from "../../../components/api/ShipmentRequestApiService";
import {
  retrieveFastFilteredShippingInstructionsApi,
  retrieveFastShippingInstructionsApi,
  retrieveSelectedShippingInstructionsByIdApi,
  retrieveShippingInstructionByIdApi,
  updateShippingInstructionApi,
} from "../../../components/api/ShippingInstructionApiService";
import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { retrieveAllWarehouseApi } from "../../../components/api/WarehouseApiService";
import ExportExcel from "../../../utils/excelExport";
import {
  currencies
} from "../../../utils/menu-items";
import EditFreightOffer from "../FreightOfferView/EditFreightOffer";
import EditShipmentRequest from "../ShipmentRequestView/EditShipmentRequest";
import AddShippingInstruction from "./AddShippingInstruction";
import CloseShippingInstructionButton from "./Dialogs/CloseShippingInstructionButton";
import ExportProformaDetails from "./Dialogs/ExportProformaDetails";
import ExportShippingDetails from "./Dialogs/ExportShippingDetails";
import ExportShippingInstruction from "./Dialogs/ExportShippingInstruction";
import OpenShippingInstructionButton from "./Dialogs/OpenShippingInstructionButton";
import ShippingInstructionHistoryButton from "./Dialogs/ShippingInstructionHistoryButton";
import EditShippingInstruction from "./EditShippingInstruction";
import ShipmentRequestButton from "./Dialogs/ShipmentRequestButton";
import OrderButton from "../ShipmentRequestView/Dialogs/OrderButton";
import EditVendorOrder from "../VendorOrderView/EditVendorOrder";
import EditCustomerOrder from "../CustomerOrder/EditCustomerOrder";
import ItemButton from "../ShipmentRequestView/Dialogs/ItemButton";
import EditItem from "../ItemView/EditItem";
import FreightOfferButton from "./Dialogs/FreightOfferButton";
import ClipLoader from "react-spinners/ClipLoader";
import { deleteUserComponentSettingsApi, retrieveUserComponentSettingsApi, retrieveUserReportsApi, saveUserComponentSettingsApi } from "../../../components/api/UserComponentSettingsApiService";
import { DndContext, closestCenter } from '@dnd-kit/core';
import {
  SortableContext,
  useSortable,
  arrayMove,
  verticalListSortingStrategy,
} from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import SortableItem from "./Dialogs/SortableItem";
import { retrieveAllItemsApi } from "../../../components/api/ItemApiService";
import { retrieveFastOrdersApi } from "../../../components/api/OrderApiService";
import ShippingSummary from "./ShippingSummary";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import ExportGoodsReceipt from "./Dialogs/ExportGoodsReceipt";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import FilterSelect from "../../../components/FilterSelect";
import { useAuth } from "../../../auth/AuthContext";
import { retrieveFastStakeholdersApi } from "../../../components/api/StakeholderApiService";
import MyFilters from "../../../components/MyFilters";
import BatchManagement from "./BatchManagement";
import BatchAllocationsDialog from "./Dialogs/BatchAllocationsDialog";
import { retrieveBatchAllocationCountsBySiApi } from "../../../components/api/BatchAllocationApiService";

function getValueByPath(obj, path) {
  return path.split('.').reduce((acc, key) => {
    return acc ? acc[key] : undefined;
  }, obj);
}

function descendingComparator(a, b, orderBy) {
const valueA = getValueByPath(a, orderBy);
  const valueB = getValueByPath(b, orderBy);

  if (valueA == null && valueB == null) return 0;
  if (valueA == null) return 1; 
  if (valueB == null) return -1; 

  if (orderBy === "timestamp" && typeof valueA === "string") {
    valueA = new Date(valueA);
    valueB = new Date(valueB);
  }

  if (valueB < valueA) {
    return -1;
  }
  if (valueB > valueA) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
  const stabilizedThis = array?.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) {
      return order;
    }
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

const headCells = [
  {
    id: "editButton",
    disablePadding: true,
    label: "",
    render: (row, rowIndex, { setEditShippingInstruction }) => (
      <Tooltip
        title={row?.status === "Cancelled" ? "Cancelled SIs cannot be edited." : ""}
        componentsProps={{ tooltip: { sx: { fontSize: "1rem" } } }}
      >
        <span>
          <Button
            disabled={row?.status === "Cancelled"}
            onClick={(e) => {
              e.stopPropagation();
              if (!row?.id) {
                alert("Please refresh the page.");
                return;
              }
              if (row?.status !== "Cancelled") {
                setEditShippingInstruction({
                  visible: true,
                  data: row,
                  index: rowIndex,
                });
              }
            }}
          >
            Edit
          </Button>
        </span>
      </Tooltip>
    ),
  },
  {
    id: "closeSiButton",
    disablePadding: true,
    label: "",
    render: (row, rowIndex, { retrieveShippingInstructionByIdApi, setInvoiceData, setCloseDialogOpen }) => (
      <Button
        disabled={row?.status === "Cancelled"}
        variant="outlined"
        onClick={(e) => {
          e.stopPropagation();
          if (!row?.id) {
            alert("Please refresh the page.");
            return;
          }
          e.preventDefault();
          const {
            siFolderLink,
            containsARInvoice,
            containsSupplierInvoice,
            containsInsurance,
            containsFreight,
            containsBLLink,
            containsWeightListLink,
            billOfLadingNumber,
            goodsReceiptNumber,
            landedCostNumber,
            deliveryNumber,
            bookingNumber,
            shippingLine,
            vesselName,
            voyageNumber,
          } = row;

          const missingFields = [];

          if (!siFolderLink)
            missingFields.push("SI Folder Link");
          if (!containsARInvoice)
            missingFields.push("AR Invoice");
          if (!containsSupplierInvoice)
            missingFields.push("Supplier Invoice");
          if (!containsInsurance)
            missingFields.push("Insurance Link");
          if (!containsFreight)
            missingFields.push("Freight Link");
          if (!containsBLLink)
            missingFields.push("BL Link");
          if (!billOfLadingNumber)
            missingFields.push("BL Number");
          if (!containsWeightListLink)
            missingFields.push("Weight List Link");
          if (!goodsReceiptNumber)
            missingFields.push("GR Number");
          if (!landedCostNumber)
            missingFields.push("LC Number");
          if (!deliveryNumber)
            missingFields.push("Del Number");
          if (!bookingNumber)
            missingFields.push("Booking Number");
          if (!shippingLine)
            missingFields.push("Shipping Line");
          if (!vesselName)
            missingFields.push("Vessel Name");
          if (!voyageNumber)
            missingFields.push("Voyage Number");

          if (missingFields.length > 0) {
            const warningMessage = `The following fields are missing:\n\n ${missingFields.join(
              ",\n ",
            )}.\n\n Do you still want to close the SI?`;

            if (!window.confirm(warningMessage)) {
              return;
            }
          }
          retrieveShippingInstructionByIdApi(row?.id)
            .then((response) => {
              setInvoiceData(response?.data);
              setCloseDialogOpen(true);
            })
            .catch((error) => {
              window.alert("Failed to retrieve shipping instructions. Please try again later.");
            });
        }}
      >
        {(row?.status==='Closed' && 'Open SI') || (row?.status==='Open' && 'Close SI')}
      </Button>
    ),
  },
  {
    id: "batchAllocationsToggle",
    disablePadding: true,
    label: "",
    render: (row, rowIndex, { handleToggleAllocations, batchCountMap }) => {
      const count = batchCountMap?.[row.id];
      return count > 0 ? (
        <Chip
          size="small"
          label={`${count} batch${count > 1 ? "es" : ""}`}
          color="primary"
          variant="outlined"
          onClick={(e) => { e.stopPropagation(); handleToggleAllocations?.(e, row); }}
          sx={{ cursor: "pointer" }}
        />
      ) : (
        <Button
          size="small"
          onClick={(e) => { e.stopPropagation(); handleToggleAllocations?.(e, row); }}
        >
          {"▼"}
        </Button>
      );
    },
  },
  {
    id: "uploadFileButton",
    disablePadding: true,
    label: "",
    render: (row, rowIndex, { retrieveShippingInstructionByIdApi, setInvoiceData, setUploadDialogOpen }) => (
      <Button
        disabled={row?.status === "Cancelled"}
        variant="outlined"
        onClick={(e) => {
          e.stopPropagation();
          if (!row?.id) {
            alert("Please refresh the page.");
            return;
          }
          retrieveShippingInstructionByIdApi(row?.id)
            .then((response) => {
              setInvoiceData(response?.data);
              setUploadDialogOpen(true);
            })
            .catch((error) => {
              window.alert("Failed to retrieve shipping instructions. Please try again later.");
            });
        }}
      >
        Upload File
      </Button>
    ),
  },
  {
    id: "cancelShippingInstructionButton",
    disablePadding: true,
    label: "",
    render: (row, rowIndex, { retrieveShippingInstructionByIdApi, cancelShippingInstruction, loadingRecord }) =>
      loadingRecord === row?.id ? (
        <ClipLoader color="#000000" loadingRecord={loadingRecord} size={35} />
      ) : (
        <Tooltip
          title={
            row?.recordStatus === "PASSIVE"
              ? "Passive SIs cannot be cancelled."
              : row?.status === "Cancelled"
                ? "SI already cancelled."
                : ""
          }
          arrow
        >
          <span>
            <Button
              style={{ whiteSpace: "nowrap" }}
              variant="outlined"
              color="warning"
              disabled={
                row?.recordStatus === "PASSIVE" ||
                row?.status === "Closed" ||
                row?.status === "Cancelled"
              }
              onClick={(e) => {
                e.stopPropagation();
                if (!row?.id) {
                  alert("Please refresh the page.");
                  return;
                }
                if (window.confirm(`Are you sure you want to cancel SI ${row?.finalShippingInstructionNumber || ""}?`)) {
                  retrieveShippingInstructionByIdApi(row?.id)
                    .then((response) => {
                      cancelShippingInstruction(response?.data);
                    })
                    .catch((error) => {
                      window.alert("Failed to retrieve shipping instruction. Please try again later.");
                    });
                }
              }}
            >
              Cancel SI
            </Button>
          </span>
        </Tooltip>
      ),
  },
  {
    id: "id",
    numeric: true,
    disablePadding: true,
    label: "ID",
    sx: {
      position: "sticky",
      left: 0,
      background: "inherit",
      zIndex: 1,
    },
    render: (row) => row?.id,
  },
  {
    id: "shipmentRequestId",
    disablePadding: true,
    label: "SR",
    render: (row, rowIndex, { setEditShipmentRequest }) => (
      <ShipmentRequestButton
        row={row}
        id={row?.shipmentRequestId}
        setEditShipmentRequest={setEditShipmentRequest}
      />
    ),
  },
  {
    id: "shipmentRequestType",
    disablePadding: true,
    label: "Type",
    render: (row) => row?.shipmentRequestType,
  },
  {
    id: "shipmentQuantity",
    disablePadding: true,
    label: "Shipment Quantity",
    render: (row) =>
      row?.shipmentQuantity
        ? `${new Intl.NumberFormat("en-US", { style: "decimal", minimumFractionDigits: 2 }).format(row.shipmentQuantity)} ${row?.shipmentQuantityUnit || ""}`
        : "",
  },
  {
    id: "shipmentRequestStorageQuantity",
    disablePadding: true,
    label: "Storage Quantity",
    render: (row) =>
      row?.shipmentRequestStorageQuantity
        ? `${new Intl.NumberFormat("en-US", { style: "decimal", minimumFractionDigits: 2 }).format(row.shipmentRequestStorageQuantity)}`
        : "",
  },
  {
    id: "finalShippingInstructionNumber",
    disablePadding: true,
    label: "SI Number",
    sx: {
      position: "sticky",
      left: 50,
      background: "inherit",
      zIndex: 1,
    },
    render: (row) => row?.finalShippingInstructionNumber,
  },
  {
    id: "shippingInstructionDate",
    disablePadding: true,
    label: "SI Date",
    render: (row) => row?.shippingInstructionDate ? format(new Date(row.shippingInstructionDate), "dd/MM/yyyy") : "",
  },
  {
    id: "shipmentRequestTo",
    disablePadding: true,
    label: "SI To",
       render: (row) => (
  row?.shipmentRequestTo?.length > 15 ? (
    <Tooltip title={row?.shipmentRequestTo} arrow placement="top">
      <span
        style={{
          display: "inline-block",
          maxWidth: "150px",
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
          verticalAlign: "top",
        }}
      >
        {row?.shipmentRequestTo}
      </span>
    </Tooltip>
  ) : (
    row?.shipmentRequestTo
  )
),
  },

  {
    id: "purchaseOrderId",
    disablePadding: true,
    label: "PO",
    render: (row, rowIndex, { setEditVendorOrder }) => (
      <OrderButton
        row={row}
        id={row?.purchaseOrderId}
        setEditOrder={setEditVendorOrder}
      />
    ),
  },
    {
    id: "purchaseOrderStatus",
    disablePadding: true,
    label: "PO Status",
    render: (row) => row?.purchaseOrderStatus,
  },
  {
    id: "purchaseOrderCompany",
    disablePadding: true,
    label: "PO Company",
    render: (row) => row?.purchaseOrderCompany,
  },
  {
    id: "purchaseOrderNumber",
    disablePadding: true,
    label: "SAP PO Number",
    render: (row) => row?.purchaseOrderNumber,
  },
  {
    id: "purchaseOrderIncoterm",
    disablePadding: true,
    label: "PO Incoterm",
    render: (row) => row?.purchaseOrderIncoterm,
  },
  {
    id: "salesOrderId",
    disablePadding: true,
    label: "SO",
    render: (row, rowIndex, { setEditCustomerOrder }) => (
      <OrderButton
        row={row}
        id={row?.salesOrderId}
        setEditOrder={setEditCustomerOrder}
      />
    ),
  },
      {
    id: "salesOrderStatus",
    disablePadding: true,
    label: "SO Status",
    render: (row) => row?.salesOrderStatus,
  },
  {
    id: "salesOrderCompany",
    disablePadding: true,
    label: "SO Company",
    render: (row) => row?.salesOrderCompany,
  },
  {
    id: "salesOrderNumber",
    disablePadding: true,
    label: "SAP SO Number",
    render: (row) => row?.salesOrderNumber,
  },
  {
    id: "salesOrderIncoterm",
    disablePadding: true,
    label: "SO Incoterm",
    render: (row) => row?.salesOrderIncoterm,
  },
  {
    id: "customer",
    disablePadding: true,
    label: "Customer",
       render: (row) => (
  row?.customer?.length > 15 ? (
    <Tooltip title={row?.customer} arrow placement="top">
      <span
        style={{
          display: "inline-block",
          maxWidth: "150px",
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
          verticalAlign: "top",
        }}
      >
        {row?.customer}
      </span>
    </Tooltip>
  ) : (
    row?.customer
  )
),
  },
  {
    id: "itemId",
    disablePadding: true,
    label: "Item ID",
    render: (row, rowIndex, { setEditItem }) => (
      <ItemButton
        row={row}
        id={row?.salesOrderItemId || row?.purchaseOrderItemId || ""}
        setEditItem={setEditItem}
      />
    ),
  },
  {
    id: "supplierGradeMark",
    disablePadding: true,
    label: "Supplier Grade Mark",
    render: (row) =>
      row?.salesOrderItemBuyingGrade ||
      row?.purchaseOrderItemBuyingGrade ||
      "",
  },
  {
    id: "shipmentRequestCustomerGradeMark",
    disablePadding: true,
    label: "Customer Grade Mark",
    render: (row) => row?.shipmentRequestCustomerGradeMark || "",
  },
  {
    id: "origin",
    disablePadding: true,
    label: "Origin",
    render: (row) =>
      row?.salesOrderItemOrigin || row?.purchaseOrderItemOrigin || "",
  },
  {
    id: "type",
    disablePadding: true,
    label: "Type",
    render: (row) =>
      row?.salesOrderItemType || row?.purchaseOrderItemType || "",
  },
  {
    id: "crop",
    numeric: true,
    disablePadding: true,
    label: "Crop",
    render: (row) =>
      row?.salesOrderItemCrop || row?.purchaseOrderItemCrop || "",
  },
    {
    id: "nicotine",
    numeric: true,
    disablePadding: true,
    label: "Nicotine",
    render: (row) =>
      row?.salesOrderItemNicotine || row?.purchaseOrderItemNicotine || "",
  },
    {
    id: "sugar",
    numeric: true,
    disablePadding: true,
    label: "Sugar",
    render: (row) =>
      row?.salesOrderItemSugar || row?.purchaseOrderItemSugar || "",
  },
  {
    id: "dateOfLoadingRemark",
    disablePadding: true,
    label: "Date Of Loading",
    render: (row) => row?.dateOfLoadingRemark || "",
  },
  {
    id: "warehouse",
    disablePadding: true,
    label: "Warehouse",
    render: (row) => row?.warehouse || "",
  },
  {
    id: "destination",
    disablePadding: true,
    label: "Destination",
    render: (row) => row?.destination || "",
  },
  {
    id: "pointOfLoading",
    disablePadding: true,
    label: "POL",
    render: (row) => row?.pointOfLoading || "",
  },
  {
    id: "pointOfUnloading",
    disablePadding: true,
    label: "POD",
    render: (row) => row?.pointOfUnloading || "",
  },
  {
    id: "freightOfferId",
    disablePadding: true,
    label: "Freight Offer",
    render: (row, rowIndex, { setEditFreightOffer }) => (
      <FreightOfferButton
        row={row}
        id={row?.freightOfferId || ""}
        setEditFreightOffer={setEditFreightOffer}
      />
    ),
  },
  {
    id: "transportationContact",
    disablePadding: true,
    label: "Contact Details For Transportation",
    render: (row) => row?.transportationContact || "",
  },
  {
    id: "freightRemark",
    disablePadding: true,
    label: "Freight Offer Remark",
    render: (row) => row?.freightRemark || "",
  },
  {
    id: "shipmentRequestNumberOfCases",
    numeric: true,
    disablePadding: true,
    label: "Number Of Cartons",
    render: (row) => row?.shipmentRequestNumberOfCases || "",
  },
  {
    id: "shipmentRequestNetWeightPerCase",
    numeric: true,
    disablePadding: true,
    label: "Net Weight",
    render: (row) => row?.shipmentRequestNetWeightPerCase || "",
  },
  {
    id: "cartonNumber",
    disablePadding: true,
    label: "Case Numbers",
    render: (row) => row?.cartonNumber || "",
  },
  {
    id: "shippedBy",
    numeric: false,
    disablePadding: true,
    label: "To Be Shipped By",
    render: (row) => row?.shippedBy || "",
  },
  {
    id: "shipperName",
    disablePadding: true,
    label: "Shipper",
    render: (row) => row?.shipperName || "",
  },
  {
    id: "toBeShippedBy20",
    disablePadding: true,
    label: "20",
    render: (row) => row?.toBeShippedBy20 || "",
  },
  {
    id: "toBeShippedBy40",
    disablePadding: true,
    label: "40",
    render: (row) => row?.toBeShippedBy40 || "",
  },
  {
    id: "toBeShippedBy40HC",
    disablePadding: true,
    label: "40HC",
    render: (row) => row?.toBeShippedBy40HC || "",
  },
  {
    id: "toBeShippedByFtl",
    disablePadding: true,
    label: "FTL",
    render: (row) => row?.toBeShippedByFtl || "",
  },
  {
    id: "billOfLadingNumber",
    disablePadding: true,
    label: "Bill Of Lading Number",
    render: (row) => row?.billOfLadingNumber || "",
  },
  {
    id: "billOfLadingDate",
    disablePadding: true,
    label: "Bill Of Lading Date",
    render: (row) =>
      row?.billOfLadingDate ? format(new Date(row.billOfLadingDate), "dd/MM/yyyy") : "",
  },
  {
    id: "cmrNumber",
    disablePadding: true,
    label: "CMR Number",
    render: (row) => row?.cmrNumber || "",
  },
  {
    id: "cmrDate",
    disablePadding: true,
    label: "CMR Date",
    render: (row) =>
      row?.cmrDate ? format(new Date(row.cmrDate), "dd/MM/yyyy") : "",
  },
  {
    id: "estimatedTimeOfDeparture",
    disablePadding: true,
    label: "ETD",
    render: (row, rowIndex, extra) => (
      <Box
        onClick={(e) => { e.stopPropagation(); extra.handleDepartureCellClick(); }}
        sx={{ cursor: "pointer", color: "blue", textDecoration: "underline" }}
      >
        {row?.thirdEstimatedTimeOfDeparture ?
          format(new Date(row.thirdEstimatedTimeOfDeparture), "dd/MM/yyyy") :
          row?.secondEstimatedTimeOfDeparture ?
            format(new Date(row.secondEstimatedTimeOfDeparture), "dd/MM/yyyy") :
            row?.estimatedTimeOfDeparture ?
              format(new Date(row.estimatedTimeOfDeparture), "dd/MM/yyyy") :
              ""}
        {extra.isAdditionalDepartureTimesVisible && (
          <Box>
            {row?.secondEstimatedTimeOfDeparture && (
              <div>{`2nd Update: ${format(new Date(row.secondEstimatedTimeOfDeparture), "dd/MM/yyyy")}`}</div>
            )}
            {row?.estimatedTimeOfDeparture && (
              <div>{`1st Update: ${format(new Date(row.estimatedTimeOfDeparture), "dd/MM/yyyy")}`}</div>
            )}
          </Box>
        )}
      </Box>
    ),
  },
  {
    id: "estimatedTimeOfArrival",
    disablePadding: true,
    label: "ETA",
    render: (row, rowIndex, extra) => (
      <Box
        onClick={(e) => { e.stopPropagation(); extra.handleDepartureCellClick(); }}
        sx={{ cursor: "pointer", color: "blue", textDecoration: "underline" }}
      >
        {row?.thirdEstimatedTimeOfArrival ?
          format(new Date(row.thirdEstimatedTimeOfArrival), "dd/MM/yyyy") :
          row?.secondEstimatedTimeOfArrival ?
            format(new Date(row.secondEstimatedTimeOfArrival), "dd/MM/yyyy") :
            row?.estimatedTimeOfArrival ?
              format(new Date(row.estimatedTimeOfArrival), "dd/MM/yyyy") :
              ""}
        {extra.isAdditionalDepartureTimesVisible && (
          <Box>
            {row?.secondEstimatedTimeOfArrival && (
              <div>{`2nd Update: ${format(new Date(row.secondEstimatedTimeOfArrival), "dd/MM/yyyy")}`}</div>
            )}
            {row?.estimatedTimeOfArrival && (
              <div>{`1st Update: ${format(new Date(row.estimatedTimeOfArrival), "dd/MM/yyyy")}`}</div>
            )}
          </Box>
        )}
      </Box>
    ),
  },
  {
    id: "actualTimeOfArrival",
    disablePadding: true,
    label: "ATA",
    render: (row) => row?.actualTimeOfArrival ? format(new Date(row.actualTimeOfArrival), "dd/MM/yyyy") : "",
  },
  {
    id: "consigneeName",
    disablePadding: true,
    label: "Consignee",
   render: (row) => (
  row?.consigneeName?.length > 15 ? (
    <Tooltip title={row?.consigneeName} arrow placement="top">
      <span
        style={{
          display: "inline-block",
          maxWidth: "150px",
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
          verticalAlign: "top",
        }}
      >
        {row?.consigneeName}
      </span>
    </Tooltip>
  ) : (
    row?.consigneeName
  )
),
  },
  {
    id: "notifyName",
    disablePadding: true,
    label: "Notify Party(ies)",
   render: (row) => (
  row?.notifyName?.length > 15 ? (
    <Tooltip title={row?.notifyName} arrow placement="top">
      <span
        style={{
          display: "inline-block",
          maxWidth: "150px",
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
          verticalAlign: "top",
        }}
      >
        {row?.notifyName}
      </span>
    </Tooltip>
  ) : (
    row?.notifyName
  )
),
  },
  {
    id: "description",
    disablePadding: true,
    label: "Description",
    render: (row) => row?.description,
  },
  {
    id: "revision",
    numeric: false,
    disablePadding: false,
    label: "Revision",
    render: (row) => row?.revision,
  },
  {
    id: "remark",
    numeric: false,
    disablePadding: false,
    label: "Remark",
    render: (row) => row?.remark,
  },
  {
    id: "link",
    numeric: false,
    disablePadding: false,
    label: "SI Link",
    render: (row) =>
      row?.link ? (
        <a href={row.link} target="_blank" rel="noreferrer">
          <Button variant="outlined" size="small">SI Link</Button>
        </a>
      ) : (
        ""
      ),
  },
  {
    id: "containsHardCopy",
    numeric: false,
    disablePadding: true,
    label: "Hard Copy",
    render: (row) =>
      row?.containsHardCopy ? (
        <Tooltip title="Contains hard copy" arrow>
          <CheckCircleIcon sx={{ color: "#2e7d32" }} />
        </Tooltip>
      ) : (
        <Tooltip title="No hard copy" arrow>
          <CancelOutlinedIcon sx={{ color: "#9e9e9e" }} />
        </Tooltip>
      ),
  },
  {
    id: "shipmentRequestreferenceShippingInstructionId",
    numeric: false,
    disablePadding: true,
    label: "Reference SI",
    render: (row) =>
      `${row?.shipmentRequestreferenceShippingInstructionId || ""}-${row?.shipmentRequestreferenceShippingInstructionNumber || ""}`,
  },
  {
    id: "status",
    numeric: false,
    disablePadding: false,
    label: "Status",
    render: (row) => row?.status,
  },
  {
    id: "timestamp",
    numeric: false,
    disablePadding: true,
    label: "Creation Time",
    render: (row) => row?.timestamp ? format(new Date(row.timestamp), "dd/MM/yyyy HH:mm") : "",
  },
  {
    id: "creator",
    numeric: false,
    disablePadding: true,
    label: "Created By",
    render: (row) => row?.creator,
  },
  {
    id: "recordStatus",
    numeric: false,
    disablePadding: false,
    label: "Record Status",
    render: (row) => row?.recordStatus,
  },
];

function EnhancedTableHead(props) {
  const {
    onSelectAllClick,
    order,
    orderBy,
    numSelected,
    rowCount,
    onRequestSort,
    visibleColumns,
  } = props;

  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        <TableCell padding="checkbox">
          <Checkbox
            color="primary"
            indeterminate={numSelected > 0 && numSelected < rowCount}
            checked={rowCount > 0 && numSelected === rowCount}
            onChange={onSelectAllClick}
            inputProps={{
              "aria-label": "select all",
            }}
          />
        </TableCell>
        {headCells
          .filter(headCell => visibleColumns.includes(headCell.id))
          .sort((a, b) => visibleColumns.indexOf(a.id) - visibleColumns.indexOf(b.id))
          .map(headCell => (
            <TableCell
              key={headCell.id}
              align={"center"}
              padding={headCell.disablePadding ? "none" : "normal"}
              sortDirection={orderBy === headCell.id ? order : false}
              sx={
                headCell.id === "id"
                  ? {
                    position: "sticky",
                    left: 0,
                    zIndex: 3,
                  }
                  : headCell.id === "finalShippingInstructionNumber"
                    ? {
                      position: "sticky",
                      left: 50,
                      zIndex: 3,
                    }
                    : null
              }
            >
              <TableSortLabel
                active={orderBy === headCell.id}
                direction={orderBy === headCell.id ? order : "asc"}
                onClick={createSortHandler(headCell.id)}
              >
                {headCell.label}
                {orderBy === headCell.id ? (
                  <Box component="span" sx={visuallyHidden}>
                    {order === "desc" ? "sorted descending" : "sorted ascending"}
                  </Box>
                ) : null}
              </TableSortLabel>
            </TableCell>
          ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.oneOf(["asc", "desc"]).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

function ShippingInstructionTable({
  visibleRows,
  dense,
  isSelected,
  handleClick,
  emptyRows,
  visibleColumns,
  onSelectAllClick,
  order,
  orderBy,
  numSelected,
  rowCount,
  onRequestSort,
  // extra functions for custom cell renders
  setEditShippingInstruction,
  retrieveShippingInstructionByIdApi,
  setInvoiceData,
  setCloseDialogOpen,
  setUploadDialogOpen,
  cancelShippingInstruction,
  loadingRecord,
  setEditItem,
  setEditShipmentRequest,
  setEditFreightOffer,
  setEditVendorOrder,
  setEditCustomerOrder,
  handleDepartureCellClick,
  isAdditionalDepartureTimesVisible,
  handleToggleAllocations,
  batchCountMap,
  // allocation details are now shown in a dialog from parent
}) {
  const activeHeadCells = headCells
    .filter((cell) => visibleColumns.includes(cell.id))
    .sort((a, b) => visibleColumns.indexOf(a.id) - visibleColumns.indexOf(b.id));

  return (
    <TableContainer style={{ maxHeight: 700 }}>
      <Table
        stickyHeader
        aria-label="sticky table"
        sx={{
          minWidth: 750,
          "& .MuiTableCell-root": {
            borderRight: "1px solid rgba(224, 224, 224, 1)",
          },
          "& .MuiTableCell-head": {
            backgroundColor: "#20315d",
            color: "white",
            borderRight: "1px solid rgba(49, 64, 128, 1)",
          },
        }}
        aria-labelledby="tableTitle"
        size={dense ? "small" : "medium"}
        style={{ width: "max-content" }}>
        <EnhancedTableHead
          numSelected={numSelected}
          order={order}
          orderBy={orderBy}
          onSelectAllClick={onSelectAllClick}
          onRequestSort={onRequestSort}
          rowCount={rowCount}
          visibleColumns={visibleColumns}
        />
        <TableBody>
          {visibleRows.map((row, rowIndex) => {
            const isItemSelected = isSelected(row.id);
            const labelId = `enhanced-table-checkbox-${rowIndex}`;
            return (
              <React.Fragment key={row.id}>
                <TableRow
                  hover
                  onClick={(e) => handleClick(e, row.id, row)}
                  role="checkbox"
                  aria-checked={isItemSelected}
                  tabIndex={-1}
                  selected={isItemSelected}
                  style={
                    isItemSelected
                      ? { background: "#d7e7fc" }
                      : row?.status === "Closed"
                        ? { background: "#c8e6c9" }
                        : rowIndex % 2
                          ? { background: "#f0f0f0" }
                          : { background: "white" }
                  }
                  sx={{
                    cursor: "pointer",
                  }}
                >
                  <TableCell padding="checkbox" id="checkbox-cell">
                    <Checkbox color="primary" checked={isItemSelected} inputProps={{ "aria-labelledby": labelId }} />
                  </TableCell>
                  {activeHeadCells.map((cell) => (
                    <TableCell
                      key={cell.id}
                      align="center"
                      sx={cell.sx || {}}
                      id={`tableCell_${cell.id}`}>
                      {typeof cell.render === "function"
                        ? cell.render(row, rowIndex, {
                          setEditShippingInstruction,
                          retrieveShippingInstructionByIdApi,
                          setInvoiceData,
                          setCloseDialogOpen,
                          setUploadDialogOpen,
                          cancelShippingInstruction,
                          loadingRecord,
                          setEditItem,
                          setEditShipmentRequest,
                          setEditFreightOffer,
                          setEditVendorOrder,
                          setEditCustomerOrder,
                          handleDepartureCellClick,
                          isAdditionalDepartureTimesVisible,
                          handleToggleAllocations,
                          batchCountMap,
                        })
                        : row[cell.id] || ""}
                    </TableCell>
                  ))}
                </TableRow>
              </React.Fragment>
            );
          })}
          {emptyRows > 0 && (
            <TableRow style={{ height: (dense ? 33 : 53) * emptyRows }}>
              <TableCell colSpan={activeHeadCells.length + 1} />
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

ShippingInstructionTable.propTypes = {
  visibleRows: PropTypes.array.isRequired,
  dense: PropTypes.bool.isRequired,
  isSelected: PropTypes.func.isRequired,
  handleClick: PropTypes.func.isRequired,
  emptyRows: PropTypes.number.isRequired,
  visibleColumns: PropTypes.array.isRequired,
  setEditShippingInstruction: PropTypes.func.isRequired,
  retrieveShippingInstructionByIdApi: PropTypes.func.isRequired,
  setInvoiceData: PropTypes.func.isRequired,
  setCloseDialogOpen: PropTypes.func.isRequired,
  setUploadDialogOpen: PropTypes.func.isRequired,
  cancelShippingInstruction: PropTypes.func.isRequired,
  loadingRecord: PropTypes.any,
  setEditItem: PropTypes.func.isRequired,
  setEditShipmentRequest: PropTypes.func.isRequired,
  setEditFreightOffer: PropTypes.func.isRequired,
  setEditVendorOrder: PropTypes.func.isRequired,
  setEditCustomerOrder: PropTypes.func.isRequired,
  handleDepartureCellClick: PropTypes.func.isRequired,
  isAdditionalDepartureTimesVisible: PropTypes.bool.isRequired,
  handleToggleAllocations: PropTypes.func.isRequired,
  batchCountMap: PropTypes.object,
};

function EnhancedTableToolbar(props) {
  const {
    numSelected,
    showFilters,
    setShowFilters,
    setAddView,
    setExportSIPopup,
    setExportShippingDetailsPopup,
    setExportProformaDetailsPopup,
    selected,
    selectedData,
    visibleColumns,
    setVisibleColumns,
    selectedColumns,
    setSelectedColumns,
    selectColumnsDialogOpen,
    setSelectColumnsDialogOpen,
    columnsOrder,
    setColumnsOrder,
    filterShippingInstruction,
    setFilterShippingInstruction,
    rows,
    setRows,
  } = props;

  const headerMapping = {
    "Databox ID": "id",
    "SI Type": "shipmentRequestType",
    "Shipment Quantity": (row) =>
      row?.shipmentQuantity
        ? {
          v: Number(row.shipmentQuantity),
          t: 'n',
          z: '#,##0.00'
        }
        : "",
    "Storage Quantity": (row) =>
      row?.shipmentRequestStorageQuantity
        ? {
          v: Number(row.shipmentRequestStorageQuantity),
          t: 'n',
          z: '#,##0.00'
        }
        : "",
    "SI Number": "finalShippingInstructionNumber",
    "SI Date": (row) => {
      const date = row?.shippingInstructionDate;
      return date ? format(new Date(date), "dd/MMM/yyyy") : "";
    },
    "SI To": "shipmentRequestTo",
    "PO ID": "purchaseOrderId",
    "PO Company": "purchaseOrderCompany",
    "PO Status": "purchaseOrderStatus",
    "SAP PO Number": "purchaseOrderNumber",
    "PO Incoterm": "purchaseOrderIncoterm",
    "SO ID": "salesOrderId",
    "SO Company": "salesOrderCompany",
    "SO Status": "salesOrderStatus",
    "SAP SO Number": "salesOrderNumber",
    "SO Incoterm": "salesOrderIncoterm",
    "Customer": "customer",
    "Item ID": (row) => row?.salesOrderItemId || row?.purchaseOrderItemId || "",
    "Supplier Grade Mark": (row) =>
      row?.salesOrderItemBuyingGrade || row?.purchaseOrderItemBuyingGrade || "",
    "Customer Grade Mark": "shipmentRequestCustomerGradeMark",
    "Origin": (row) =>
      row?.salesOrderItemOrigin || row?.purchaseOrderItemOrigin || "",
    "Type": (row) => row?.salesOrderItemType || row?.purchaseOrderItemType || "",
    "Crop": (row) => row?.salesOrderItemCrop || row?.purchaseOrderItemCrop || "",
    "Nicotine": (row) => row?.salesOrderItemNicotine || row?.purchaseOrderItemNicotine || "",
    "Sugar": (row) => row?.salesOrderItemSugar || row?.purchaseOrderItemSugar || "",
    "Date Of Loading": "dateOfLoadingRemark",
    "Warehouse": "warehouse",
    "Destination": "destination",
    "Point Of Loading": "pointOfLoading",
    "Point Of Unloading": "pointOfUnloading",
    "Freight Offer": "freightOfferId",
    "Transportation Contact": "transportationContact",
    "Freight Remark": "freightRemark",
    "Number Of Cases": "shipmentRequestNumberOfCases",
    "Net Weight Per Case": "shipmentRequestNetWeightPerCase",
    "Case Numbers": "cartonNumber",
    "To Be Shipped By": "shippedBy",
    "Shipper": "shipperName",
    "20-": "toBeShippedBy20",
    "40-": "toBeShippedBy40",
    "40HC": "toBeShippedBy40HC",
    "FTL": "toBeShippedByFtl",
    "BL Number": "billOfLadingNumber",
    "BL Date": (row) => {
      const date = row?.billOfLadingDate;
      return date ? format(new Date(date), "dd/MMM/yyyy") : "";
    },
    "CMR Number": "cmrNumber",
    "CMR Date": (row) => {
      const date = row?.cmrDate;
      return date ? format(new Date(date), "dd/MMM/yyyy") : "";
    },
    "Final ETD": (row) => {
      const date = row?.thirdEstimatedTimeOfDeparture ||
        row?.secondEstimatedTimeOfDeparture ||
        row?.estimatedTimeOfDeparture;
      return date ? format(new Date(date), "dd/MMM/yyyy") : "";
    },
    "Final ETA": (row) => {
      const date = row?.thirdEstimatedTimeOfArrival ||
        row?.secondEstimatedTimeOfArrival ||
        row?.estimatedTimeOfArrival;
      return date ? format(new Date(date), "dd/MMM/yyyy") : "";
    },
    "ATA": (row) => {
      const date = row?.actualTimeOfArrival;
      return date ? format(new Date(date), "dd/MMM/yyyy") : "";
    },
    "Consignee": "consigneeName",
    "Notify Party(ies)": "notifyName",
    "Description": "description",
    "Revision": "revision",
    "Remark": "remark",
    "Reference SI": (row) =>
      `${row?.shipmentRequestreferenceShippingInstructionId || ""}-${row?.shipmentRequestreferenceShippingInstructionNumber || ""
      }`,
    "Status": "status",
    "Timestamp": (row) => {
      const date = row?.timestamp;
      return date ? format(new Date(date), "dd/MMM/yyyy HH:mm") : "";
    },
    "Creator": "creator",
    "AR Number": "accountsReceivableNumber",
    "AP Number": "supplierInvoiceNumber",
    "Weight List Link": "weightListLink",
    "Goods Receipt Number": "goodsReceiptNumber",
    "Landed Cost Number": "landedCostNumber",
    "Delivery Number": "deliveryNumber",
    "Insurance Number": "insuranceNumber",
    "Sale Price": (row) =>
      row?.salesOrderFinalPrice
        ? {
          v: Number(row.salesOrderFinalPrice),
          t: 'n',
          z: '#,##0.0000'
        }
        : "",
    "Total Sale Price": (row) =>
      row?.salesOrderFinalPrice
        ? {
          v: Number(row.salesOrderFinalPrice ? row.shipmentQuantity ? (row.salesOrderFinalPrice * row.shipmentQuantity) : row.salesOrderFinalPrice : 0),
          t: 'n',
          z: '#,##0.0000'
        }
        : "",
    "Sale Price Currency": "salesOrderFinalPriceCurrency",
    "Sale Price USD": (row) =>
      row?.salesOrderUsdFinalPrice
        ? {
          v: Number(row.salesOrderUsdFinalPrice),
          t: 'n',
          z: '#,##0.0000'
        }
        : "",
    "Total Sale Price USD": (row) =>
      row?.salesOrderUsdFinalPrice
        ? {
          v: Number(row.salesOrderUsdFinalPrice ? row.shipmentQuantity ? (row.salesOrderUsdFinalPrice * row.shipmentQuantity) : row.salesOrderUsdFinalPrice : 0),
          t: 'n',
          z: '#,##0.0000'
        }
        : "",
    "Actual Buying Price": (row) =>
      row?.actualBuyingPrice
        ? {
          v: Number(row.actualBuyingPrice),
          t: 'n',
          z: '#,##0.0000'
        }
        : "",
    "Total Actual Buying Price": (row) =>
      row?.actualBuyingPrice
        ? {
          v: Number(row.actualBuyingPrice ? row.shipmentQuantity ? (row.actualBuyingPrice * row.shipmentQuantity) : row.actualBuyingPrice : 0),
          t: 'n',
          z: '#,##0.0000'
        }
        : "",
    "Actual Buying Price Currency": "actualBuyingPriceCurrency",
    "Actual Buying Price USD": (row) =>
      row?.actualBuyingPriceUsd
        ? {
          v: Number(row.actualBuyingPriceUsd),
          t: 'n',
          z: '#,##0.0000'
        }
        : "",
    "Total Actual Buying Price USD": (row) =>
      row?.actualBuyingPriceUsd
        ? {
          v: Number(row.actualBuyingPriceUsd ? row.shipmentQuantity ? (row.actualBuyingPriceUsd * row.shipmentQuantity) : row.actualBuyingPriceUsd : 0),
          t: 'n',
          z: '#,##0.0000'
        }
        : "",
    "Actual Buying Price Date": (row) => {
      const date = row?.actualBuyingPriceDate;
      return date ? format(new Date(date), "dd/MMM/yyyy") : "";
    },
    "Insurance Number": "insuranceNumber",
    "Insurance Cost": (row) =>
      row?.actualInsuranceCost
        ? {
          v: Number(row.actualInsuranceCost),
          t: 'n',
          z: '#,##0.0000'
        }
        : "",
    "Total Insurance Cost": (row) =>
      row?.actualInsuranceCost
        ? {
          v: Number(row.actualInsuranceCost ? row.shipmentQuantity ? (row.actualInsuranceCost * row.shipmentQuantity) : row.actualInsuranceCost : 0),
          t: 'n',
          z: '#,##0.0000'
        }
        : "",
    "Insurance Currency": "actualInsuranceCurrency",
    "Insurance Cost USD": (row) =>
      row?.actualInsuranceCostUsd
        ? {
          v: Number(row.actualInsuranceCostUsd),
          t: 'n',
          z: '#,##0.0000'
        }
        : "",
    "Total Insurance Cost USD": (row) =>
      row?.actualInsuranceCostUsd
        ? {
          v: Number(row.actualInsuranceCostUsd ? row.shipmentQuantity ? (row.actualInsuranceCostUsd * row.shipmentQuantity) : row.actualInsuranceCostUsd : 0),
          t: 'n',
          z: '#,##0.0000'
        }
        : "",
    "Insurance Date": (row) => {
      const date = row?.actualTimeOfInsurance;
      return date ? format(new Date(date), "dd/MMM/yyyy") : "";
    },
    "Freight Number": "freightNumber",
    "Actual Freight Cost": (row) =>
      row?.actualFreightPrice
        ? {
          v: Number(row.actualFreightPrice),
          t: 'n',
          z: '#,##0.0000'
        }
        : "",
    "Total Actual Freight Cost": (row) =>
      row?.actualFreightPrice
        ? {
          v: Number(row.actualFreightPrice ? row.shipmentQuantity ? (row.actualFreightPrice * row.shipmentQuantity) : row.actualFreightPrice : 0),
          t: 'n',
          z: '#,##0.0000'
        }
        : "",
    "Actual Freight Currency": "actualFreightCurrency",
    "Actual Freight Cost USD": (row) =>
      row?.actualFreightPriceUsd
        ? {
          v: Number(row.actualFreightPriceUsd),
          t: 'n',
          z: '#,##0.0000'
        }
        : "",
    "Total Actual Freight Cost USD": (row) =>
      row?.actualFreightPriceUsd
        ? {
          v: Number(row.actualFreightPriceUsd ? row.shipmentQuantity ? (row.actualFreightPriceUsd * row.shipmentQuantity) : row.actualFreightPriceUsd : 0),
          t: 'n',
          z: '#,##0.0000'
        }
        : "",
    "Actual Freight Date": (row) => {
      const date = row?.actualTimeOfFreight;
      return date ? format(new Date(date), "dd/MMM/yyyy") : "";
    },
    "Second Freight Cost": (row) =>
      row?.secondFreightCost
        ? {
          v: Number(row.secondFreightCost),
          t: 'n',
          z: '#,##0.0000'
        }
        : "",
    "Total Second Freight Cost": (row) =>
      row?.secondFreightCost
        ? {
          v: Number(row.secondFreightCost ? row.shipmentQuantity ? (row.secondFreightCost * row.shipmentQuantity) : row.secondFreightCost : 0),
          t: 'n',
          z: '#,##0.0000'
        }
        : "",
    "Second Freight Currency": "secondFreightCostCurrency",
    "Second Freight Cost USD": (row) =>
      row?.secondFreightCostUsd
        ? {
          v: Number(row.secondFreightCostUsd),
          t: 'n',
          z: '#,##0.0000'
        }
        : "",
    "Total Second Freight Cost USD": (row) =>
      row?.secondFreightCostUsd
        ? {
          v: Number(row.secondFreightCostUsd ? row.shipmentQuantity ? (row.secondFreightCostUsd * row.shipmentQuantity) : row.secondFreightCostUsd : 0),
          t: 'n',
          z: '#,##0.0000'
        }
        : "",
    "Second Freight Date": (row) => {
      const date = row?.secondFreightDate;
      return date ? format(new Date(date), "dd/MMM/yyyy") : "";
    },
    "Import Export Expense": (row) =>
      row?.importExportExpense
        ? {
          v: Number(row.importExportExpense),
          t: 'n',
          z: '#,##0.0000'
        }
        : "",
    "Total Import Export Expenses": (row) =>
      row?.importExportExpense
        ? {
          v: Number(row.importExportExpense ? row.shipmentQuantity ? (row.importExportExpense * row.shipmentQuantity) : row.importExportExpense : 0),
          t: 'n',
          z: '#,##0.0000'
        }
        : "",
    "Import Export Expense Currency": "importExportExpenseCurrency",
    "Import Export Expense USD": (row) =>
      row?.importExportExpenseUsd
        ? {
          v: Number(row.importExportExpenseUsd),
          t: 'n',
          z: '#,##0.0000'
        }
        : "",
    "Total Import Export Expenses USD": (row) =>
      row?.importExportExpenseUsd
        ? {
          v: Number(row.importExportExpenseUsd ? row.shipmentQuantity ? (row.importExportExpenseUsd * row.shipmentQuantity) : row.importExportExpenseUsd : 0),
          t: 'n',
          z: '#,##0.0000'
        }
        : "",
    "Import Export Expense Date": (row) => {
      const date = row?.importExportExpenseDate;
      return date ? format(new Date(date), "dd/MMM/yyyy") : "";
    },
    "Demurrage": (row) =>
      row?.demurrage
        ? {
          v: Number(row.demurrage),
          t: 'n',
          z: '#,##0.0000'
        }
        : "",
    "Total Demurrage": (row) =>
      row?.demurrage
        ? {
          v: Number(row.demurrage ? row.shipmentQuantity ? (row.demurrage * row.shipmentQuantity) : row.demurrage : 0),
          t: 'n',
          z: '#,##0.0000'
        }
        : "",
    "Demurrage Currency": "demurrageCurrency",
    "Demurrage USD": (row) =>
      row?.demurrageUsd
        ? {
          v: Number(row.demurrageUsd),
          t: 'n',
          z: '#,##0.0000'
        }
        : "",
    "Total Demurrage USD": (row) =>
      row?.demurrageUsd
        ? {
          v: Number(row.demurrageUsd ? row.shipmentQuantity ? (row.demurrageUsd * row.shipmentQuantity) : row.demurrageUsd : 0),
          t: 'n',
          z: '#,##0.0000'
        }
        : "",
    "Demurrage Date": (row) => {
      const date = row?.demurrageDate;
      return date ? format(new Date(date), "dd/MMM/yyyy") : "";
    },
    "Fumigation": (row) =>
      row?.fumigation
        ? {
          v: Number(row.fumigation),
          t: 'n',
          z: '#,##0.0000'
        }
        : "",
    "Total Fumigation": (row) =>
      row?.fumigation
        ? {
          v: Number(row.fumigation ? row.shipmentQuantity ? (row.fumigation * row.shipmentQuantity) : row.fumigation : 0),
          t: 'n',
          z: '#,##0.0000'
        }
        : "",
    "Fumigation Currency": "fumigationCurrency",
    "Fumigation USD": (row) =>
      row?.fumigationUsd
        ? {
          v: Number(row.fumigationUsd),
          t: 'n',
          z: '#,##0.0000'
        }
        : "",
    "Total Fumigation USD": (row) =>
      row?.fumigationUsd
        ? {
          v: Number(row.fumigationUsd ? row.shipmentQuantity ? (row.fumigationUsd * row.shipmentQuantity) : row.fumigationUsd : 0),
          t: 'n',
          z: '#,##0.0000'
        }
        : "",
    "Fumigation Date": (row) => {
      const date = row?.fumigationDate;
      return date ? format(new Date(date), "dd/MMM/yyyy") : "";
    },
    "Handling": (row) =>
      row?.handling
        ? {
          v: Number(row.handling),
          t: 'n',
          z: '#,##0.0000'
        }
        : "",
    "Total Handling": (row) =>
      row?.handling
        ? {
          v: Number(row.handling ? row.shipmentQuantity ? (row.handling * row.shipmentQuantity) : row.handling : 0),
          t: 'n',
          z: '#,##0.0000'
        }
        : "",
    "Handling Currency": "handlingCurrency",
    "Handling USD": (row) =>
      row?.handlingUsd
        ? {
          v: Number(row.handlingUsd),
          t: 'n',
          z: '#,##0.0000'
        }
        : "",
    "Total Handling USD": (row) =>
      row?.handlingUsd
        ? {
          v: Number(row.handlingUsd ? row.shipmentQuantity ? (row.handlingUsd * row.shipmentQuantity) : row.handlingUsd : 0),
          t: 'n',
          z: '#,##0.0000'
        }
        : "",
    "Handling Date": (row) => {
      const date = row?.handlingDate;
      return date ? format(new Date(date), "dd/MMM/yyyy") : "";
    },
    "Debit Note": (row) =>
      row?.debitNote
        ? {
          v: Number(row.debitNote),
          t: 'n',
          z: '#,##0.0000'
        }
        : "",
    "Total Debit Note": (row) =>
      row?.debitNote
        ? {
          v: Number(row.debitNote ? row.shipmentQuantity ? (row.debitNote * row.shipmentQuantity) : row.debitNote : 0),
          t: 'n',
          z: '#,##0.0000'
        }
        : "",
    "Debit Note Currency": "debitNoteCurrency",
    "Debit Note USD": (row) =>
      row?.debitNoteUsd
        ? {
          v: Number(row.debitNoteUsd),
          t: 'n',
          z: '#,##0.0000'
        }
        : "",
    "Total Debit Note USD": (row) =>
      row?.debitNoteUsd
        ? {
          v: Number(row.debitNoteUsd ? row.shipmentQuantity ? (row.debitNoteUsd * row.shipmentQuantity) : row.debitNoteUsd : 0),
          t: 'n',
          z: '#,##0.0000'
        }
        : "",
    "Debit Note Date": (row) => {
      const date = row?.debitNoteDate;
      return date ? format(new Date(date), "dd/MMM/yyyy") : "";
    },
    "Credit Note": (row) =>
      row?.creditNote
        ? {
          v: Number(row.creditNote),
          t: 'n',
          z: '#,##0.0000'
        }
        : "",
    "Total Credit Note": (row) =>
      row?.creditNote
        ? {
          v: Number(row.creditNote ? row.shipmentQuantity ? (row.creditNote * row.shipmentQuantity) : row.creditNote : 0),
          t: 'n',
          z: '#,##0.0000'
        }
        : "",
    "Credit Note Currency": "creditNoteCurrency",
    "Credit Note USD": (row) =>
      row?.creditNoteUsd
        ? {
          v: Number(row.creditNoteUsd),
          t: 'n',
          z: '#,##0.0000'
        }
        : "",
    "Total Credit Note USD": (row) =>
      row?.creditNoteUsd
        ? {
          v: Number(row.creditNoteUsd ? row.shipmentQuantity ? (row.creditNoteUsd * row.shipmentQuantity) : row.creditNoteUsd : 0),
          t: 'n',
          z: '#,##0.0000'
        }
        : "",
    "Credit Note Date": (row) => {
      const date = row?.creditNoteDate;
      return date ? format(new Date(date), "dd/MMM/yyyy") : "";
    },
    "Debit Note Type": "debitNoteType",
    "Debit Note Remark": "debitNoteRemark",
    "Credit Note Type": "creditNoteType",
    "Credit Note Remark": "creditNoteRemark",

  };

  const [manageExportOpen, setManageExportOpen] = useState(false);
  const [exportColumns, setExportColumns] = useState(Object.keys(headerMapping));
  const [exportColumnsOrder, setExportColumnsOrder] = useState(Object.keys(headerMapping));

  const [customColumns, setCustomColumns] = useState([]);
  const [newColumnName, setNewColumnName] = useState('');
  const [showAddColumnInput, setShowAddColumnInput] = useState(false);

  const [anchorEl, setAnchorEl] = useState(null);
  const [reports, setReports] = useState([]);
  const [selectedReport, setSelectedReport] = useState('');
  const [showNewReportInput, setShowNewReportInput] = useState(false);
  const [newReportName, setNewReportName] = useState('');
  const open = Boolean(anchorEl);
  const { user, loading } = useAuth();

  // Simple batch creation state (for quick testing)
  const [createAnchorEl, setCreateAnchorEl] = useState(null);
  const openCreate = Boolean(createAnchorEl);
  const handleCreateClick = (e) => setCreateAnchorEl(e.currentTarget);
  const handleCreateClose = () => setCreateAnchorEl(null);

  const handleCreateAction = async (type) => {
    if (!selected) {
      alert("Please refresh the page.");
      handleCreateClose();
      return;
    }
    try {
      const response = await retrieveSelectedShippingInstructionsByIdApi(selected);
      setTimeout(() => {
        if (type === "si") {
          setExportSIPopup({ data: response?.data, visible: true });
        } else if (type === "details") {
          setExportShippingDetailsPopup({ data: response?.data, visible: true });
        } else if (type === "proforma") {
          setExportProformaDetailsPopup({ data: response?.data, visible: true });
        }else if (type === "goodsReceipt") {
          // Directly export selected rows to formatted Excel (no popup)
          ExportGoodsReceipt(response?.data || [])
            .then(() => {
              toast.success("Goods receipt Excel exported.");
            })
            .catch((err) => {
              console.error(err);
              toast.error("Failed to export goods receipt Excel.");
            });
        }
      }, 1000);
      toast.success("Shipping instruction records retrieved successfully.");
    } catch (error) {
      toast.error("Shipping instruction records could not be retrieved.");
    } finally {
      handleCreateClose();
    }
  };

const handleExportClick = (event) => {
  setAnchorEl(event.currentTarget);
};

const handleClose = () => {
  setAnchorEl(null);
};

  const [showMyShippingInstructions, setShowMyShippingInstructions] = useState(false);
  const handleExportDragEnd = (event) => {
    const { active, over } = event;
    if (active.id !== over.id) {
      setExportColumnsOrder((items) => {
        const oldIndex = items.indexOf(active.id);
        const newIndex = items.indexOf(over.id);
        const newOrder = [...items];
        newOrder.splice(oldIndex, 1);
        newOrder.splice(newIndex, 0, active.id);
        return newOrder;
      });
    }
  };

      if (loading) {
    return <div>Loading...</div>;
  }

  if (!user) {
    return <div>Not authorized</div>;
  }
  
  const handleDragEnd = (event) => {
    const { active, over } = event;
    if (active.id !== over.id) {
      setColumnsOrder((items) => {
        const oldIndex = items.indexOf(active.id);
        const newIndex = items.indexOf(over.id);
        return arrayMove(items, oldIndex, newIndex);
      });
    }
  };

  const handleManageExportClick = async () => {
    try {
      const listResp = await retrieveUserReportsApi('ShippingInstructionExport');
      setReports(listResp?.data);            
      setSelectedReport(listResp?.data[0]?.reportName || 'default');
      const settings = await retrieveUserComponentSettingsApi('ShippingInstructionExport', listResp?.data[0]?.reportName || 'default');
      const allColumns = Object.keys(headerMapping);
      setExportColumnsOrder(allColumns);

      if (settings?.data?.visibleColumns) {
        try {
          // Try to parse the settings data
          let parsedSettings;

          if (typeof settings?.data?.visibleColumns === 'string') {
            parsedSettings = JSON.parse(settings?.data?.visibleColumns);
          } else {
            // If it's already an object, use it directly
            parsedSettings = settings?.data?.visibleColumns;
          }

          if (Array.isArray(parsedSettings)) {
            // Set the visible columns from saved settings
            setExportColumns(parsedSettings);

            // Create ordered array with visible columns first, then invisible ones
            const invisibleColumns = Object.keys(headerMapping).filter(
              col => !parsedSettings.includes(col)
            );

            setExportColumnsOrder([...parsedSettings, ...invisibleColumns]);
          } else {
            console.warn('Saved settings are not in array format:', parsedSettings);
            setExportColumns([]);
          }
        } catch (e) {
          console.warn('Failed to parse saved settings:', e);
          setExportColumns([]);
        }
      }
      setManageExportOpen(true);
    } catch (error) {
      console.error('Error loading export settings:', error);
      toast.error('Failed to load export settings');
    }
  };


  const handleToggle = (id) => {
    setSelectedColumns((prev) => {
      if (prev.includes(id)) {
        // Uncheck the item.
        return prev.filter(item => item !== id);
      } else {
        // Check the item.
        return [...prev, id];
      }
    });
  };

  function createNewExportObject(rows) {
    const newObjects = [];
    rows.forEach((row) => {
      const newObject = {};
      exportColumnsOrder
        .filter(header => exportColumns.includes(header))
        .forEach((header) => {
          const pathOrFunction = headerMapping[header];
          let value;

          if (typeof pathOrFunction === "function") {
            value = pathOrFunction(row);
          } else if (pathOrFunction) {
            const keys = pathOrFunction.split("?.");
            value = row;
            for (const key of keys) {
              if (value == null) break;
              value = value[key];
            }
          }
          newObject[header] = value ?? "";
        });
      newObjects.push(newObject);
    });
    return newObjects;
  }

 async function loadSettings(reportName) {
  try {
    const resp = await retrieveUserComponentSettingsApi(
      'ShippingInstructionExport',
      reportName
    );
    let parsed = [];
    const raw = resp?.data?.visibleColumns;
    if (typeof raw === 'string') {
      parsed = JSON.parse(raw);
    } else if (Array.isArray(raw)) {
      parsed = raw;
    }
    setExportColumns(parsed);
    const allCols = Object.keys(headerMapping);
    const invisible = allCols.filter(c => !parsed.includes(c));
    setExportColumnsOrder([...parsed, ...invisible]);
  } catch (_) {
    const allCols = Object.keys(headerMapping);
    setExportColumns(allCols);
    setExportColumnsOrder(allCols);
  }
}

const handleDeleteReport = async () => {
  if (!selectedReport) return;

  if (selectedReport==="default") {
    toast.error('Default report cannot be deleted.');
    return;
  }

  if (!window.confirm(`Are you sure you want to delete "${selectedReport}"?`)) {
    return;
  }

  // find its DB id
  const report = reports.find(r => r.reportName === selectedReport);
  if (!report) return;

  try {
    // 1) mark it PASSIVE
    await deleteUserComponentSettingsApi('ShippingInstructionExport', selectedReport);

    toast.success(`Report "${selectedReport}" deleted`);

    // 2) remove it from local list
    const updated = reports.filter(r => r.id !== report.id);
    setReports(updated);

    // 3) pick a new selectedReport (or reset)
    const next = updated.length ? updated[0].reportName : '';
    setSelectedReport(next);

    if (next) {
      // load its saved columns
      await loadSettings(next);
    } else {
      // no reports left → reset to defaults
      const all = Object.keys(headerMapping);
      setExportColumns(all);
      setExportColumnsOrder(all);
    }
  } catch (err) {
    console.error(err);
    toast.error('Failed to delete report');
  }
};

  return (
    <Toolbar
      sx={{
        pl: { sm: 2 },
        pr: { xs: 1, sm: 1 },
        ...(numSelected > 0 && {
          bgcolor: (theme) =>
            alpha(
              theme.palette.primary.main,
              theme.palette.action.activatedOpacity,
            ),
        }),
        display: "flex",
        justifyContent: "space-between",
      }}
    >

      <Stack direction="row" spacing={1} alignItems={"center"}>
        <Typography
          sx={{ fontWeight: 600, fontSize: "20px" }}
          variant="h6"
          id="tableTitle"
          component="div"
          color="#1E2685"
        >
          Shipping Instructions
        </Typography>

        <Typography></Typography>
         {numSelected > 0 && (
          <>
            <Button
              variant="outlined"
              sx={{ minWidth: "130px" }}
              style={{ whiteSpace: "nowrap", marginLeft: 20 }}
              onClick={handleCreateClick}
            >
              Create Files
            </Button>

            <Menu
              anchorEl={createAnchorEl}
              open={openCreate}
              onClose={handleCreateClose}
              MenuListProps={{ dense: true }}
            >
              <MenuItem onClick={() => handleCreateAction("si")}>Create SI File</MenuItem>
              <MenuItem onClick={() => handleCreateAction("details")}>Create Shipping Details File</MenuItem>
              <MenuItem onClick={() => handleCreateAction("proforma")}>Create Proforma Invoice</MenuItem>
              <MenuItem onClick={() => handleCreateAction("goodsReceipt")}>Create Goods Receipt File</MenuItem>
            </Menu>
          </>
        )}
        {/*{numSelected > 0 ? (
          <Typography
            sx={{ fontWeight: 200, fontSize: "16px" }}
            color="#1E2685"
            variant="subtitle1"
            component="div"
          >
            {numSelected} selected
          </Typography>
        ) : (
          <Typography></Typography>
        )}

        {numSelected > 0 && (
          <Button
            variant="outlined"
            sx={{ minWidth: "130px" }}
            style={{ whiteSpace: "nowrap", marginLeft: 20 }}
            onClick={() => {
              if (!selected) {
                alert("Please refresh the page.");
                return;
              }
              retrieveSelectedShippingInstructionsByIdApi(selected)
                .then((response) => {
                  setTimeout(() => {
                    setExportSIPopup({
                      data: response?.data,
                      visible: true,
                    });
                  }, 1000);
                  toast.success(
                    "Shipping instructrion records retrieved successfully.",
                  );
                })
                .catch((error) => {
                  toast.error(
                    "Shipping instructrion records could not be retrieved.",
                  );
                });
            }}
          >
            Create SI File
          </Button>
        )}
        {numSelected > 0 && (
          <Button
            variant="outlined"
            sx={{ minWidth: "130px" }}
            style={{ whiteSpace: "nowrap", marginLeft: 20 }}
            onClick={() => {
              if (!selected) {
                alert("Please refresh the page.");
                return;
              }
              retrieveSelectedShippingInstructionsByIdApi(selected)
                .then((response) => {
                  setTimeout(() => {
                    setExportShippingDetailsPopup({
                      data: response?.data,
                      visible: true,
                    });
                  }, 1000);
                  toast.success(
                    "Shipping instructrion records retrieved successfully.",
                  );
                })
                .catch((error) => {
                  toast.error(
                    "Shipping instructrion records could not be retrieved.",
                  );
                });
            }}
          >
            Create Shipping Details File
          </Button>
        )}
        {numSelected > 0 && (
          <Button
            variant="outlined"
            sx={{ minWidth: "130px" }}
            style={{ whiteSpace: "nowrap", marginLeft: 20 }}
            onClick={() => {
              if (!selected) {
                alert("Please refresh the page.");
                return;
              }
              retrieveSelectedShippingInstructionsByIdApi(selected)
                .then((response) => {
                  setTimeout(() => {
                    setExportProformaDetailsPopup({
                      data: response?.data,
                      visible: true,
                    });
                  }, 1000);
                  toast.success(
                    "Shipping instructrion records retrieved successfully.",
                  );
                })
                .catch((error) => {
                  toast.error(
                    "Shipping instructrion records could not be retrieved.",
                  );
                });
            }}
          >
            Create Proforma Invoice
          </Button>
        )}*/}
        <FormControlLabel
          control={
            <Switch
              checked={showMyShippingInstructions}
              onChange={(e) => {
                setShowMyShippingInstructions(e.target.checked);
                if (e.target.checked) {
                  retrieveFastFilteredShippingInstructionsApi({
                    ...filterShippingInstruction,
                    currentUser: user?.email,
                  })
                    .then((response) => {
                      setRows(response?.data);
                    })
                    .catch((error) => {
                      console.log(error?.response?.data);
                      toast.error('Failed to filter shipping instructions');
                    });
                } else {
                  retrieveFastFilteredShippingInstructionsApi({
                    ...filterShippingInstruction,
                    currentUser: null,
                  })
                    .then((response) => {
                      setRows(response?.data);
                    })
                    .catch((error) => {
                      console.log(error?.response?.data);
                      toast.error('Failed to load shipping instructions');
                    });
                }
              }}
            />
          }
          label="Show Shipping Instructions Assigned To Me"
          sx={{ ml: 2 }}
        />
      </Stack>
      <Stack spacing={1} direction="row" sx={{ mr: 2 }}>
        <Button
          disableElevation
          variant="outlined"
          size="small"
          onClick={() => setSelectColumnsDialogOpen(true)}
        >
          Select Columns
        </Button>

        <Dialog open={selectColumnsDialogOpen} onClose={() => setSelectColumnsDialogOpen(false)}>
          <DialogTitle>Select Columns</DialogTitle>
          <DialogContent>
            {/* Buttons to select/deselect all */}
            <Stack direction="row" spacing={2} mb={2}>
              <Button variant="outlined" onClick={() => setSelectedColumns([...columnsOrder])}>
                Select All
              </Button>
              <Button variant="outlined" onClick={() => setSelectedColumns([])}>
                Select None
              </Button>
              <Button
                variant="outlined"
                onClick={() => {
                  const defaultOrder = headCells.map((cell) => cell.id);
                  setColumnsOrder(defaultOrder);
                  setSelectedColumns(defaultOrder);
                }}
              >
                Reset
              </Button>
            </Stack>
            {/* Use the DndContext and SortableContext for reordering */}
            <DndContext
              collisionDetection={closestCenter}
              onDragEnd={handleDragEnd}
            >
              <SortableContext items={columnsOrder} strategy={verticalListSortingStrategy}>
                {columnsOrder.map((columnId) => {
                  // Find the headCell data (label etc.) for this column id.
                  const column = headCells.find(cell => cell.id === columnId);
                  return (
                    <SortableItem
                      key={columnId}
                      id={columnId}
                      label={column.label || column.id}
                      checked={selectedColumns.includes(columnId)}
                      onToggle={() => handleToggle(columnId)}
                    />
                  );
                })}
              </SortableContext>
            </DndContext>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setSelectColumnsDialogOpen(false)}>Cancel</Button>
            <Button
              variant="contained"
              onClick={() => {
                // Get the ordered list of selected columns according to the current columnsOrder:
                const orderedSelectedColumns = columnsOrder.filter(id => selectedColumns.includes(id));
                const visibleColumnsJson = JSON.stringify(orderedSelectedColumns);
                saveUserComponentSettingsApi("ShippingInstructionView", "default", visibleColumnsJson)
                  .then((response) => {
                    toast.success("Column settings saved successfully!");
                    // Update the state that controls which columns are rendered in the table.
                    setVisibleColumns(orderedSelectedColumns);
                    setSelectColumnsDialogOpen(false);
                  })
                  .catch((error) => {
                    toast.error("Failed to save column settings.");
                    console.error("Save settings error:", error);
                  });
              }}
            >
              Save Column Settings
            </Button>
          </DialogActions>
        </Dialog>

        <Button
          disableElevation
          variant="outlined"
          size="small"
          onClick={handleManageExportClick}
        >
          Manage Export
        </Button>

        <Dialog
          open={manageExportOpen}
          onClose={() => setManageExportOpen(false)}
          maxWidth="sm"
          fullWidth
          PaperProps={{
            sx: {
              width: '600px'  // Set a fixed width
            }
          }}
        >
          <DialogTitle>Manage Export Settings</DialogTitle>
          <DialogContent>
            <FormControl fullWidth size="small" sx={{ mb: 2, display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 1 }}>
  <Select
    value={selectedReport}
    onChange={async (e) => {
      const name = e.target.value;
      setSelectedReport(name);
      await loadSettings(name);
    }}
    sx={{ flexGrow: 1 }}
  >
    {reports?.map(r => (
     <MenuItem key={r.id} value={r.reportName}>
        {r.reportName}
      </MenuItem>
    ))}
  </Select>

  <IconButton
    size="small"
    onClick={() => setShowNewReportInput(true)}
    title="New report"
  >
    <AddIcon />
  </IconButton>
  <IconButton
    size="small"
    onClick={handleDeleteReport}
    disabled={!selectedReport}
    title="Delete report"
  >
    <DeleteIcon />
  </IconButton>
</FormControl>
{showNewReportInput && (
  <Box sx={{ mb: 2, display: 'flex', gap: 1 }}>
    <TextField
      size="small"
      value={newReportName}
      onChange={e => setNewReportName(e.target.value)}
      placeholder="New report name"
      fullWidth
    />
    <Button
      variant="contained"
      onClick={async () => {
        const name = newReportName.trim();
        if (!name) return;
        const defaultCols = Object.keys(headerMapping);
        await saveUserComponentSettingsApi('ShippingInstructionExport', name, JSON.stringify(defaultCols));
        const updated = await retrieveUserReportsApi('ShippingInstructionExport');
        setReports(updated?.data);
        setSelectedReport(name);
        await loadSettings(name);
        setNewReportName('');
        setShowNewReportInput(false);
      }}
    >
      Create
    </Button>
    <IconButton onClick={() => setShowNewReportInput(false)}>
      <CloseIcon />
    </IconButton>
  </Box>
)}
            <Stack direction="row" spacing={2} mb={2}>
              <Button
                variant="outlined"
                onClick={() => setExportColumns(Object.keys(headerMapping))}
              >
                Select All
              </Button>
              <Button
                variant="outlined"
                onClick={() => setExportColumns([])}
              >
                Select None
              </Button>
              <Button
                variant="outlined"
                onClick={() => {
                  setExportColumns(Object.keys(headerMapping));
                  setExportColumnsOrder(Object.keys(headerMapping));
                }}
              >
                Reset
              </Button>
              <Button
                variant="outlined"
                onClick={() => setShowAddColumnInput(true)}
              >
                Add Column
              </Button>
            </Stack>
            {showAddColumnInput && (
              <Box sx={{ mb: 2, display: 'flex', gap: 1 }}>
                <TextField
                  size="small"
                  value={newColumnName}
                  onChange={(e) => setNewColumnName(e.target.value)}
                  placeholder="Enter column name"
                  fullWidth
                />
                <Button
                  variant="contained"
                  onClick={() => {
                    if (newColumnName.trim()) {
                      const newColumn = newColumnName.trim().replace(/\s+/g, ' ');
                      setCustomColumns([...customColumns, { id: newColumn, label: newColumnName }]);
                      setExportColumns([...exportColumns, newColumn]);
                      setExportColumnsOrder([...exportColumnsOrder, newColumn]);
                      setNewColumnName('');
                      setShowAddColumnInput(false);
                    }
                  }}
                >
                  Add
                </Button>
                <IconButton onClick={() => setShowAddColumnInput(false)}>
                  <CloseIcon />
                </IconButton>
              </Box>
            )}
            <DndContext
              collisionDetection={closestCenter}
              onDragEnd={handleExportDragEnd}
            >
              <SortableContext
                items={exportColumnsOrder}
                strategy={verticalListSortingStrategy}
              >
                {exportColumnsOrder.map((columnId) => (
                  <Box
                    key={columnId}
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: 1,
                      width: '100%',
                      // Minimal styling just for layout
                      '& > div:first-of-type': {
                        flex: 1
                      }
                    }}
                  >
                    <SortableItem
                      key={columnId}
                      id={columnId}
                      label={columnId}
                      checked={exportColumns.includes(columnId)}
                      onToggle={() => {
                        if (exportColumns.includes(columnId)) {
                          setExportColumns(exportColumns.filter(col => col !== columnId));
                        } else {
                          setExportColumns([...exportColumns, columnId]);
                        }
                      }}
                    />
                    {customColumns.find(c => c.id === columnId) && (
                      <IconButton
                        size="small"
                        onClick={() => {
                          setCustomColumns(customColumns.filter(c => c.id !== columnId));
                          setExportColumns(exportColumns.filter(col => col !== columnId));
                          setExportColumnsOrder(exportColumnsOrder.filter(col => col !== columnId));
                        }}
                        sx={{ ml: 1 }}
                      >
                        <DeleteIcon />
                      </IconButton>
                    )}
                  </Box>
                ))}
              </SortableContext>
            </DndContext>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setManageExportOpen(false)}>Cancel</Button>
            <Button
              onClick={() => {
                // Get visible columns in their current order
                const orderedVisibleColumns = exportColumnsOrder.filter(id => exportColumns.includes(id));

                // Stringify the array before saving
                const settingsString = JSON.stringify(orderedVisibleColumns);

                saveUserComponentSettingsApi('ShippingInstructionExport', selectedReport, settingsString)
                  .then(() => {
                    toast.success('Export settings saved successfully');
                    setManageExportOpen(false);
                  })
                  .catch(error => {
                    console.error('Error saving export settings:', error);
                    toast.error('Failed to save export settings');
                  });
              }}
              variant="contained"
            >
              Save Export Settings
            </Button>
            <Button
  variant="contained"
  color="success"
  onClick={handleExportClick}
  endIcon={<KeyboardArrowDownIcon />}
>
  Export Options
</Button>
<Menu
  anchorEl={anchorEl}
  open={open}
  onClose={handleClose}
>
  <MenuItem onClick={() => {
    handleClose();
  }}>
   <ExportExcel
          excelData={createNewExportObject(selectedData)}
          fileName={"ShippingInstruction-"+selectedReport}
          buttonLabel="Export Table"
        />
  </MenuItem>
  <MenuItem onClick={() => {
    handleClose();
  }}>
    <ShippingSummary data={selectedData} />
  </MenuItem>
</Menu>
          </DialogActions>
        </Dialog>

       {/* <ExportExcel
          excelData={createNewExportObject(selectedData)}
          fileName={"ShippingInstructionExport"}
          buttonLabel="Export Table"
        />
          {showFilters && <ShippingSummary data={selectedData} />}*/}
        <Button
          disableElevation
          variant="outlined"
          size="small"
          onClick={() => setAddView(true)}
        >
          Add
        </Button>
        <Button
          variant="outlined"
          onClick={() => setShowFilters(!showFilters)}
          sx={{ minWidth: "130px", mr: 2 }}
          size="small"
        >
          {showFilters ? "Hide Filters" : "Show Filters"}
        </Button>
      </Stack>
    </Toolbar>
  );
}

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
};

export default function ShippingInstructionView() {
  const [rows, setRows] = useState([]);
  const componentName = "ShippingInstructionView";
  useEffect(() => retrieveShippingInstructions(), []);
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("calories");
  const [selected, setSelected] = useState([]);
  const [selectedData, setSelectedData] = useState([]);
  const [page, setPage] = useState(0);
  const [dense, setDense] = useState(true);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [addView, setAddView] = useState(false);
  const [addViewStates, setAddViewStates] = useState(null);
  const [showFilters, setShowFilters] = useState(false);
  const [uploadDialogOpen, setUploadDialogOpen] = useState(false);
  const [selectedGroup, setSelectedGroup] = useState("");
  const [invoiceData, setInvoiceData] = useState([]);
  const [closeDialogOpen, setCloseDialogOpen] = useState(false);
  const [warehouses, setWarehouses] = useState([]);
  const [destinations, setDestinations] = useState([]);
  const [loadingRecord, setLoadingRecord] = useState(null);
  const [visibleColumns, setVisibleColumns] = useState(headCells.map(cell => cell.id));
  const [selectColumnsDialogOpen, setSelectColumnsDialogOpen] = useState(false);
  const [columnsOrder, setColumnsOrder] = useState(headCells.map(cell => cell.id));
  const [selectedColumns, setSelectedColumns] = useState(headCells.map(cell => cell.id));
  const [items, setItems] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [allocationsDialogOpen, setAllocationsDialogOpen] = useState(false);
  const [allocationsDialogSi, setAllocationsDialogSi] = useState(null);
  const [batchCountMap, setBatchCountMap] = useState({});

  const handleToggleAllocations = (event, row) => {
    event.stopPropagation();
    if (!row?.id) return;
    setAllocationsDialogSi(row);
    setAllocationsDialogOpen(true);
  };

  useEffect(() => {
    retrieveUserComponentSettingsApi(componentName, 'default')
      .then((response) => {
        const allColumnIds = headCells.map(cell => cell.id);
        if (response.data && response.data.visibleColumns) {
          const savedColumns = JSON.parse(response.data.visibleColumns);
          const combinedOrder = [
            ...savedColumns,
            ...allColumnIds.filter(id => !savedColumns.includes(id))
          ];
          setVisibleColumns(savedColumns);
          setColumnsOrder(combinedOrder);
          setSelectedColumns(savedColumns);
        } else {
          setVisibleColumns(allColumnIds);
          setColumnsOrder(allColumnIds);
          setSelectedColumns(allColumnIds);
        }
      })
      .catch((error) => {
        console.error("Error loading column settings:", error);
      });
  }, [componentName]);

  const handleSaveColumns = () => {
    const visibleColumnsJson = JSON.stringify(visibleColumns);
    saveUserComponentSettingsApi(componentName, "default", visibleColumnsJson)
      .then((response) => {
        toast.success("Column settings saved successfully!");
      })
      .catch((error) => {
        toast.error("Failed to save column settings.");
        console.error("Save settings error:", error);
      });
  };

  function mapShippingInstruction(shippingInstruction) {
    return {
      ...shippingInstruction,
      shipmentRequestId: shippingInstruction?.shipmentRequest?.id,
      shipmentRequestType: shippingInstruction?.shipmentRequest?.shipmentRequestType,
      shipmentQuantity: shippingInstruction?.shipmentRequest?.shipmentQuantity,
      shipmentQuantityUnit: shippingInstruction?.shipmentRequest?.shipmentQuantityUnit,
      shipmentRequestTo: shippingInstruction?.shipmentRequest?.shipmentRequestTo,
      shipmentRequestreferenceShippingInstructionId: shippingInstruction?.shipmentRequest?.referenceShippingInstructionId,
      shipmentRequestreferenceShippingInstructionNumber: shippingInstruction?.shipmentRequest?.referenceShippingInstructionNumber,
      purchaseOrderId: shippingInstruction?.shipmentRequest?.purchaseOrder?.id,
      purchaseOrderCompany: shippingInstruction?.shipmentRequest?.purchaseOrder?.company,
      purchaseOrderNumber: shippingInstruction?.shipmentRequest?.purchaseOrder?.purchaseOrderNumber,
      purchaseOrderIncoterm: shippingInstruction?.shipmentRequest?.purchaseOrder?.incoterm,
      purchaseOrderVolume: shippingInstruction?.shipmentRequest?.purchaseOrder?.volume,
      purchaseOrderRemainingQuantity: shippingInstruction?.shipmentRequest?.purchaseOrder?.remainingQuantity,
      purchaseOrderVolumeUnit: shippingInstruction?.shipmentRequest?.purchaseOrder?.volumeUnit,
      customer: shippingInstruction?.shipmentRequest?.salesOrder?.customer?.name,
      salesOrderId: shippingInstruction?.shipmentRequest?.salesOrder?.id,
      salesOrderCompany: shippingInstruction?.shipmentRequest?.salesOrder?.company,
      salesOrderNumber: shippingInstruction?.shipmentRequest?.salesOrder?.salesOrderNumber,
      salesOrderIncoterm: shippingInstruction?.shipmentRequest?.salesOrder?.incoterm,
      salesOrderVolume: shippingInstruction?.shipmentRequest?.salesOrder?.volume,
      salesOrderRemainingQuantity: shippingInstruction?.shipmentRequest?.salesOrder?.remainingQuantity,
      salesOrderVolumeUnit: shippingInstruction?.shipmentRequest?.salesOrder?.volumeUnit,
      purchaseOrderItemId: shippingInstruction?.shipmentRequest?.purchaseOrder?.offer?.item?.id,
      salesOrderItemId: shippingInstruction?.shipmentRequest?.salesOrder?.offer?.item?.id,
      purchaseOrderItemBuyingGrade: shippingInstruction?.shipmentRequest?.purchaseOrder?.offer?.item?.buyingGrade,
      salesOrderItemBuyingGrade: shippingInstruction?.shipmentRequest?.salesOrder?.offer?.item?.buyingGrade,
      shipmentRequestCustomerGradeMark: shippingInstruction?.shipmentRequest?.customerGradeMark,
      purchaseOrderItemOrigin: shippingInstruction?.shipmentRequest?.purchaseOrder?.offer?.item?.origin,
      salesOrderItemOrigin: shippingInstruction?.shipmentRequest?.salesOrder?.offer?.item?.origin,
      purchaseOrderItemType: shippingInstruction?.shipmentRequest?.purchaseOrder?.offer?.item?.type,
      salesOrderItemType: shippingInstruction?.shipmentRequest?.salesOrder?.offer?.item?.type,
      purchaseOrderItemCrop: shippingInstruction?.shipmentRequest?.purchaseOrder?.offer?.item?.crop,
      salesOrderItemCrop: shippingInstruction?.shipmentRequest?.salesOrder?.offer?.item?.crop,
      purchaseOrderItemNicotine: shippingInstruction?.shipmentRequest?.purchaseOrder?.offer?.item?.nicotine,
      salesOrderItemNicotine: shippingInstruction?.shipmentRequest?.salesOrder?.offer?.item?.nicotine,
      purchaseOrderItemSugar: shippingInstruction?.shipmentRequest?.purchaseOrder?.offer?.item?.sugar,
      salesOrderItemSugar: shippingInstruction?.shipmentRequest?.salesOrder?.offer?.item?.sugar,
      shipmentRequestNumberOfCases: shippingInstruction?.shipmentRequest?.numberOfCases,
      shipmentRequestNetWeightPerCase: shippingInstruction?.shipmentRequest?.netWeightPerCase,
      shipperId: shippingInstruction?.shipper?.id,
      shipperName: shippingInstruction?.shipper?.name,
      consigneeId: shippingInstruction?.consignee?.id,
      consigneeName: shippingInstruction?.consignee?.name,
      notifyId: shippingInstruction?.notify?.id,
      notifyName: shippingInstruction?.notify?.name,
      freightOfferId: shippingInstruction?.freightOffer?.id,
      shipmentRequestStorageQuantity: shippingInstruction?.shipmentRequest?.storageQuantity,
      purchaseOrderStatus: shippingInstruction?.shipmentRequest?.purchaseOrder?.orderStatus,
      salesOrderStatus: shippingInstruction?.shipmentRequest?.salesOrder?.orderStatus,
    };
  }

  const handleColumnToggle = (columnId) => {
    setVisibleColumns(prev =>
      prev.includes(columnId)
        ? prev.filter(id => id !== columnId)
        : [...prev, columnId]
    );
  };

  function retrieveWarehouse() {
    retrieveAllWarehouseApi()
      .then((response) => {
        setWarehouses(response?.data);
        setDestinations(response?.data);
      })
      .catch((error) => console.log(error.response?.data));
  }

  const [addViewStatesArray, setAddViewStatesArray] = useState([
    {
      shipmentRequestId: null,
      destination: null,
      pointOfLoading: null,
      pointOfUnloading: null,
      consigneeId: null,
      notifyId: null,
      shippingInstructionType: null,
      shippingInstructionNumber: null,
      finalShippingInstructionNumber: null,
      shippingInstructionDate: null,
      status: null,
      dateOfLoadingRemark: null,
      freightOfferId: null,
      transportationContact: null,
      shipmentRequestCustomerGradeMark: null,
      freightRemark: null,
      cartonNumber: null,
      grossWeight: null,
      shippedBy: null,
      shipperId: null,
      toBeShippedBy20: null,
      toBeShippedBy40: null,
      toBeShippedBy40HC: null,
      toBeShippedByFtl: null,
      billOfLadingNumber: null,
      billOfLadingDate: null,
      cmrNumber: null,
      cmrDate: null,
      estimatedTimeOfDeparture: null,
      estimatedTimeOfArrival: null,
      description: null,
      revision: null,
      remark: null,
      link: null,
      recordStatus: null,
    },
  ]);

  const handleTextFieldChange = (event) => {
    const { name, value } = event.target;
    setInvoiceData({ ...invoiceData, [name]: value });
  };
  const handleCostTextFieldChange = (event) => {
    const { name, value } = event.target;
    setInvoiceData({
      ...invoiceData,
      cost: { ...invoiceData?.cost, [name]: value },
    });
  };

  const handleTransshipmentPortChange = (e, index) => {
    const newPorts = [...invoiceData.transshipmentPorts];
    newPorts[index] = e.target.value;
    setInvoiceData({ ...invoiceData, transshipmentPorts: newPorts });
  };

  const handleRemoveTransshipmentPort = (index) => {
    const newPorts = invoiceData.transshipmentPorts.filter(
      (_, i) => i !== index,
    );
    setInvoiceData({ ...invoiceData, transshipmentPorts: newPorts });
  };

  const handleAddTransshipmentPort = () => {
    const newPorts = [...invoiceData.transshipmentPorts, ""];
    setInvoiceData({ ...invoiceData, transshipmentPorts: newPorts });
  };

  const [
    isAdditionalDepartureTimesVisible,
    setIsAdditionalDepartureTimesVisible,
  ] = useState(false);

  const handleDepartureCellClick = () => {
    setIsAdditionalDepartureTimesVisible((prevVisibility) => !prevVisibility);
  };

  const [componentsState, setComponentsState] = useState({
    shipmentRequest: {
      dropdownOpen: false,
      inputValue: "",
    },
    freightOffer: {
      dropdownOpen: false,
      inputValue: "",
    },
    destination: {
      dropdownOpen: false,
      inputValue: "",
    },
    warehouse: {
      dropdownOpen: false,
      inputValue: "",
    },
    item: {
      dropdownOpen: false,
      inputValue: "",
    },
      origin: {
      dropdownOpen: false,
      inputValue: "",
    },
    shippingInstruction: {
      dropdownOpen: false,
      inputValue: "",
    },
    purchaseOrder: {
      dropdownOpen: false,
      inputValue: "",
    },
    salesOrder: {
      dropdownOpen: false,
      inputValue: "",
    },
      customer: {
      dropdownOpen: false,
      inputValue: "",
    },
  });

  const updateComponentState = (componentKey, newState) => {
    setComponentsState((prevState) => ({
      ...prevState,
      [componentKey]: {
        ...prevState[componentKey],
        ...newState,
      },
    }));
  };

  const [exportSIPopup, setExportSIPopup] = useState({
    visible: false,
    data: null,
  });
  const [exportShippingDetailsPopup, setExportShippingDetailsPopup] = useState({
    visible: false,
    data: null,
  });
  const [exportProformaDetailsPopup, setExportProformaDetailsPopup] = useState({
    visible: false,
    data: null,
  });
  const [editShipmentRequest, setEditShipmentRequest] = useState({
    visible: false,
    data: null,
    index: null,
  });
  const [editVendorOrder, setEditVendorOrder] = useState({
    visible: false,
    data: null,
    index: null,
  });
  const [editCustomerOrder, setEditCustomerOrder] = useState({
    visible: false,
    data: null,
    index: null,
  });
  const [editItem, setEditItem] = useState({
    visible: false,
    data: null,
    index: null,
  });
  const [editFreightOffer, setEditFreightOffer] = useState({
    visible: false,
    data: null,
    index: null,
  });

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const [showPorts, setShowPorts] = useState(false);

  const togglePortsVisibility = () => {
    setShowPorts(!showPorts);
  };

  const STATUS_OPTIONS = [
  { label: 'Open', value: 'OPEN' },
  { label: 'Closed', value: 'CLOSED' },
  { label: 'All', value: 'ALL' },
];

  const [filterShippingInstruction, setFilterShippingInstruction] = useState({
    id: 0,
    shipmentRequestIdList: [],
    shippingInstructionTypeList: [],
    freightOfferIdList: [],
    itemIdList: [],
    shippingInstructionIdList: [],
    purchaseOrderIdList: [],
    salesOrderIdList: [],
    purchaseOrderCompanyList: [],
    salesOrderCompanyList: [],
    purchaseOrderIncotermList: [],
    salesOrderIncotermList: [],
    transportationContact: "",
    finalShippingInstructionNumber: "",
    cartonNumber: "",
    shippedByList: [],
    billOfLadingNumber: "",
    showBillOfLadingDateFields: false,
    billOfLadingDateFrom: null,
    billOfLadingDateTo: null,
    cmrNumber: "",showCmrDateFields: false,
    cmrDateFrom: null,
    cmrDateTo: null,
    showEtdFields: false,
    estimatedTimeOfDepartureFrom: null,
    estimatedTimeOfDepartureTo: null,
    showEtaFields: false,
    estimatedTimeOfArrivalFrom: null,
    estimatedTimeOfArrivalTo: null,
    shipperIdList: [],
    consigneeIdList: [],
    notifyIdList: [],
    pointOfLoadingList: [],
    pointOfUnloadingList: [],
    description: "",
    remark: "",
    statusList: [],
    recordStatusList: ["ACTIVE"],
    originList: [],
    purchaseOrderStatus: 'ALL',
    salesOrderStatus: 'ALL',
    customerIdList: [],
  });

  // ── Load batch allocation counts once per row set ────────────────────────
  useEffect(() => {
    if (!rows || rows.length === 0) return;
    const ids = rows.map((r) => r.id).filter(Boolean);
    if (ids.length === 0) return;
    retrieveBatchAllocationCountsBySiApi(ids)
      .then((res) => setBatchCountMap(res?.data || {}))
      .catch(() => {/* non-fatal */});
  }, [rows]);

  function retrieveShippingInstructions() {
    retrieveFastShippingInstructionsApi()
      .then((response) => {
        setRows(response?.data);
      })
      .catch((error) => console.log(error.response?.data));
  }

  const cancelShippingInstruction = async (shippingInstruction) => {
    setLoadingRecord(shippingInstruction?.id);
    const row = mapShippingInstruction(shippingInstruction);
    const isFormalityWarehouse =
      shippingInstruction?.warehouse === "Cross Trades" ||
      shippingInstruction?.warehouse === "Zafiris Warehouse";
    const updatedShippingInstructionData = {
      ...row,
      recordStatus: "PASSIVE",
      status: "Cancelled",
      operation: "Cancelling",
      source: isFormalityWarehouse ? "formality" : "",
         purchaseOrderDto: {
       ...shippingInstruction?.shipmentRequest?.purchaseOrder,
      remainingQuantity: shippingInstruction?.shipmentRequest?.purchaseOrder
        ? (shippingInstruction?.shipmentRequest?.purchaseOrder?.remainingQuantity ||
            0) + (shippingInstruction?.shipmentRequest?.shipmentQuantity || 0)
        : shippingInstruction?.shipmentRequest?.purchaseOrder?.remainingQuantity,
      orderStatus: shippingInstruction?.shipmentRequest?.purchaseOrder
        ? (shippingInstruction?.shipmentRequest?.purchaseOrder?.remainingQuantity ||
            0) +
            (shippingInstruction?.shipmentRequest?.shipmentQuantity || 0) >=
          0
          ? "Open"
          : shippingInstruction?.shipmentRequest?.purchaseOrder?.orderStatus
        : shippingInstruction?.shipmentRequest?.purchaseOrder?.orderStatus,
     },
          salesOrderDto: {
      ...shippingInstruction?.shipmentRequest?.salesOrder,
      remainingQuantity: shippingInstruction?.shipmentRequest?.salesOrder
        ? (shippingInstruction?.shipmentRequest?.salesOrder?.remainingQuantity || 0) +
          (shippingInstruction?.shipmentRequest?.shipmentQuantity || 0)
        : shippingInstruction?.shipmentRequest?.salesOrder?.remainingQuantity,
      orderStatus: shippingInstruction?.shipmentRequest?.salesOrder
        ? (shippingInstruction?.shipmentRequest?.salesOrder?.remainingQuantity || 0) +
            (shippingInstruction?.shipmentRequest?.shipmentQuantity || 0) >=
          0
          ? "Open"
          : shippingInstruction?.shipmentRequest?.salesOrder?.orderStatus
        : shippingInstruction?.shipmentRequest?.salesOrder?.orderStatus,
     },
    };

    try {
      const response = await updateShippingInstructionApi(
        shippingInstruction?.id,
        updatedShippingInstructionData,
      );
      if (rows && setRows) {
        const idx = rows.findIndex(row => row.id === updatedShippingInstructionData.id);

        if (idx !== -1) {
          const newRows = [...rows];
          newRows[idx] = updatedShippingInstructionData;
          setRows(newRows);
        }
      }
      toast.success("SI cancelled successfully.");
    } catch (error) {
      console.log(error.response.data);
      toast.error("Something went wrong. ", error.response.data);
    } finally {
      setLoadingRecord(null);
    }
  }

  const [shipmentRequest, setShipmentRequest] = useState([]);
  const [shipmentRequests, setShipmentRequests] = useState([]);
  const [freightOffer, setFreightOffer] = useState([]);
  const [freightOffers, setFreightOffers] = useState([]);
  const [purchaseOrders, setPurchaseOrders] = useState([]);
  const [salesOrders, setSalesOrders] = useState([]);

  function retrieveOrders(type) {
    retrieveFastOrdersApi(type)
      .then((response) => {
        if (type === "VENDOR") {
          setPurchaseOrders(response?.data);
        } else if (type === "CUSTOMER") {
          setSalesOrders(response?.data);
        }
      })
      .catch((error) => console.log(error.response?.data));
  }

  function retrieveShipmentRequestById(id) {
    retrieveShipmentRequestByIdApi(id)
      .then((response) => {
        setShipmentRequest(response?.data);
      })
      .catch((error) => console.log(error.response?.data));
  }

  function retrieveShipmentRequests() {
    retrieveFastShipmentRequestsApi()
      .then((response) => {
        setShipmentRequests(response?.data);
      })
      .catch((error) => console.log(error.response?.data));
  }

  function retrieveItems() {
    retrieveAllItemsApi()
      .then((response) => {
        setItems(response?.data);
      })
      .catch((error) => console.log(error.response?.data));
  }

    function retrieveCustomers() {
      retrieveFastStakeholdersApi("CUSTOMER")
        .then((response) => {
          setCustomers(response?.data);
        })
        .catch((error) => console.log(error.response?.data));
    }

  function retrieveFreightOffers() {
    retrieveAllFreightOffersApi()
      .then((response) => {
        setFreightOffers(response?.data);
      })
      .catch((error) => console.log(error.response?.data));
  }
  function retrieveFreightOfferById(id) {
    retrieveFreightOfferByIdApi(id)
      .then((response) => {
        setFreightOffer(response?.data);
      })
      .catch((error) => console.log(error.response?.data));
  }

  const [editShippingInstruction, setEditShippingInstruction] = useState({
    visible: false,
    data: null,
    index: null,
  });

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelected = rows.map((n) => n.id);
      setSelected(newSelected);
      setSelectedData(rows);
      return;
    } else {
      setSelected([]);
      setSelectedData([]);
    }
  };

  const handleClick = (event, name, row) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1),
      );
    }

    const selectedDataIndex = selectedData.indexOf(row);
    let newSelectedData = [];

    if (selectedDataIndex === -1) {
      newSelectedData = newSelectedData.concat(selectedData, row);
    } else if (selectedDataIndex === 0) {
      newSelectedData = newSelectedData.concat(selectedData.slice(1));
    } else if (selectedDataIndex === selectedData.length - 1) {
      newSelectedData = newSelectedData.concat(selectedData.slice(0, -1));
    } else if (selectedDataIndex > 0) {
      newSelectedData = newSelectedData.concat(
        selectedData.slice(0, selectedDataIndex),
        selectedData.slice(selectedDataIndex + 1),
      );
    }
    setSelectedData(newSelectedData);

    setSelected(newSelected);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleChangeDense = (event) => {
    setDense(event.target.checked);
  };

  const isSelected = (name) => selected.indexOf(name) !== -1;

  const isFieldFilled = (fieldName, isDirect = true) => {
    return isDirect
      ? !!invoiceData?.[fieldName]
      : !!invoiceData?.cost?.[fieldName];
  };

  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;

  const visibleRows = React.useMemo(
    () =>
      stableSort(rows, getComparator(order, orderBy)).slice(
        page * rowsPerPage,
        page * rowsPerPage + rowsPerPage,
      ),
    [order, orderBy, page, rowsPerPage, rows, editShippingInstruction],
  );

  return (
    <div>
      <BatchAllocationsDialog
        open={allocationsDialogOpen}
        onClose={() => setAllocationsDialogOpen(false)}
        shippingInstruction={allocationsDialogSi}
      />
      <Dialog
        open={uploadDialogOpen}
        onClose={() => setUploadDialogOpen(false)}
        aria-labelledby="upload-dialog-title"
      >
        <DialogTitle id="upload-dialog-title">
          Select File{" "}
          {invoiceData?.finalShippingInstructionNumber
            ? "For " + invoiceData?.finalShippingInstructionNumber
            : ""}
        </DialogTitle>
        <DialogContent>
          <Box display="flex" alignItems="center" gap={2}>
            <TextField
              label="SI Folder Link"
              name="siFolderLink"
              value={invoiceData?.siFolderLink || ""}
              onChange={handleTextFieldChange}
              fullWidth
              margin="normal"
            />
            {invoiceData?.siFolderLink && (
              <a
                href={
                  /^https?:\/\//.test(invoiceData?.siFolderLink)
                    ? invoiceData?.siFolderLink
                    : `https://${invoiceData?.siFolderLink}`
                }
                target="_blank"
                rel="noreferrer"
                style={{ textDecoration: "none" }}
              >
                <Button disableElevation variant="outlined" size="small">
                  Link
                </Button>
              </a>
            )}
          </Box>
          <FormGroup>
            <FormControlLabel
              control={
                <Checkbox
                  checked={invoiceData?.containsARInvoice || false}
                  onChange={(e) =>
                    setInvoiceData({
                      ...invoiceData,
                      containsARInvoice: e.target.checked,
                    })
                  }
                />
              }
              label="Contains AR Invoice Link"
            />

            <FormControlLabel
              control={
                <Checkbox
                  checked={invoiceData?.containsSupplierInvoice || false}
                  onChange={(e) =>
                    setInvoiceData({
                      ...invoiceData,
                      containsSupplierInvoice: e.target.checked,
                    })
                  }
                />
              }
              label="Contains Supplier Invoice Link"
            />

            <FormControlLabel
              control={
                <Checkbox
                  checked={invoiceData?.containsInsurance || false}
                  onChange={(e) =>
                    setInvoiceData({
                      ...invoiceData,
                      containsInsurance: e.target.checked,
                    })
                  }
                />
              }
              label="Contains Insurance Link"
            />

            <FormControlLabel
              control={
                <Checkbox
                  checked={invoiceData?.containsFreight || false}
                  onChange={(e) =>
                    setInvoiceData({
                      ...invoiceData,
                      containsFreight: e.target.checked,
                    })
                  }
                />
              }
              label="Contains Freight Link"
            />

            <FormControlLabel
              control={
                <Checkbox
                  checked={invoiceData?.containsBLLink || false}
                  onChange={(e) =>
                    setInvoiceData({
                      ...invoiceData,
                      containsBLLink: e.target.checked,
                    })
                  }
                />
              }
              label="Contains BL Link"
            />

            <FormControlLabel
              control={
                <Checkbox
                  checked={invoiceData?.containsWeightListLink || false}
                  onChange={(e) =>
                    setInvoiceData({
                      ...invoiceData,
                      containsWeightListLink: e.target.checked,
                    })
                  }
                />
              }
              label="Contains Weight List Link"
            />
          </FormGroup>

          {/* Menu for Related Fields */}
          <Select
            value={selectedGroup || ""}
            onChange={(e) => setSelectedGroup(e.target.value)}
            displayEmpty
            fullWidth
          >
            <MenuItem value="" disabled>
              Select Document Group
            </MenuItem>
            <MenuItem value="arInvoiceGroup">AR Invoice</MenuItem>
            <MenuItem value="supplierInvoiceGroup">Supplier Invoice</MenuItem>
            <MenuItem value="insuranceGroup">Insurance</MenuItem>
            <MenuItem value="freightGroup">Freight</MenuItem>
            <MenuItem value="blGroup">Bill of Lading</MenuItem>
            <MenuItem value="cmrGroup">CMR</MenuItem>
            <MenuItem value="grGroup">GR</MenuItem>
            <MenuItem value="lcGroup">LC</MenuItem>
            <MenuItem value="delGroup">Del</MenuItem>
            <MenuItem value="shippingDetailsGroup">Shipping Details</MenuItem>
          </Select>

          {/* Conditional Rendering for Additional Fields */}
          {selectedGroup === "arInvoiceGroup" && (
            <TextField
              label="AR Number"
              name="accountsReceivableNumber"
              value={invoiceData?.accountsReceivableNumber || ""}
              onChange={handleTextFieldChange}
              fullWidth
              margin="normal"
            />
          )}

          {selectedGroup === "supplierInvoiceGroup" && (
            <TextField
              label="Supplier Invoice Number"
              name="supplierInvoiceNumber"
              value={invoiceData?.supplierInvoiceNumber || ""}
              onChange={handleTextFieldChange}
              fullWidth
              margin="normal"
            />
          )}

          {selectedGroup === "insuranceGroup" && (
            <TextField
              label="Insurance Number"
              name="insuranceNumber"
              value={invoiceData?.insuranceNumber || ""}
              onChange={handleTextFieldChange}
              fullWidth
              margin="normal"
            />
          )}

          {selectedGroup === "freightGroup" && (
            <TextField
              label="Freight Number"
              name="freightNumber"
              value={invoiceData?.freightNumber || ""}
              onChange={handleTextFieldChange}
              fullWidth
              margin="normal"
            />
          )}

          {selectedGroup === "blGroup" && (
            <>
              <TextField
                label="BL Number"
                name="billOfLadingNumber"
                value={invoiceData?.billOfLadingNumber || ""}
                onChange={handleTextFieldChange}
                fullWidth
                margin="normal"
              />
              <TextField
                label="BL Date"
                name="billOfLadingDate"
                type="date"
                 onKeyDown={(e) => e.preventDefault()}
                inputProps={{ min: "1999-01-01", max: "2999-01-01" }}
                InputLabelProps={{
                  shrink: true,
                }}
                value={
                  invoiceData?.billOfLadingDate
                    ? format(
                      parseISO(invoiceData.billOfLadingDate),
                      "yyyy-MM-dd",
                    )
                    : ""
                }
                onChange={handleTextFieldChange}
                fullWidth
                margin="normal"
              />
            </>
          )}

          {selectedGroup === "cmrGroup" && (
            <>
              <TextField
                label="CMR Number"
                name="cmrNumber"
                value={invoiceData?.cmrNumber || ""}
                onChange={handleTextFieldChange}
                fullWidth
                margin="normal"
              />
              <TextField
                label="CMR Date"
                name="cmrDate"
                type="date" 
                onKeyDown={(e) => e.preventDefault()}
            inputProps={{ min: "1999-01-01", max: "2999-01-01" }}
            InputLabelProps={{
              shrink: true,
            }}
                value={
                  invoiceData?.cmrDate
                    ? format(parseISO(invoiceData.cmrDate), "yyyy-MM-dd")
                    : ""
                }
                onChange={handleTextFieldChange}
                fullWidth
                margin="normal"
              />
            </>
          )}

          {selectedGroup === "grGroup" && (
            <TextField
              label="GR Number"
              name="goodsReceiptNumber"
              value={invoiceData?.goodsReceiptNumber || ""}
              onChange={handleTextFieldChange}
              fullWidth
              margin="normal"
            />
          )}

          {selectedGroup === "lcGroup" && (
            <TextField
              label="LC Number"
              name="landedCostNumber"
              value={invoiceData?.landedCostNumber || ""}
              onChange={handleTextFieldChange}
              fullWidth
              margin="normal"
            />
          )}

          {selectedGroup === "delGroup" && (
            <TextField
              label="Del Number"
              name="deliveryNumber"
              value={invoiceData?.deliveryNumber || ""}
              onChange={handleTextFieldChange}
              fullWidth
              margin="normal"
            />
          )}

          {selectedGroup === "shippingDetailsGroup" && (
            <>
              <TextField
                label="Booking Number"
                name="bookingNumber"
                value={invoiceData?.bookingNumber || ""}
                onChange={handleTextFieldChange}
                fullWidth
                margin="normal"
              />
              {/*<TextField
                label="Shipping Line"
                name="shippingLine"
                value={invoiceData?.shippingLine || ""}
                onChange={handleTextFieldChange}
                fullWidth
                margin="normal"
              />*/}
              <TextField
                label="Vessel Name"
                name="vesselName"
                value={invoiceData?.vesselName || ""}
                onChange={handleTextFieldChange}
                fullWidth
                margin="normal"
              />
              <TextField
                label="Voyage Number"
                name="voyageNumber"
                value={invoiceData?.voyageNumber || ""}
                onChange={handleTextFieldChange}
                fullWidth
                margin="normal"
              />
              <Button
                variant="contained"
                onClick={togglePortsVisibility}
                style={{ marginBottom: "16px", marginTop: "16px" }}
              >
                Manage Transshipment Ports
              </Button>

              {showPorts && (
                <div>
                  {invoiceData?.transshipmentPorts?.map((port, index) => (
                    <div
                      key={index}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        marginBottom: "8px",
                      }}
                    >
                      <TextField
                        label={`Transshipment Port ${index + 1}`}
                        value={port}
                        onChange={(e) =>
                          handleTransshipmentPortChange(e, index)
                        }
                        fullWidth
                        margin="normal"
                      />
                      <IconButton
                        onClick={() => handleRemoveTransshipmentPort(index)}
                      >
                        <CloseIcon />
                      </IconButton>
                    </div>
                  ))}
                  <IconButton onClick={handleAddTransshipmentPort}>
                    <AddIcon />
                  </IconButton>
                </div>
              )}
            </>
          )}
        </DialogContent>

        <DialogActions>
          <Button onClick={() => setUploadDialogOpen(false)} color="primary">
            Cancel
          </Button>
          <Button
            onClick= { async () => {
                  //setLoadingRecord(invoiceData?.id);
                  try {
                 const response = await updateShippingInstructionApi(invoiceData?.id, invoiceData);
                   toast.success("Shipping Instruction edited successfully.");
                  const row = mapShippingInstruction(invoiceData);
                  if (rows && setRows) {
                    const idx = rows.findIndex(row => row.id === invoiceData.id);
                    if (idx !== -1) {
                      const newRows = [...rows];
                      newRows[idx] = row;
                      setRows(newRows);
                    }
                  }
                  setUploadDialogOpen(false);
               } catch (error) {
                 toast.error("Something went wrong.");
                  console.log(error.response.data);
               } finally {
                 //setLoadingRecord(null);
               }
            }}
            color="primary"
          >
            Upload
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={closeDialogOpen}
        onClose={() => setCloseDialogOpen(false)}
        aria-labelledby="close-dialog-title"
      >
        <DialogTitle id="close-dialog-title">
          Necessary Fields{" "}
          {invoiceData?.finalShippingInstructionNumber
            ? "For: " + invoiceData?.finalShippingInstructionNumber + " "
            : ""}
          {invoiceData?.shipmentRequest?.shipmentRequestType
            ? "(" + invoiceData?.shipmentRequest?.shipmentRequestType + ")"
            : ""}
        </DialogTitle>
        <DialogContent>
          <Accordion>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography
                sx={{
                  color: isFieldFilled("actualInsuranceCost", true)
                    ? "#388e3c"
                    : "inherit",
                  fontWeight: isFieldFilled("actualInsuranceCost", true)
                    ? "bold"
                    : "normal",
                }}
              >
                Insurance Cost
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <TextField
                label="Total Insurance Cost"
                name="actualTotalInsuranceCost"
                value={
                  invoiceData?.actualTotalInsuranceCost ||
                  Math.round(
                    invoiceData?.actualInsuranceCost *
                    (invoiceData?.shipmentRequest?.shipmentQuantity || 0),
                  ) ||
                  ""
                }
                type="number"
                onWheel={(e) => e.target.blur()}
                onChange={(event) => {
                  handleTextFieldChange(event);
                  setInvoiceData((prevInvoiceData) => ({
                    ...prevInvoiceData,
                    actualInsuranceCost: prevInvoiceData?.shipmentRequest
                      ?.shipmentQuantity
                      ? (event.target.value || 0) /
                      prevInvoiceData.shipmentRequest.shipmentQuantity
                      : "",
                  }));
                }}
                fullWidth
                margin="normal"
              />
              <TextField
                label="Unit Insurance Cost"
                name="actualInsuranceCost"
                value={
                  invoiceData?.actualTotalInsuranceCost
                    ? invoiceData?.shipmentRequest?.shipmentQuantity
                      ? (invoiceData.actualTotalInsuranceCost || 0) /
                      invoiceData.shipmentRequest.shipmentQuantity
                      : ""
                    : invoiceData?.actualInsuranceCost
                      ? invoiceData?.actualInsuranceCost
                      : ""
                }
                type="number"
                onWheel={(e) => e.target.blur()}
                onChange={handleTextFieldChange}
                fullWidth
                margin="normal"
                InputProps={{
                  readOnly: true,
                }}
              />
              <TextField
                label="Insurance Currency"
                name="actualInsuranceCurrency"
                select
                value={invoiceData?.actualInsuranceCurrency}
                onChange={handleTextFieldChange}
                fullWidth
                margin="normal"
              >
                {currencies.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </TextField>
              <TextField
                size="small"
                label="Insurance Date"
                fullWidth
                name="actualTimeOfInsurance"
                margin="normal"
                value={
                  invoiceData?.actualTimeOfInsurance
                    ? format(
                      parseISO(invoiceData.actualTimeOfInsurance),
                      "yyyy-MM-dd",
                    )
                    : ""
                }
                id="date"
                type="date"
                inputProps={{ min: "1999-01-01", max: "2999-01-01" }}
                InputLabelProps={{
                  shrink: true,
                }}
                onKeyDown={(e) => e.preventDefault()}
                onChange={(e) => {
                  handleTextFieldChange(e);
                }}
              />
              <TextField
                label="Insurance Remark"
                name="actualInsuranceRemark"
                value={invoiceData?.actualInsuranceRemark}
                onChange={handleTextFieldChange}
                fullWidth
                margin="normal"
              />
            </AccordionDetails>
          </Accordion>
          <Accordion>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography
                sx={{
                  color: isFieldFilled("actualFreightPrice", true)
                    ? "#388e3c"
                    : "inherit",
                  fontWeight: isFieldFilled("actualFreightPrice", true)
                    ? "bold"
                    : "normal",
                }}
              >
                Freight Cost
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <TextField
                label="Total Freight Cost"
                name="actualTotalFreightPrice"
                onWheel={(e) => e.target.blur()}
                onChange={(event) => {
                  handleTextFieldChange(event);
                  setInvoiceData((prevInvoiceData) => ({
                    ...prevInvoiceData,
                    actualFreightPrice: prevInvoiceData?.shipmentRequest
                      ?.shipmentQuantity
                      ? (event.target.value || 0) /
                      prevInvoiceData.shipmentRequest.shipmentQuantity
                      : "",
                  }));
                }}
                value={
                  invoiceData?.actualTotalFreightPrice ||
                  Math.round(
                    invoiceData?.actualFreightPrice *
                    (invoiceData?.shipmentRequest?.shipmentQuantity || 0),
                  ) ||
                  ""
                }
                type="number"
                fullWidth
                margin="normal"
              />
              <TextField
                label="Unit Freight Cost"
                name="actualFreightPrice"
                value={
                  invoiceData?.actualTotalFreightPrice
                    ? invoiceData?.shipmentRequest?.shipmentQuantity
                      ? (invoiceData.actualTotalFreightPrice || 0) /
                      invoiceData.shipmentRequest.shipmentQuantity
                      : ""
                    : invoiceData?.actualFreightPrice
                      ? invoiceData?.actualFreightPrice
                      : ""
                }
                type="number"
                onWheel={(e) => e.target.blur()}
                onChange={handleTextFieldChange}
                fullWidth
                margin="normal"
                InputProps={{
                  readOnly: true,
                }}
              />
              <TextField
                label="Freight Currency"
                name="actualFreightCurrency"
                select
                value={invoiceData?.actualFreightCurrency}
                onChange={handleTextFieldChange}
                fullWidth
                margin="normal"
              >
                {currencies.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </TextField>
              <TextField
                size="small"
                label="Freight Date"
                fullWidth
                name="actualTimeOfFreight"
                margin="normal"
                value={
                  invoiceData?.actualTimeOfFreight
                    ? format(
                      parseISO(invoiceData.actualTimeOfFreight),
                      "yyyy-MM-dd",
                    )
                    : ""
                }
                id="date"
                type="date"
                inputProps={{ min: "1999-01-01", max: "2999-01-01" }}
                InputLabelProps={{
                  shrink: true,
                }}
                onKeyDown={(e) => e.preventDefault()}
                onChange={(e) => {
                  handleTextFieldChange(e);
                }}
              />
              <TextField
                label="Freight Remark"
                name="actualFreightRemark"
                value={invoiceData?.actualFreightRemark}
                onChange={handleTextFieldChange}
                fullWidth
                margin="normal"
              />
            </AccordionDetails>
          </Accordion>

          <Accordion>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography
                sx={{
                  color: isFieldFilled("secondFreightCost", false)
                    ? "#388e3c"
                    : "inherit",
                  fontWeight: isFieldFilled("secondFreightCost", false)
                    ? "bold"
                    : "normal",
                }}
              >
                Second Freight Cost
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <TextField
                label="Second Freight Cost"
                name="totalSecondFreightCost"
                onWheel={(e) => e.target.blur()}
                onChange={(event) => {
                  handleCostTextFieldChange(event);
                  setInvoiceData((prevInvoiceData) => ({
                    ...prevInvoiceData,
                    cost: {
                      ...prevInvoiceData?.cost,
                      secondFreightCost: prevInvoiceData?.shipmentRequest
                        ?.shipmentQuantity
                        ? (event.target.value || 0) /
                        prevInvoiceData.shipmentRequest.shipmentQuantity
                        : "",
                    },
                  }));
                }}
                value={
                  invoiceData?.cost?.totalSecondFreightCost ||
                  Math.round(
                    invoiceData?.cost?.secondFreightCost *
                    (invoiceData?.shipmentRequest?.shipmentQuantity || 0),
                  ) ||
                  ""
                }
                type="number"
                fullWidth
                margin="normal"
              />
              <TextField
                label="Unit Second Freight Cost"
                name="secondFreightCost"
                value={
                  invoiceData?.cost?.totalSecondFreightCost
                    ? invoiceData?.shipmentRequest?.shipmentQuantity
                      ? (invoiceData?.cost?.totalSecondFreightCost || 0) /
                      invoiceData.shipmentRequest.shipmentQuantity
                      : ""
                    : invoiceData?.cost?.secondFreightCost
                      ? invoiceData?.cost?.secondFreightCost
                      : ""
                }
                type="number"
                fullWidth
                margin="normal"
                InputProps={{
                  readOnly: true,
                }}
              />
              <TextField
                label="Second Freight Cost Currency"
                name="secondFreightCostCurrency"
                select
                value={invoiceData?.cost?.secondFreightCostCurrency}
                onChange={handleCostTextFieldChange}
                fullWidth
                margin="normal"
              >
                {currencies.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </TextField>
              <TextField
                size="small"
                label="Second Freight Date"
                fullWidth
                name="secondFreightDate"
                margin="normal"
                value={
                  invoiceData?.cost?.secondFreightDate
                    ? format(
                      parseISO(invoiceData.cost.secondFreightDate),
                      "yyyy-MM-dd",
                    )
                    : ""
                }
                id="date"
                type="date"
                inputProps={{ min: "1999-01-01", max: "2999-01-01" }}
                InputLabelProps={{
                  shrink: true,
                }}
                onKeyDown={(e) => e.preventDefault()}
                onChange={(e) => {
                  handleCostTextFieldChange(e);
                }}
              />
            </AccordionDetails>
          </Accordion>

          <Accordion>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography
                sx={{
                  color: isFieldFilled("importExportExpense", false)
                    ? "#388e3c"
                    : "inherit",
                  fontWeight: isFieldFilled("importExportExpense", false)
                    ? "bold"
                    : "normal",
                }}
              >
                Import/Export Expenses
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <TextField
                label="Imoprt/Export Cost"
                name="totalImportExportExpense"
                onWheel={(e) => e.target.blur()}
                onChange={(event) => {
                  handleCostTextFieldChange(event);
                  setInvoiceData((prevInvoiceData) => ({
                    ...prevInvoiceData,
                    cost: {
                      ...prevInvoiceData?.cost,
                      importExportExpense: prevInvoiceData?.shipmentRequest
                        ?.shipmentQuantity
                        ? (event.target.value || 0) /
                        prevInvoiceData.shipmentRequest.shipmentQuantity
                        : "",
                    },
                  }));
                }}
                value={
                  invoiceData?.cost?.totalImportExportExpense ||
                  Math.round(
                    invoiceData?.cost?.importExportExpense *
                    (invoiceData?.shipmentRequest?.shipmentQuantity || 0),
                  ) ||
                  ""
                }
                type="number"
                fullWidth
                margin="normal"
              />
              <TextField
                label="Unit Import/Export Expense"
                name="importExportExpense"
                value={
                  invoiceData?.cost?.totalImportExportExpense
                    ? invoiceData?.shipmentRequest?.shipmentQuantity
                      ? (invoiceData?.cost?.totalImportExportExpense || 0) /
                      invoiceData.shipmentRequest.shipmentQuantity
                      : ""
                    : invoiceData?.cost?.importExportExpense
                      ? invoiceData?.cost?.importExportExpense
                      : ""
                }
                type="number"
                fullWidth
                margin="normal"
                InputProps={{
                  readOnly: true,
                }}
              />
              <TextField
                label="Import/Export Currency"
                name="importExportExpenseCurrency"
                select
                value={invoiceData?.cost?.importExportExpenseCurrency}
                onChange={handleCostTextFieldChange}
                fullWidth
                margin="normal"
              >
                {currencies.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </TextField>
              <TextField
                size="small"
                label="Import/Export Date"
                fullWidth
                name="importExportExpenseDate"
                margin="normal"
                value={
                  invoiceData?.cost?.importExportExpenseDate
                    ? format(
                      parseISO(invoiceData.cost.importExportExpenseDate),
                      "yyyy-MM-dd",
                    )
                    : ""
                }
                id="date"
                type="date"
                inputProps={{ min: "1999-01-01", max: "2999-01-01" }}
                InputLabelProps={{
                  shrink: true,
                }}
                onKeyDown={(e) => e.preventDefault()}
                onChange={(e) => {
                  handleCostTextFieldChange(e);
                }}
              />
            </AccordionDetails>
          </Accordion>

          <Accordion>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography
                sx={{
                  color: isFieldFilled("demurrage", false)
                    ? "#388e3c"
                    : "inherit",
                  fontWeight: isFieldFilled("demurrage", false)
                    ? "bold"
                    : "normal",
                }}
              >
                Demurrage
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <TextField
                label="Demurrage"
                name="totalDemurrage"
                onWheel={(e) => e.target.blur()}
                onChange={(event) => {
                  handleCostTextFieldChange(event);
                  setInvoiceData((prevInvoiceData) => ({
                    ...prevInvoiceData,
                    cost: {
                      ...prevInvoiceData?.cost,
                      demurrage: prevInvoiceData?.shipmentRequest
                        ?.shipmentQuantity
                        ? (event.target.value || 0) /
                        prevInvoiceData.shipmentRequest.shipmentQuantity
                        : "",
                    },
                  }));
                }}
                value={
                  invoiceData?.cost?.totalDemurrage ||
                  Math.round(
                    invoiceData?.cost?.demurrage *
                    (invoiceData?.shipmentRequest?.shipmentQuantity || 0),
                  ) ||
                  ""
                }
                type="number"
                fullWidth
                margin="normal"
              />
              <TextField
                label="Unit Demurrage"
                name="demurrage"
                value={
                  invoiceData?.cost?.totalDemurrage
                    ? invoiceData?.shipmentRequest?.shipmentQuantity
                      ? (invoiceData?.cost?.totalDemurrage || 0) /
                      invoiceData.shipmentRequest.shipmentQuantity
                      : ""
                    : invoiceData?.cost?.demurrage
                      ? invoiceData?.cost?.demurrage
                      : ""
                }
                type="number"
                fullWidth
                margin="normal"
                InputProps={{
                  readOnly: true,
                }}
              />
              <TextField
                label="Demurrage Currency"
                name="demurrageCurrency"
                select
                value={invoiceData?.cost?.demurrageCurrency}
                onChange={handleCostTextFieldChange}
                fullWidth
                margin="normal"
              >
                {currencies.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </TextField>
              <TextField
                size="small"
                label="Demurrage Date"
                fullWidth
                name="demurrageDate"
                margin="normal"
                value={
                  invoiceData?.cost?.demurrageDate
                    ? format(
                      parseISO(invoiceData.cost.demurrageDate),
                      "yyyy-MM-dd",
                    )
                    : ""
                }
                id="date"
                type="date"
                inputProps={{ min: "1999-01-01", max: "2999-01-01" }}
                InputLabelProps={{
                  shrink: true,
                }}
                onKeyDown={(e) => e.preventDefault()}
                onChange={(e) => {
                  handleCostTextFieldChange(e);
                }}
              />
            </AccordionDetails>
          </Accordion>

          <Accordion>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography
                sx={{
                  color: isFieldFilled("fumigation", false)
                    ? "#388e3c"
                    : "inherit",
                  fontWeight: isFieldFilled("fumigation", false)
                    ? "bold"
                    : "normal",
                }}
              >
                Fumigation
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <TextField
                label="Fumigation"
                name="totalFumigation"
                onWheel={(e) => e.target.blur()}
                onChange={(event) => {
                  handleCostTextFieldChange(event);
                  setInvoiceData((prevInvoiceData) => ({
                    ...prevInvoiceData,
                    cost: {
                      ...prevInvoiceData?.cost,
                      fumigation: prevInvoiceData?.shipmentRequest
                        ?.shipmentQuantity
                        ? (event.target.value || 0) /
                        prevInvoiceData.shipmentRequest.shipmentQuantity
                        : "",
                    },
                  }));
                }}
                value={
                  invoiceData?.cost?.totalFumigation ||
                  Math.round(
                    invoiceData?.cost?.fumigation *
                    (invoiceData?.shipmentRequest?.shipmentQuantity || 0),
                  ) ||
                  ""
                }
                type="number"
                fullWidth
                margin="normal"
              />
              <TextField
                label="Unit Fumigation"
                name="fumigation"
                value={
                  invoiceData?.cost?.totalFumigation
                    ? invoiceData?.shipmentRequest?.shipmentQuantity
                      ? (invoiceData?.cost?.totalFumigation || 0) /
                      invoiceData.shipmentRequest.shipmentQuantity
                      : ""
                    : invoiceData?.cost?.fumigation
                      ? invoiceData?.cost?.fumigation
                      : ""
                }
                type="number"
                fullWidth
                margin="normal"
                InputProps={{
                  readOnly: true,
                }}
              />
              <TextField
                label="Fumigation Currency"
                name="fumigationCurrency"
                select
                value={invoiceData?.cost?.fumigationCurrency}
                onChange={handleCostTextFieldChange}
                fullWidth
                margin="normal"
              >
                {currencies.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </TextField>
              <TextField
                size="small"
                label="Fumigation Date"
                fullWidth
                name="fumigationDate"
                margin="normal"
                value={
                  invoiceData?.cost?.fumigationDate
                    ? format(
                      parseISO(invoiceData.cost.fumigationDate),
                      "yyyy-MM-dd",
                    )
                    : ""
                }
                id="date"
                type="date"
                inputProps={{ min: "1999-01-01", max: "2999-01-01" }}
                InputLabelProps={{
                  shrink: true,
                }}
                onKeyDown={(e) => e.preventDefault()}
                onChange={(e) => {
                  handleCostTextFieldChange(e);
                }}
              />
            </AccordionDetails>
          </Accordion>

          <Accordion>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography
                sx={{
                  color: isFieldFilled("handling", false)
                    ? "#388e3c"
                    : "inherit",
                  fontWeight: isFieldFilled("handling", false)
                    ? "bold"
                    : "normal",
                }}
              >
                Handling
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <TextField
                label="Handling"
                name="totalHandling"
                onChange={(event) => {
                  handleCostTextFieldChange(event);
                  setInvoiceData((prevInvoiceData) => ({
                    ...prevInvoiceData,
                    cost: {
                      ...prevInvoiceData?.cost,
                      handling: prevInvoiceData?.shipmentRequest
                        ?.shipmentQuantity
                        ? (event.target.value || 0) /
                        prevInvoiceData.shipmentRequest.shipmentQuantity
                        : "",
                    },
                  }));
                }}
                value={
                  invoiceData?.cost?.totalHandling ||
                  Math.round(
                    invoiceData?.cost?.handling *
                    (invoiceData?.shipmentRequest?.shipmentQuantity || 0),
                  ) ||
                  ""
                }
                type="number"
                fullWidth
                margin="normal"
              />
              <TextField
                label="Unit Handling"
                name="handling"
                value={
                  invoiceData?.cost?.totalHandling
                    ? invoiceData?.shipmentRequest?.shipmentQuantity
                      ? (invoiceData?.cost?.totalHandling || 0) /
                      invoiceData.shipmentRequest.shipmentQuantity
                      : ""
                    : invoiceData?.cost?.handling
                      ? invoiceData?.cost?.handling
                      : ""
                }
                type="number"
                fullWidth
                margin="normal"
                InputProps={{
                  readOnly: true,
                }}
              />
              <TextField
                label="Handling Currency"
                name="handlingCurrency"
                select
                value={invoiceData?.cost?.handlingCurrency}
                onChange={handleCostTextFieldChange}
                fullWidth
                margin="normal"
              >
                {currencies.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </TextField>
              <TextField
                size="small"
                label="Handling Date"
                fullWidth
                name="handlingDate"
                margin="normal"
                value={
                  invoiceData?.cost?.handlingDate
                    ? format(
                      parseISO(invoiceData.cost.handlingDate),
                      "yyyy-MM-dd",
                    )
                    : ""
                }
                id="date"
                type="date"
                inputProps={{ min: "1999-01-01", max: "2999-01-01" }}
                InputLabelProps={{
                  shrink: true,
                }}
                onKeyDown={(e) => e.preventDefault()}
                onChange={(e) => {
                  handleCostTextFieldChange(e);
                }}
              />
            </AccordionDetails>
          </Accordion>

          <TextField
            size="small"
            label="ATA*"
            fullWidth
            name="actualTimeOfArrival"
            margin="normal"
            value={
              invoiceData?.actualTimeOfArrival
                ? format(
                  parseISO(invoiceData.actualTimeOfArrival),
                  "yyyy-MM-dd",
                )
                : ""
            }
            id="date"
            type="date"
            inputProps={{ min: "1999-01-01", max: "2999-01-01" }}
            InputLabelProps={{
              shrink: true,
            }}
            onKeyDown={(e) => e.preventDefault()}
            onChange={(e) => {
              handleTextFieldChange(e);
            }}
          />

          {/*<Box
            display="flex"
            flexDirection="column"
            padding="16px"
            border="1px solid #1976d2"
            bgcolor="#e3f2fd"
            borderRadius="8px"
            marginTop="16px"
            marginBottom="16px"
          >
            <Typography variant="body1" sx={{ textDecoration: "underline" }}>
              SAP PO Number:
              {invoiceData?.shipmentRequest?.purchaseOrder?.purchaseOrderNumber
                ? " " +
                invoiceData?.shipmentRequest?.purchaseOrder
                  ?.purchaseOrderNumber
                : ""}
            </Typography>
            <Typography variant="body1" fontWeight="bold">
              Total PO Quantity:
              {invoiceData?.shipmentRequest?.purchaseOrder?.volume
                ? " " +
                invoiceData?.shipmentRequest?.purchaseOrder?.volume.toLocaleString(
                  "en-US",
                ) +
                " " +
                invoiceData?.shipmentRequest?.purchaseOrder?.volumeUnit
                : "-"}
            </Typography>
            <Typography variant="body1" fontWeight="bold">
              Shipped PO Quantity:
              {invoiceData?.shipmentRequest?.purchaseOrder?.volume
                ? " " +
                (
                  (invoiceData?.shipmentRequest?.purchaseOrder?.volume || 0) -
                  (invoiceData?.shipmentRequest?.purchaseOrder
                    ?.remainingQuantity || 0)
                ).toLocaleString("en-US") +
                " " +
                invoiceData?.shipmentRequest?.purchaseOrder?.volumeUnit
                : "-"}
            </Typography>
            <Typography variant="body1" fontWeight="bold">
              Unshipped PO Quantity:
              {invoiceData?.shipmentRequest?.purchaseOrder?.remainingQuantity
                ? " " +
                invoiceData?.shipmentRequest?.purchaseOrder?.remainingQuantity.toLocaleString(
                  "en-US",
                ) +
                " " +
                invoiceData?.shipmentRequest?.purchaseOrder?.volumeUnit
                : "-"}
            </Typography>
            <Typography variant="body1" fontWeight="bold">
              SI Shipment Quantity:
              {invoiceData?.shipmentRequest?.shipmentQuantity
                ? " " +
                invoiceData?.shipmentRequest?.shipmentQuantity.toLocaleString(
                  "en-US",
                ) +
                " " +
                invoiceData?.shipmentRequest?.shipmentQuantityUnit
                : "-"}
            </Typography>
            {invoiceData?.status !== "Closed" &&
              !/^FW.*//*.test(
                invoiceData?.shipmentRequest?.shipmentRequestType,
              ) && (
                <Typography variant="body1" fontWeight="bold" color="#1976d2">
                  Unshipped PO Quantity After SI:
                  {invoiceData?.shipmentRequest?.purchaseOrder
                    ? " " +
                    (
                      (invoiceData?.shipmentRequest?.purchaseOrder
                        ?.remainingQuantity || 0) -
                      (invoiceData?.shipmentRequest?.shipmentQuantity || 0)
                    ).toLocaleString("en-US") +
                    " " +
                    invoiceData?.shipmentRequest?.purchaseOrder?.volumeUnit
                    : "-"}
                </Typography>
              )}
          </Box>   

          <Box
            display="flex"
            flexDirection="column"
            padding="16px"
            border="1px solid #1976d2"
            bgcolor="#e3f2fd"
            borderRadius="8px"
            marginBottom="16px"
          >
            <Typography variant="body1" sx={{ textDecoration: "underline" }}>
              SAP SO Number:
              {invoiceData?.shipmentRequest?.salesOrder?.salesOrderNumber
                ? " " +
                invoiceData?.shipmentRequest?.salesOrder?.salesOrderNumber
                : ""}
            </Typography>
            <Typography variant="body1" fontWeight="bold">
              Total SO Quantity:
              {invoiceData?.shipmentRequest?.salesOrder?.volume
                ? " " +
                invoiceData?.shipmentRequest?.salesOrder?.volume.toLocaleString(
                  "en-US",
                ) +
                " " +
                invoiceData?.shipmentRequest?.salesOrder?.volumeUnit
                : "-"}
            </Typography>
            <Typography variant="body1" fontWeight="bold">
              Shipped SO Quantity:
              {invoiceData?.shipmentRequest?.salesOrder?.volume
                ? " " +
                (
                  (invoiceData?.shipmentRequest?.salesOrder?.volume || 0) -
                  (invoiceData?.shipmentRequest?.salesOrder
                    ?.remainingQuantity || 0)
                ).toLocaleString("en-US") +
                " " +
                invoiceData?.shipmentRequest?.salesOrder?.volumeUnit
                : "-"}
            </Typography>
            <Typography variant="body1" fontWeight="bold">
              Unshipped SO Quantity:
              {invoiceData?.shipmentRequest?.salesOrder?.remainingQuantity
                ? " " +
                invoiceData?.shipmentRequest?.salesOrder?.remainingQuantity.toLocaleString(
                  "en-US",
                ) +
                " " +
                invoiceData?.shipmentRequest?.salesOrder?.volumeUnit
                : "-"}
            </Typography>
            <Typography variant="body1" fontWeight="bold">
              SI Shipment Quantity:
              {invoiceData?.shipmentRequest?.shipmentQuantity
                ? " " +
                invoiceData?.shipmentRequest?.shipmentQuantity.toLocaleString(
                  "en-US",
                ) +
                " " +
                invoiceData?.shipmentRequest?.shipmentQuantityUnit
                : "-"}
            </Typography>
            {invoiceData?.status !== "Closed" && (
              <Typography variant="body1" fontWeight="bold" color="#1976d2">
                Unshipped SO Quantity After SI:
                {invoiceData?.shipmentRequest?.salesOrder
                  ? " " +
                  (
                    (invoiceData?.shipmentRequest?.salesOrder
                      ?.remainingQuantity || 0) -
                    (invoiceData?.shipmentRequest?.shipmentQuantity || 0)
                  ).toLocaleString("en-US") +
                  " " +
                  invoiceData?.shipmentRequest?.salesOrder?.volumeUnit
                  : "-"}
              </Typography>
            )}
          </Box>
          */}

        </DialogContent>
        <DialogActions>
          <Box
            display="flex"
            justifyContent="space-between"
            width="100%"
            padding="16px"
          >
            <OpenShippingInstructionButton
              invoiceData={invoiceData}
              mapShippingInstruction={mapShippingInstruction}
              onSuccessfulOpen={() => {
                window.location.reload();
              }}
            />
            <Box display="flex">
              <Button onClick={() => setCloseDialogOpen(false)} color="error">
                Cancel
              </Button>
              <CloseShippingInstructionButton
                rows={rows}
                setRows={setRows}
                invoiceData={invoiceData}
                mapShippingInstruction={mapShippingInstruction}
                onSuccessfulClose={() => {
                  setCloseDialogOpen(false)
                }}
              />
            </Box>
          </Box>
        </DialogActions>
      </Dialog>

      {addView ? (
        <AddShippingInstruction
          setAddViewStatesArray={setAddViewStatesArray}
          addViewStatesArray={addViewStatesArray}
          setAddViewStates={setAddViewStates}
          addViewStates={addViewStates}
          rows={rows}
          setRows={setRows}
          setAddView={setAddView}
          type={"shippingInstruction"}
          mapFunction={mapShippingInstruction}
        />
      ) : editShipmentRequest.visible ? (
        <EditShipmentRequest
          rows={rows}
          setRows={setRows}
          setAddView={setAddView}
          editShipmentRequest={editShipmentRequest}
          setEditShipmentRequest={setEditShipmentRequest}
        />
      ) : editVendorOrder.visible ? (
        <EditVendorOrder
          rows={rows}
          setRows={setRows}
          setAddView={setAddView}
          editVendorOrder={editVendorOrder}
          setEditVendorOrder={setEditVendorOrder}
        />
      ) : editCustomerOrder.visible ? (
        <EditCustomerOrder
          rows={rows}
          setRows={setRows}
          setAddView={setAddView}
          editCustomerOrder={editCustomerOrder}
          setEditCustomerOrder={setEditCustomerOrder}
        />
      ) : editItem.visible ? (
        <EditItem
          rows={rows}
          setRows={setRows}
          setAddView={setAddView}
          editItem={editItem}
          setEditItem={setEditItem}
        />
      ) : editFreightOffer.visible ? (
        <EditFreightOffer
          rows={rows}
          setRows={setRows}
          setAddView={setAddView}
          editFreightOffer={editFreightOffer}
          setEditFreightOffer={setEditFreightOffer}
        />
      ) : editShippingInstruction.visible ? (
        <EditShippingInstruction
          rows={rows}
          setRows={setRows}
          setAddView={setAddView}
          editShippingInstruction={editShippingInstruction}
          setEditShippingInstruction={setEditShippingInstruction}
          mapShippingInstruction={mapShippingInstruction}
        />
      ) : exportSIPopup.visible ? (
        <ExportShippingInstruction
          setExportSIPopup={setExportSIPopup}
          exportSIPopup={exportSIPopup}
        />
      ) : exportShippingDetailsPopup.visible ? (
        <ExportShippingDetails
          setExportShippingDetailsPopup={setExportShippingDetailsPopup}
          exportShippingDetailsPopup={exportShippingDetailsPopup}
        />
      ) : exportProformaDetailsPopup.visible ? (
        <ExportProformaDetails
          setExportProformaDetailsPopup={setExportProformaDetailsPopup}
          exportProformaDetailsPopup={exportProformaDetailsPopup}
        />
      ) : (
        <>
          {showFilters && (
            <Box
              component="form"
              sx={{
                "& .MuiTextField-root": { m: 1, width: "25ch" },
              }}
              noValidate
              autoComplete="off"
            >
              <Grid
                container
                spacing={1}
                justifyContent="flex-start"
                alignItems="center"
              >

                <Autocomplete
                  multiple
                  id="outlined-select-shipping-instruction"
                  disableClearable
                  open={componentsState.shippingInstruction.dropdownOpen}
                  onOpen={() => updateComponentState("shippingInstruction", { dropdownOpen: true })}
                  inputValue={componentsState.shippingInstruction.inputValue}
                  onInputChange={(event, newInputValue, reason) => {
                    if (reason === "input") {
                      updateComponentState("shippingInstruction", { inputValue: newInputValue });
                    }
                  }}
                  options={[
                    ...rows.filter((shippingInstruction) =>
                      filterShippingInstruction.shippingInstructionIdList.includes(shippingInstruction.id),
                    ),
                    ...rows.filter(
                      (shippingInstruction) => !filterShippingInstruction.shippingInstructionIdList.includes(shippingInstruction.id),
                    ),
                  ]}
                  getOptionLabel={(option) =>
                    `${option?.id || ""} - ${option?.finalShippingInstructionNumber || ""} - ${option?.shipmentRequestType || ""} - Buying Grade: ${option?.purchaseOrderItemId || ""
                    } - ${option?.purchaseOrderItemBuyingGrade || ""
                    } - ${option?.purchaseOrderItemCrop || ""}`
                  }
                  value={rows.filter((shippingInstruction) =>
                    filterShippingInstruction.shippingInstructionIdList.includes(shippingInstruction.id),
                  )}
                  onChange={(event, newValue) => {
                    setFilterShippingInstruction({
                      ...filterShippingInstruction,
                      shippingInstructionIdList: newValue
                        .map((shippingInstruction) => shippingInstruction.id)
                        .filter((id) => id !== null),
                    });
                  }}
                  renderOption={(props, option, { selected }) => (
                    <li
                      {...props}
                      style={{
                        ...props.style,
                        backgroundColor: selected ? "lightblue" : undefined,
                        fontWeight: selected ? 700 : 400,
                      }}
                    >
                      {`${option?.id || ""} - ${option?.finalShippingInstructionNumber || ""} - ${option?.shipmentRequestType || ""} - Buying Grade: ${option?.purchaseOrderItemId || ""
                        } - ${option?.purchaseOrderItemBuyingGrade || ""
                        } - ${option?.purchaseOrderItemCrop || ""}`}
                    </li>
                  )}
                  renderInput={(params) => {
                    const label =
                      filterShippingInstruction?.shippingInstructionIdList.length > 0
                        ? `Shipping Instructions Selected (${filterShippingInstruction?.shippingInstructionIdList.length})`
                        : "Shipping Instrunction";

                    return (
                      <TextField
                        {...params}
                        label={label}
                        type="search"
                        value={componentsState.shippingInstruction.inputValue}
                        onChange={(e) =>
                          updateComponentState("shippingInstruction", { inputValue: e.target.value })
                        }
                        InputProps={{
                          ...params.InputProps,
                          style: { height: 42 },
                        }}
                        onBlur={() =>
                          updateComponentState("shippingInstruction", { dropdownOpen: false })
                        }
                      />
                    );
                  }}
                  renderTags={() => null}
                />

<FilterSelect
        label="Type"
        menuType="shipmentRequestTypes"
        value={filterShippingInstruction.shippingInstructionTypeList || []}
        onChange={(e) =>  setFilterShippingInstruction({
              ...filterShippingInstruction,
              shippingInstructionTypeList: e.target.value,
            })}
        multiple
      />

                <Autocomplete
                  multiple
                  id="outlined-select-shipment-request"
                  disableClearable
                  open={componentsState.shipmentRequest.dropdownOpen}
                  onOpen={() =>
                    updateComponentState("shipmentRequest", {
                      dropdownOpen: true,
                    })
                  }
                  inputValue={componentsState.shipmentRequest.inputValue}
                  onInputChange={(event, newInputValue, reason) => {
                    if (reason === "input") {
                      updateComponentState("shipmentRequest", {
                        inputValue: newInputValue,
                      });
                    }
                  }}
                  options={[
                    ...shipmentRequests.filter((shipmentRequest) =>
                      filterShippingInstruction.shipmentRequestIdList.includes(
                        shipmentRequest.id,
                      ),
                    ),
                    ...shipmentRequests.filter(
                      (shipmentRequest) =>
                        !filterShippingInstruction.shipmentRequestIdList.includes(
                          shipmentRequest.id,
                        ),
                    ),
                  ]}
                  getOptionLabel={(option) => {
                    const values = [
                      option?.id,
                      option?.purchaseOrderNumber
                        ? `SAP PO Number: ${option.purchaseOrderNumber}`
                        : null,
                      option?.purchaseOrderStakeholderName
                        ? `Supplier: ${option.purchaseOrderStakeholderName}`
                        : null,
                      option?.purchaseOrderItemOrigin
                        ? `Origin: ${option.purchaseOrderItemOrigin}`
                        : null,
                      option?.purchaseOrderItemBuyingGrade
                        ? `Buying Grade: ${option.purchaseOrderItemBuyingGrade}`
                        : null,
                    ].filter((value) => value);

                    return values.join(" - ");
                  }}
                  value={shipmentRequests.filter((shipmentRequest) =>
                    filterShippingInstruction.shipmentRequestIdList.includes(
                      shipmentRequest.id,
                    ),
                  )}
                  onChange={(event, newValue) => {
                    setFilterShippingInstruction({
                      ...filterShippingInstruction,
                      shipmentRequestIdList: newValue
                        .map((shipmentRequest) => shipmentRequest.id)
                        .filter((id) => id !== null),
                    });
                  }}
                  renderOption={(props, option, { selected }) => {
                    const values = [
                      option?.id,
                      option?.purchaseOrderNumber
                        ? `SAP PO Number: ${option.purchaseOrderNumber}`
                        : null,
                      option?.purchaseOrderStakeholderName
                        ? `Supplier: ${option.purchaseOrderStakeholderName}`
                        : null,
                      option?.purchaseOrderItemOrigin
                        ? `Origin: ${option.purchaseOrderItemOrigin}`
                        : null,
                      option?.purchaseOrderItemBuyingGrade
                        ? `Buying Grade: ${option.purchaseOrderItemBuyingGrade}`
                        : null,
                    ].filter((value) => value);

                    const optionLabel = values.join(" - ");
                    return (
                      <li
                        {...props}
                        style={{
                          ...props.style,
                          backgroundColor: selected ? "lightblue" : undefined,
                          fontWeight: selected ? 700 : 400,
                        }}
                      >
                        {optionLabel}
                      </li>
                    );
                  }}
                  renderInput={(params) => {
                    const label =
                      filterShippingInstruction?.shipmentRequestIdList.length >
                        0
                        ? `Shipment Requests Selected (${filterShippingInstruction?.shipmentRequestIdList.length})`
                        : "Shipment Request";

                    return (
                      <TextField
                        {...params}
                        label={label}
                        type="search"
                        value={componentsState.shipmentRequest.inputValue}
                        onChange={(e) => {
                          updateComponentState("shipmentRequest", {
                            inputValue: e.target.value,
                          });
                        }}
                        onMouseDown={() => retrieveShipmentRequests()}
                        InputProps={{
                          ...params.InputProps,
                          style: { height: 42 },
                        }}
                        onBlur={() =>
                          updateComponentState("shipmentRequest", {
                            dropdownOpen: false,
                          })
                        }
                      />
                    );
                  }}
                  renderTags={() => null}
                />

                <Autocomplete
                  multiple
                  id="outlined-select-po"
                  disableClearable
                  open={componentsState.purchaseOrder.dropdownOpen}
                  onOpen={() =>
                    updateComponentState("purchaseOrder", {
                      dropdownOpen: true,
                    })
                  }
                  inputValue={componentsState.purchaseOrder.inputValue}
                  onInputChange={(event, newInputValue, reason) => {
                    if (reason === "input") {
                      updateComponentState("purchaseOrder", {
                        inputValue: newInputValue,
                      });
                    }
                  }}
                  options={[
                    ...purchaseOrders.filter((purchaseOrder) =>
                      filterShippingInstruction.purchaseOrderIdList.includes(
                        purchaseOrder.id,
                      ),
                    ),
                    ...purchaseOrders.filter(
                      (purchaseOrder) =>
                        !filterShippingInstruction.purchaseOrderIdList.includes(
                          purchaseOrder.id,
                        ),
                    ),
                  ]}
                  getOptionLabel={(option) =>
                    `ID: ${option?.id || ""}, PO Number: ${option?.purchaseOrderNumber || ""}, Item Buying Grade: ${option?.offerItemBuyingGrade || ""
                    }, 
                       Origin: ${option?.offerItemOrigin || ""}, Crop: ${option?.offerItemCrop || ""
                    }`
                  }
                  value={purchaseOrders.filter((purchaseOrder) =>
                    filterShippingInstruction.purchaseOrderIdList.includes(
                      purchaseOrder.id,
                    ),
                  )}
                  onChange={(event, newValue) => {
                    setFilterShippingInstruction({
                      ...filterShippingInstruction,
                      purchaseOrderIdList: newValue
                        .map((purchaseOrder) => purchaseOrder.id)
                        .filter((id) => id !== null),
                    });
                  }}
                  renderOption={(props, option, { selected }) => (
                    <li
                      {...props}
                      style={{
                        ...props.style,
                        backgroundColor: selected ? "lightblue" : undefined,
                        fontWeight: selected ? 700 : 400,
                      }}
                    >
                      {`ID: ${option?.id || ""}, PO Number: ${option?.purchaseOrderNumber || ""}, Item Buying Grade: ${option?.offerItemBuyingGrade || ""
                        }, 
                       Origin: ${option?.offerItemOrigin || ""}, Crop: ${option?.offerItemCrop || ""
                        }`}
                    </li>
                  )}
                  renderInput={(params) => {
                    const label =
                      filterShippingInstruction?.purchaseOrderIdList.length > 0
                        ? `POs Selected (${filterShippingInstruction?.purchaseOrderIdList.length})`
                        : "PO";

                    return (
                      <TextField
                        {...params}
                        label={label}
                        type="search"
                        value={componentsState.purchaseOrder.inputValue}
                        onChange={(e) => {
                          updateComponentState("purchaseOrder", {
                            inputValue: e.target.value,
                          });
                        }}
                        onMouseDown={() => retrieveOrders("VENDOR")}
                        InputProps={{
                          ...params.InputProps,
                          style: { height: 42 },
                        }}
                        onBlur={() =>
                          updateComponentState("purchaseOrder", {
                            dropdownOpen: false,
                          })
                        }
                      />
                    );
                  }}
                  renderTags={() => null}
                />

<Box sx={{ m: 1, width: "25ch", display: "flex", flexDirection: "column", gap: 0.5 }}>
  <ToggleButtonGroup
    color="primary"
    size="small"
    exclusive
    value={filterShippingInstruction.purchaseOrderStatus}
    onChange={(_, v) => {
      if (v == null) return;
      setFilterShippingInstruction(p => ({ ...p, purchaseOrderStatus: v }));
    }}
    sx={{ width: "100%", display: "flex" }}
  >
    {STATUS_OPTIONS.map(o => (
      <ToggleButton key={o.value} value={o.value} sx={{ flex: 1, fontSize: "0.8rem" }}>
        {o.label}
      </ToggleButton>
    ))}
  </ToggleButtonGroup>
</Box>

{/*
<Select
  value={filterShippingInstruction.purchaseOrderStatus}
  onChange={(e) =>
    setFilterShippingInstruction(p => ({ ...p, purchaseOrderStatus: e.target.value }))
  }
>
  {STATUS_OPTIONS.map(o => (
    <MenuItem key={o.value} value={o.value}>{o.label}</MenuItem>
  ))}
</Select>*/}

                <Autocomplete
                  multiple
                  id="outlined-select-so"
                  disableClearable
                  open={componentsState.salesOrder.dropdownOpen}
                  onOpen={() =>
                    updateComponentState("salesOrder", { dropdownOpen: true })
                  }
                  inputValue={componentsState.salesOrder.inputValue}
                  onInputChange={(event, newInputValue, reason) => {
                    if (reason === "input") {
                      updateComponentState("salesOrder", {
                        inputValue: newInputValue,
                      });
                    }
                  }}
                  options={[
                    ...salesOrders.filter((salesOrder) =>
                      filterShippingInstruction.salesOrderIdList.includes(
                        salesOrder.id,
                      ),
                    ),
                    ...salesOrders.filter(
                      (salesOrder) =>
                        !filterShippingInstruction.salesOrderIdList.includes(
                          salesOrder.id,
                        ),
                    ),
                  ]}
                  getOptionLabel={(option) =>
                    `ID: ${option?.id || ""}, SO Number: ${option?.salesOrderNumber || ""}, Item Buying Grade: ${option?.offerItemBuyingGrade || ""
                    }, 
                                       Origin: ${option?.offerItemOrigin || ""}, Crop: ${option?.offerItemCrop || ""
                    }`
                  }
                  value={salesOrders.filter((salesOrder) =>
                    filterShippingInstruction.salesOrderIdList.includes(
                      salesOrder.id,
                    ),
                  )}
                  onChange={(event, newValue) => {
                    setFilterShippingInstruction({
                      ...filterShippingInstruction,
                      salesOrderIdList: newValue
                        .map((salesOrder) => salesOrder.id)
                        .filter((id) => id !== null),
                    });
                  }}
                  renderOption={(props, option, { selected }) => (
                    <li
                      {...props}
                      style={{
                        ...props.style,
                        backgroundColor: selected ? "lightblue" : undefined,
                        fontWeight: selected ? 700 : 400,
                      }}
                    >
                      {`ID: ${option?.id || ""}, SO Number: ${option?.salesOrderNumber || ""}, Item Buying Grade: ${option?.offerItemBuyingGrade || ""
                        }, 
                                       Origin: ${option?.offerItemOrigin || ""}, Crop: ${option?.offerItemCrop || ""
                        }`}
                    </li>
                  )}
                  renderInput={(params) => {
                    const label =
                      filterShippingInstruction?.salesOrderIdList.length > 0
                        ? `SOs Selected (${filterShippingInstruction?.salesOrderIdList.length})`
                        : "SO";

                    return (
                      <TextField
                        {...params}
                        label={label}
                        type="search"
                        value={componentsState.salesOrder.inputValue}
                        onChange={(e) => {
                          updateComponentState("salesOrder", {
                            inputValue: e.target.value,
                          });
                        }}
                        onMouseDown={() => retrieveOrders("CUSTOMER")}
                        InputProps={{
                          ...params.InputProps,
                          style: { height: 42 },
                        }}
                        onBlur={() =>
                          updateComponentState("salesOrder", {
                            dropdownOpen: false,
                          })
                        }
                      />
                    );
                  }}
                  renderTags={() => null}
                />

<Box sx={{ m: 1, width: "25ch", display: "flex", flexDirection: "column", gap: 0.5 }}>
  <ToggleButtonGroup
    color="primary"
    size="small"
    exclusive
    value={filterShippingInstruction.salesOrderStatus}
    onChange={(_, v) => {
      if (v == null) return;
      setFilterShippingInstruction(p => ({ ...p, salesOrderStatus: v }));
    }}
    sx={{ width: "100%", display: "flex" }}
  >
    {STATUS_OPTIONS.map(o => (
      <ToggleButton key={o.value} value={o.value} sx={{ flex: 1, fontSize: "0.8rem" }}>
        {o.label}
      </ToggleButton>
    ))}
  </ToggleButtonGroup>
</Box>

<FilterSelect
  label="PO Company"
  menuType="companies"
  value={filterShippingInstruction.purchaseOrderCompanyList || []}
  onChange={(e) => setFilterShippingInstruction({
    ...filterShippingInstruction,
    purchaseOrderCompanyList: e.target.value
  })}
  multiple
/>

      <FilterSelect
        label="PO Incoterm"
        menuType="incoterms"
        value={filterShippingInstruction.purchaseOrderIncotermList || []}
        onChange={(e) => {
                      setFilterShippingInstruction({
                        ...filterShippingInstruction,
                        purchaseOrderIncotermList: e.target.value,
                      });
                    }}
        multiple
      />

      <FilterSelect
  label="SO Company"
  menuType="companies"
  value={filterShippingInstruction.salesOrderCompanyList || []}
  onChange={(e) => setFilterShippingInstruction({
    ...filterShippingInstruction,
    salesOrderCompanyList: e.target.value
  })}
  multiple
/>

      <FilterSelect
        label="SO Incoterm"
        menuType="incoterms"
        value={filterShippingInstruction.salesOrderIncotermList || []}
        onChange={(e) => {
                      setFilterShippingInstruction({
                        ...filterShippingInstruction,
                        salesOrderIncotermList: e.target.value,
                      });
                    }}
        multiple
      />

                <TextField
                  id="outlined-number"
                  label="Customer Grade Mark"
                  value={filterShippingInstruction?.shipmentRequestCustomerGradeMark || ""}
                  onChange={(e) =>
                    setFilterShippingInstruction({
                      ...filterShippingInstruction,
                      shipmentRequestCustomerGradeMark: e.target.value,
                    })
                  }
                />

       <Autocomplete
              multiple
              id="outlined-select-customer"
              disableClearable
              open={componentsState.customer.dropdownOpen}
              onOpen={() => updateComponentState("customer", { dropdownOpen: true })}
              inputValue={componentsState.customer.inputValue}
              onInputChange={(event, newInputValue, reason) => {
                if (reason === "input") {
                  updateComponentState("customer", { inputValue: newInputValue });
                }
              }}
              options={customers}
              getOptionLabel={(option) =>
                `${option?.id || ""} - ${option?.name || ""}`
              }
              value={customers.filter((customer) =>
                filterShippingInstruction.customerIdList.includes(customer.id),
              )}
              onChange={(event, newValue) => {
                setFilterShippingInstruction({
                  ...filterShippingInstruction,
                  customerIdList: newValue.map((customer) => customer.id),
                });
              }}
              renderOption={(props, option, { selected }) => (
                <li
                  {...props}
                  style={{
                    ...props.style,
                    backgroundColor: selected ? "lightblue" : undefined,
                    fontWeight: selected ? 700 : 400,
                  }}
                >
                  {`${option?.id || ""} - ${option?.name || ""}`}
                </li>
              )}
              renderInput={(params) => {
                const label =
                  filterShippingInstruction?.customerIdList.length > 0
                    ? `Customers Selected (${filterShippingInstruction?.customerIdList.length})`
                    : "Customer";
      
                return (
                  <TextField
                    {...params}
                    label={label}
                    type="search"
                    value={componentsState.customer.inputValue}
                    onChange={(e) =>
                      updateComponentState("customer", { inputValue: e.target.value })
                    }
                    onMouseDown={retrieveCustomers}
                    InputProps={{
                      ...params.InputProps,
                      style: { height: 42 },
                    }}
                    onBlur={() =>
                      updateComponentState("customer", { dropdownOpen: false })
                    }
                  />
                );
              }}
              renderTags={() => null}
            />
      
                <Autocomplete
                  multiple
                  id="outlined-select-item"
                  disableClearable
                  open={componentsState.item.dropdownOpen}
                  onOpen={() => updateComponentState("item", { dropdownOpen: true })}
                  inputValue={componentsState.item.inputValue}
                  onInputChange={(event, newInputValue, reason) => {
                    if (reason === "input") {
                      updateComponentState("item", { inputValue: newInputValue });
                    }
                  }}
                  options={[
                    ...items.filter((item) =>
                      filterShippingInstruction.itemIdList.includes(item.id),
                    ),
                    ...items.filter(
                      (item) => !filterShippingInstruction.itemIdList.includes(item.id),
                    ),
                  ]}
                  getOptionLabel={(option) =>
                    `${option?.id || ""} - ${option?.buyingGrade || ""} - ${option?.crop || ""
                    } - ${option?.origin || ""}`
                  }
                  value={items.filter((item) =>
                    filterShippingInstruction.itemIdList.includes(item.id),
                  )}
                  onChange={(event, newValue) => {
                    setFilterShippingInstruction({
                      ...filterShippingInstruction,
                      itemIdList: newValue
                        .map((item) => item.id)
                        .filter((id) => id !== null),
                    });
                  }}
                  renderOption={(props, option, { selected }) => (
                    <li
                      {...props}
                      style={{
                        ...props.style,
                        backgroundColor: selected ? "lightblue" : undefined,
                        fontWeight: selected ? 700 : 400,
                      }}
                    >
                      {`${option?.id || ""} - ${option?.buyingGrade || ""} - ${option?.crop || ""
                        } - ${option?.origin || ""}`}
                    </li>
                  )}
                  renderInput={(params) => {
                    const label =
                      filterShippingInstruction?.itemIdList.length > 0
                        ? `Items Selected (${filterShippingInstruction?.itemIdList.length})`
                        : "Item";

                    return (
                      <TextField
                        {...params}
                        label={label}
                        type="search"
                        value={componentsState.item.inputValue}
                        onChange={(e) =>
                          updateComponentState("item", { inputValue: e.target.value })
                        }
                        onMouseDown={() => retrieveItems()}
                        InputProps={{
                          ...params.InputProps,
                          style: { height: 42 },
                        }}
                        onBlur={() =>
                          updateComponentState("item", { dropdownOpen: false })
                        }
                      />
                    );
                  }}
                  renderTags={() => null}
                />

      <FilterSelect
        label="Origin"
        menuType="origin"
        value={filterShippingInstruction?.originList}
        onChange={(e) => setFilterShippingInstruction({
            ...filterShippingInstruction,
            originList: e.target.value,
          })}
        multiple
      />

                <TextField
                  id="outlined-number"
                  label="SI Number"
                  value={
                    filterShippingInstruction?.finalShippingInstructionNumber ||
                    ""
                  }
                  onChange={(e) =>
                    setFilterShippingInstruction({
                      ...filterShippingInstruction,
                      finalShippingInstructionNumber: e.target.value,
                    })
                  }
                />

                <TextField
                  id="date"
                  type="date"
                  label="SI Date"
                  value={
                    filterShippingInstruction?.shippingInstructionDate || ""
                  }
                  onKeyDown={(e) => e.preventDefault()}
                  inputProps={{ min: "1999-01-01", max: "2999-01-01" }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  onChange={(e) =>
                    setFilterShippingInstruction({
                      ...filterShippingInstruction,
                      shippingInstructionDate: e.target.value,
                    })
                  }
                />

      <FilterSelect
        label="Status"
        menuType="shippingInstructionStatus"
        value={filterShippingInstruction.statusList || []}
        onChange={(e) => setFilterShippingInstruction({
                        ...filterShippingInstruction,
                        statusList: e.target.value,
                      })}
        multiple
      />

                <TextField
                  id="date"
                  type="date"
                  label="Date Of Loading"
                  value={filterShippingInstruction?.dateOfLoading || ""}
                  onKeyDown={(e) => e.preventDefault()}
                  inputProps={{ min: "1999-01-01", max: "2999-01-01" }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  onChange={(e) =>
                    setFilterShippingInstruction({
                      ...filterShippingInstruction,
                      dateOfLoading: e.target.value,
                    })
                  }
                />
                <ClickAwayListener
                  onClickAway={() => {
                    if (filterShippingInstruction?.showEtdFields) {
                      setFilterShippingInstruction({
                        ...filterShippingInstruction,
                        showEtdFields: false,
                      });
                    }
                  }}
                >
                  <Box sx={{ position: "relative" }}>
                    <TextField
                      id="etd"
                      type="text"
                      label="ETD"
                      fullWidth
                      variant="outlined"
                      value={
                        filterShippingInstruction?.estimatedTimeOfDepartureFrom && filterShippingInstruction?.estimatedTimeOfDepartureTo
                          ? `${filterShippingInstruction.estimatedTimeOfDepartureFrom}, ${filterShippingInstruction.estimatedTimeOfDepartureTo}`
                          : filterShippingInstruction?.estimatedTimeOfDepartureFrom
                            ? `From ${filterShippingInstruction.estimatedTimeOfDepartureFrom}`
                            : filterShippingInstruction?.estimatedTimeOfDepartureTo
                              ? `To ${filterShippingInstruction.estimatedTimeOfDepartureTo}`
                              : ""
                      }
                      onFocus={() =>
                        setFilterShippingInstruction({
                          ...filterShippingInstruction,
                          showEtdFields: true,
                        })
                      }
                    />
                    {filterShippingInstruction?.showEtdFields && (
                      <Paper
                        elevation={3}
                        sx={{
                          position: "absolute",
                          mt: 1,
                          p: 2,
                          display: "flex",
                          flexDirection: "column",
                          gap: 2,
                          zIndex: 10,
                        }}
                      >
                        <TextField
                          id="etd-from"
                          type="date"
                          label="From"
                          value={filterShippingInstruction?.estimatedTimeOfDepartureFrom || ""}
                          inputProps={{ min: "1999-01-01", max: "2999-01-01" }}
                          InputLabelProps={{ shrink: true }}
                          onKeyDown={(e) => e.preventDefault()}
                          onChange={(e) =>
                            setFilterShippingInstruction({
                              ...filterShippingInstruction,
                              estimatedTimeOfDepartureFrom: e.target.value,
                            })
                          }
                        />
                        <TextField
                          id="etd-to"
                          type="date"
                          label="To"
                          value={filterShippingInstruction?.estimatedTimeOfDepartureTo || ""}
                          inputProps={{ min: "1999-01-01", max: "2999-01-01" }}
                          InputLabelProps={{ shrink: true }}
                          onKeyDown={(e) => e.preventDefault()}
                          onChange={(e) =>
                            setFilterShippingInstruction({
                              ...filterShippingInstruction,
                              estimatedTimeOfDepartureTo: e.target.value,
                            })
                          }
                        />
                        <Button
                          variant="contained"
                          sx={{ mt: 1, alignSelf: "center" }}
                          onClick={() =>
                            setFilterShippingInstruction({
                              ...filterShippingInstruction,
                              showEtdFields: false,
                            })
                          }
                        >
                          Done
                        </Button>
                      </Paper>
                    )}
                  </Box>
                </ClickAwayListener>

                <ClickAwayListener
                  onClickAway={() => {
                    if (filterShippingInstruction?.showEtaFields) {
                      setFilterShippingInstruction({
                        ...filterShippingInstruction,
                        showEtaFields: false,
                      });
                    }
                  }}
                >
                  <Box sx={{ position: "relative" }}>
                    <TextField
                      id="eta"
                      type="text"
                      label="ETA"
                      fullWidth
                      variant="outlined"
                      value={
                        filterShippingInstruction?.estimatedTimeOfArrivalFrom && filterShippingInstruction?.estimatedTimeOfArrivalTo
                          ? `${filterShippingInstruction.estimatedTimeOfArrivalFrom}, ${filterShippingInstruction.estimatedTimeOfArrivalTo}`
                          : filterShippingInstruction?.estimatedTimeOfArrivalFrom
                            ? `From ${filterShippingInstruction.estimatedTimeOfArrivalFrom}`
                            : filterShippingInstruction?.estimatedTimeOfArrivalTo
                              ? `To ${filterShippingInstruction.estimatedTimeOfArrivalTo}`
                              : ""
                      }
                      onFocus={() =>
                        setFilterShippingInstruction({
                          ...filterShippingInstruction,
                          showEtaFields: true,
                        })
                      }
                    />
                    {filterShippingInstruction?.showEtaFields && (
                      <Paper
                        elevation={3}
                        sx={{
                          position: "absolute",
                          mt: 1,
                          p: 2,
                          display: "flex",
                          flexDirection: "column",
                          gap: 2,
                          zIndex: 10,
                        }}
                      >
                        <TextField
                          id="eta-from"
                          type="date"
                          label="From"
                          value={filterShippingInstruction?.estimatedTimeOfArrivalFrom || ""}
                          inputProps={{ min: "1999-01-01", max: "2999-01-01" }}
                          InputLabelProps={{ shrink: true }}
                          onKeyDown={(e) => e.preventDefault()}
                          onChange={(e) =>
                            setFilterShippingInstruction({
                              ...filterShippingInstruction,
                              estimatedTimeOfArrivalFrom: e.target.value,
                            })
                          }
                        />
                        <TextField
                          id="eta-to"
                          type="date"
                          label="To"
                          value={filterShippingInstruction?.estimatedTimeOfArrivalTo || ""}
                          inputProps={{ min: "1999-01-01", max: "2999-01-01" }}
                          InputLabelProps={{ shrink: true }}
                          onKeyDown={(e) => e.preventDefault()}
                          onChange={(e) =>
                            setFilterShippingInstruction({
                              ...filterShippingInstruction,
                              estimatedTimeOfArrivalTo: e.target.value,
                            })
                          }
                        />
                        <Button
                          variant="contained"
                          sx={{ mt: 1, alignSelf: "center" }}
                          onClick={() =>
                            setFilterShippingInstruction({
                              ...filterShippingInstruction,
                              showEtaFields: false,
                            })
                          }
                        >
                          Done
                        </Button>
                      </Paper>
                    )}
                  </Box>
                </ClickAwayListener>

                <Autocomplete
                  multiple
                  id="outlined-select-freight-offer"
                  disableClearable
                  open={componentsState.freightOffer.dropdownOpen}
                  onOpen={() =>
                    updateComponentState("freightOffer", { dropdownOpen: true })
                  }
                  inputValue={componentsState.freightOffer.inputValue}
                  onInputChange={(event, newInputValue, reason) => {
                    if (reason === "input") {
                      updateComponentState("freightOffer", {
                        inputValue: newInputValue,
                      });
                    }
                  }}
                  options={[
                    ...freightOffers.filter((freightOffer) =>
                      filterShippingInstruction.freightOfferIdList.includes(
                        freightOffer.id,
                      ),
                    ),
                    ...freightOffers.filter(
                      (freightOffer) =>
                        !filterShippingInstruction.freightOfferIdList.includes(
                          freightOffer.id,
                        ),
                    ),
                  ]}
                  getOptionLabel={(option) => {
                    const values = [
                      option?.id,
                      option?.forwarder,
                      option?.pointOfLoading,
                      option?.pointOfDischarge,
                      option?.fortyFtRate
                        ? `40Ft: ${option.fortyFtRate} ${option?.fortyFtCurrency || ""
                        }`
                        : null,
                      option?.twentyFtRate
                        ? `20Ft: ${option.twentyFtRate} ${option?.twentyFtCurrency || ""
                        }`
                        : null,
                      option?.transitTime
                        ? `Transit: ${option.transitTime}`
                        : null,
                    ].filter((value) => value);

                    return values.join(" - ");
                  }}
                  value={freightOffers.filter((freightOffer) =>
                    filterShippingInstruction.freightOfferIdList.includes(
                      freightOffer.id,
                    ),
                  )}
                  onChange={(event, newValue) => {
                    setFilterShippingInstruction({
                      ...filterShippingInstruction,
                      freightOfferIdList: newValue
                        .map((freightOffer) => freightOffer.id)
                        .filter((id) => id !== null),
                    });
                  }}
                  renderOption={(props, option, { selected }) => {
                    const values = [
                      option?.id,
                      option?.forwarder,
                      option?.pointOfLoading,
                      option?.pointOfDischarge,
                      option?.fortyFtRate
                        ? `40Ft: ${option.fortyFtRate} ${option?.fortyFtCurrency || ""
                        }`
                        : null,
                      option?.twentyFtRate
                        ? `20Ft: ${option.twentyFtRate} ${option?.twentyFtCurrency || ""
                        }`
                        : null,
                      option?.transitTime
                        ? `Transit: ${option.transitTime}`
                        : null,
                    ].filter((value) => value);

                    const optionLabel = values.join(" - ");

                    return (
                      <li
                        {...props}
                        style={{
                          ...props.style,
                          backgroundColor: selected ? "lightblue" : undefined,
                          fontWeight: selected ? 700 : 400,
                        }}
                      >
                        {optionLabel}
                      </li>
                    );
                  }}
                  renderInput={(params) => {
                    const label =
                      filterShippingInstruction?.freightOfferIdList.length > 0
                        ? `Freight Offers Selected (${filterShippingInstruction?.freightOfferIdList.length})`
                        : "Freight Offer";

                    return (
                      <TextField
                        {...params}
                        label={label}
                        type="search"
                        value={componentsState.freightOffer.inputValue}
                        onChange={(e) => {
                          updateComponentState("freightOffer", {
                            inputValue: e.target.value,
                          });
                        }}
                        onMouseDown={() => retrieveFreightOffers()}
                        InputProps={{
                          ...params.InputProps,
                          style: { height: 42 },
                        }}
                        onBlur={() =>
                          updateComponentState("freightOffer", {
                            dropdownOpen: false,
                          })
                        }
                      />
                    );
                  }}
                  renderTags={() => null}
                />

                <TextField
                  id="outlined-number"
                  label="Transportation Contact"
                  value={filterShippingInstruction?.transportationContact || ""}
                  onChange={(e) =>
                    setFilterShippingInstruction({
                      ...filterShippingInstruction,
                      transportationContact: e.target.value,
                    })
                  }
                />

                <TextField
                  id="outlined-number"
                  label="Carton Number"
                  value={filterShippingInstruction?.cartonNumber || ""}
                  onChange={(e) =>
                    setFilterShippingInstruction({
                      ...filterShippingInstruction,
                      cartonNumber: e.target.value,
                    })
                  }
                />

      <FilterSelect
        label="To Be Shipped By"
        menuType="shippedBy"
        value={filterShippingInstruction.shippedByList || []}
        onChange={(e) =>  setFilterShippingInstruction({
                        ...filterShippingInstruction,
                        shippedByList: e.target.value,
                      })}
        multiple
      />

                <TextField
                  id="outlined-number"
                  label="Bill Of Lading Number"
                  value={filterShippingInstruction?.billOfLadingNumber || ""}
                  onChange={(e) =>
                    setFilterShippingInstruction({
                      ...filterShippingInstruction,
                      billOfLadingNumber: e.target.value,
                    })
                  }
                />

                <ClickAwayListener
                  onClickAway={() => {
                    if (filterShippingInstruction?.showBillOfLadingDateFields) {
                      setFilterShippingInstruction({
                        ...filterShippingInstruction,
                        showBillOfLadingDateFields: false,
                      });
                    }
                  }}
                >
                  <Box sx={{ position: "relative" }}>
                    <TextField
                      id="billOfLadingDate"
                      type="text"
                      label="Bill Of Lading Date"
                      fullWidth
                      variant="outlined"
                      value={
                        filterShippingInstruction?.billOfLadingDateFrom && filterShippingInstruction?.billOfLadingDateTo
                          ? `${filterShippingInstruction.billOfLadingDateFrom}, ${filterShippingInstruction.billOfLadingDateTo}`
                          : filterShippingInstruction?.billOfLadingDateFrom
                            ? `From ${filterShippingInstruction.billOfLadingDateFrom}`
                            : filterShippingInstruction?.billOfLadingDateTo
                              ? `To ${filterShippingInstruction.billOfLadingDateTo}`
                              : ""
                      }
                      onFocus={() =>
                        setFilterShippingInstruction({
                          ...filterShippingInstruction,
                          showBillOfLadingDateFields: true,
                        })
                      }
                    />
                    {filterShippingInstruction?.showBillOfLadingDateFields && (
                      <Paper
                        elevation={3}
                        sx={{
                          position: "absolute",
                          mt: 1,
                          p: 2,
                          display: "flex",
                          flexDirection: "column",
                          gap: 2,
                          zIndex: 10,
                        }}
                      >
                        <TextField
                          id="billOfLadingDate-from"
                          type="date"
                          label="From"
                          value={filterShippingInstruction?.billOfLadingDateFrom || ""}
                          inputProps={{ min: "1999-01-01", max: "2999-01-01" }}
                          InputLabelProps={{ shrink: true }}
                          onKeyDown={(e) => e.preventDefault()}
                          onChange={(e) =>
                            setFilterShippingInstruction({
                              ...filterShippingInstruction,
                              billOfLadingDateFrom: e.target.value,
                            })
                          }
                        />
                        <TextField
                          id="billOfLadingDate-to"
                          type="date"
                          label="To"
                          value={filterShippingInstruction?.billOfLadingDateTo || ""}
                          inputProps={{ min: "1999-01-01", max: "2999-01-01" }}
                          InputLabelProps={{ shrink: true }}
                          onKeyDown={(e) => e.preventDefault()}
                          onChange={(e) =>
                            setFilterShippingInstruction({
                              ...filterShippingInstruction,
                              billOfLadingDateTo: e.target.value,
                            })
                          }
                        />
                        <Button
                          variant="contained"
                          sx={{ mt: 1, alignSelf: "center" }}
                          onClick={() =>
                            setFilterShippingInstruction({
                              ...filterShippingInstruction,
                              showBillOfLadingDateFields: false,
                            })
                          }
                        >
                          Done
                        </Button>
                      </Paper>
                    )}
                  </Box>
                </ClickAwayListener>

                <TextField
                  id="outlined-number"
                  label="CMR Number"
                  value={filterShippingInstruction?.cmrNumber || ""}
                  onChange={(e) =>
                    setFilterShippingInstruction({
                      ...filterShippingInstruction,
                      cmrNumber: e.target.value,
                    })
                  }
                />

                   <ClickAwayListener
                  onClickAway={() => {
                    if (filterShippingInstruction?.showCmrDateFields) {
                      setFilterShippingInstruction({
                        ...filterShippingInstruction,
                        showCmrDateFields: false,
                      });
                    }
                  }}
                >
                  <Box sx={{ position: "relative" }}>
                    <TextField
                      id="cmrDate"
                      type="text"
                      label="CMR Date"
                      fullWidth
                      variant="outlined"
                      value={
                        filterShippingInstruction?.cmrDateFrom && filterShippingInstruction?.cmrDateTo
                          ? `${filterShippingInstruction.cmrDateFrom}, ${filterShippingInstruction.cmrDateTo}`
                          : filterShippingInstruction?.cmrDateFrom
                            ? `From ${filterShippingInstruction.cmrDateFrom}`
                            : filterShippingInstruction?.cmrDateTo
                              ? `To ${filterShippingInstruction.cmrDateTo}`
                              : ""
                      }
                      onFocus={() =>
                        setFilterShippingInstruction({
                          ...filterShippingInstruction,
                          showCmrDateFields: true,
                        })
                      }
                    />
                    {filterShippingInstruction?.showCmrDateFields && (
                      <Paper
                        elevation={3}
                        sx={{
                          position: "absolute",
                          mt: 1,
                          p: 2,
                          display: "flex",
                          flexDirection: "column",
                          gap: 2,
                          zIndex: 10,
                        }}
                      >
                        <TextField
                          id="cmrDate-from"
                          type="date"
                          label="From"
                          value={filterShippingInstruction?.cmrDateFrom || ""}
                          inputProps={{ min: "1999-01-01", max: "2999-01-01" }}
                          InputLabelProps={{ shrink: true }}
                          onKeyDown={(e) => e.preventDefault()}
                          onChange={(e) =>
                            setFilterShippingInstruction({
                              ...filterShippingInstruction,
                              cmrDateFrom: e.target.value,
                            })
                          }
                        />
                        <TextField
                          id="cmrDate-to"
                          type="date"
                          label="To"
                          value={filterShippingInstruction?.cmrDateTo || ""}
                          inputProps={{ min: "1999-01-01", max: "2999-01-01" }}
                          InputLabelProps={{ shrink: true }}
                          onKeyDown={(e) => e.preventDefault()}
                          onChange={(e) =>
                            setFilterShippingInstruction({
                              ...filterShippingInstruction,
                              cmrDateTo: e.target.value,
                            })
                          }
                        />
                        <Button
                          variant="contained"
                          sx={{ mt: 1, alignSelf: "center" }}
                          onClick={() =>
                            setFilterShippingInstruction({
                              ...filterShippingInstruction,
                              showCmrDateFields: false,
                            })
                          }
                        >
                          Done
                        </Button>
                     </Paper>
                     )}
                   </Box>
                 </ClickAwayListener>
                <Autocomplete
                  multiple
                  id="outlined-select-warehouse"
                  disableClearable
                  open={componentsState.warehouse.dropdownOpen}
                  onOpen={() =>
                    updateComponentState("warehouse", { dropdownOpen: true })
                  }
                  inputValue={componentsState.warehouse.inputValue}
                  onInputChange={(event, newInputValue, reason) => {
                    if (reason === "input") {
                      updateComponentState("warehouse", {
                        inputValue: newInputValue,
                      });
                    }
                  }}
                  options={warehouses}
                  getOptionLabel={(option) =>
                    `${option?.id || ""} - ${option?.code || ""} - ${option?.name || ""
                    }`
                  }
                  value={warehouses.filter((warehouse) =>
                    filterShippingInstruction?.warehouseList?.includes(
                      warehouse.name,
                    ),
                  )}
                  onChange={(event, newValue) => {
                    setFilterShippingInstruction({
                      ...filterShippingInstruction,
                      warehouseList: newValue.map(
                        (warehouse) => warehouse.name,
                      ),
                    });
                  }}
                  renderOption={(props, option, { selected }) => (
                    <li
                      {...props}
                      style={{
                        ...props.style,
                        backgroundColor: selected ? "lightblue" : undefined,
                        fontWeight: selected ? 700 : 400,
                      }}
                    >
                      {`${option?.id || ""} - ${option?.code || ""} - ${option?.name || ""
                        }`}
                    </li>
                  )}
                  renderInput={(params) => {
                    const label =
                      filterShippingInstruction?.warehouseList?.length > 0
                        ? `Warehouses Selected (${filterShippingInstruction?.warehouseList?.length})`
                        : "Warehouse";

                    return (
                      <TextField
                        {...params}
                        label={label}
                        type="search"
                        value={componentsState.warehouse.inputValue}
                        onChange={(e) =>
                          updateComponentState("warehouse", {
                            inputValue: e.target.value,
                          })
                        }
                        onMouseDown={retrieveWarehouse}
                        InputProps={{
                          ...params.InputProps,
                          style: { height: 42 },
                        }}
                        onBlur={() =>
                          updateComponentState("warehouse", {
                            dropdownOpen: false,
                          })
                        }
                      />
                    );
                  }}
                  renderTags={() => null}
                />

                <Autocomplete
                  multiple
                  id="outlined-select-destination"
                  disableClearable
                  open={componentsState.destination.dropdownOpen}
                  onOpen={() =>
                    updateComponentState("destination", { dropdownOpen: true })
                  }
                  inputValue={componentsState.destination.inputValue}
                  onInputChange={(event, newInputValue, reason) => {
                    if (reason === "input") {
                      updateComponentState("destination", {
                        inputValue: newInputValue,
                      });
                    }
                  }}
                  options={destinations}
                  getOptionLabel={(option) =>
                    `${option?.id || ""} - ${option?.code || ""} - ${option?.name || ""
                    }`
                  }
                  value={destinations.filter((destination) =>
                    filterShippingInstruction?.destinationList?.includes(
                      destination.name,
                    ),
                  )}
                  onChange={(event, newValue) => {
                    setFilterShippingInstruction({
                      ...filterShippingInstruction,
                      destinationList: newValue.map(
                        (destination) => destination.name,
                      ),
                    });
                  }}
                  renderOption={(props, option, { selected }) => (
                    <li
                      {...props}
                      style={{
                        ...props.style,
                        backgroundColor: selected ? "lightblue" : undefined,
                        fontWeight: selected ? 700 : 400,
                      }}
                    >
                      {`${option?.id || ""} - ${option?.code || ""} - ${option?.name || ""
                        }`}
                    </li>
                  )}
                  renderInput={(params) => {
                    const label =
                      filterShippingInstruction?.destinationList?.length > 0
                        ? `Destinations Selected (${filterShippingInstruction?.destinationList?.length})`
                        : "Destination";

                    return (
                      <TextField
                        {...params}
                        label={label}
                        type="search"
                        value={componentsState.destination.inputValue}
                        onChange={(e) =>
                          updateComponentState("destination", {
                            inputValue: e.target.value,
                          })
                        }
                        onMouseDown={retrieveWarehouse}
                        InputProps={{
                          ...params.InputProps,
                          style: { height: 42 },
                        }}
                        onBlur={() =>
                          updateComponentState("destination", {
                            dropdownOpen: false,
                          })
                        }
                      />
                    );
                  }}
                  renderTags={() => null}
                />

                 <FilterSelect
                   label="Port Of Loading"
                   menuType="portsOfLoading"
                   value={filterShippingInstruction.pointOfLoadingList || []}
                   onChange={(e) =>  setFilterShippingInstruction({
                        ...filterShippingInstruction,
                        pointOfLoadingList: e.target.value,
                      })}
                   multiple
                 />

                <FilterSelect
                  label="Port Of Unloading"
                  menuType="portsOfDischarge"
                  value={filterShippingInstruction.pointOfUnloadingList || []}
                  onChange={(e) =>  setFilterShippingInstruction({
                        ...filterShippingInstruction,
                        pointOfUnloadingList: e.target.value,
                      })}
                  multiple
                />

                <TextField
                  id="outlined-search"
                  label="Description"
                  value={filterShippingInstruction?.description || ""}
                  type="search"
                  onChange={(e) =>
                    setFilterShippingInstruction({
                      ...filterShippingInstruction,
                      description: e.target.value,
                    })
                  }
                />

                <TextField
                  id="outlined-search"
                  label="Remark"
                  value={filterShippingInstruction?.remark || ""}
                  type="search"
                  onChange={(e) =>
                    setFilterShippingInstruction({
                      ...filterShippingInstruction,
                      remark: e.target.value,
                    })
                  }
                />

                   <FilterSelect
                     label="Record Status"
                     menuType="recordStatus"
                     value={filterShippingInstruction.recordStatusList || []}
                     onChange={(e) =>   setFilterShippingInstruction({
                        ...filterShippingInstruction,
                        recordStatusList: e.target.value,
                      })}
                     multiple
                   />

                        <MyFilters
                          componentName="ShippingInstructionView"
                          filterState={filterShippingInstruction}
                          onApply={(saved) => setFilterShippingInstruction(saved)}
                        />
              </Grid>
              <br></br>
              <Grid
                container
                spacing={2}
                justifyContent="flex-start"
                alignItems="center"
              >
                <Grid item xs={3} sm={1}>
                  <Button
                    disableElevation
                    variant="contained"
                    fullWidth
                    onClick={() => {
                      retrieveFastFilteredShippingInstructionsApi(
                        filterShippingInstruction,
                      )
                        .then((response) => {
                          setRows(response?.data);
                        })
                        .catch((error) => {
                          console.log(error?.response?.data);
                        });
                    }}
                  >
                    Search
                  </Button>
                </Grid>
                <Grid item xs={3} sm={1}>
                  <Button
                    disableElevation
                    variant="outlined"
                    fullWidth
                    onClick={() => {
                      setFilterShippingInstruction({
                        id: 0,
                        shipmentRequestIdList: [],
                        shippingInstructionTypeList: [],
                        shippingInstructionNumber: null,
                        shippingInstructionDate: "",
                        dateOfLoading: "",
                        purchaseOrderIdList: [],
                        salesOrderIdList: [],
                        purchaseOrderCompanyList: [],
                        salesOrderCompanyList: [],
                        purchaseOrderIncotermList: [],
                        salesOrderIncotermList: [],
                        freightOfferIdList: [],
                        transportationContact: "",
                        shipmentRequestCustomerGradeMark: "",
                        cartonNumber: "",
                        finalShippingInstructionNumber: "",
                        shippedByList: [],
                        billOfLadingNumber: "",
                        showBillOfLadingDateFields: false,
                        billOfLadingDateFrom: null,
                        billOfLadingDateTo: null,
                        cmrNumber: "",
                        showCmrDateFields: false,
                        cmrDateFrom: null,
                        cmrDateTo: null,
                        showEtdFields: false,
                        estimatedTimeOfDepartureFrom: null,
                        estimatedTimeOfDepartureTo: null,
                        showEtaFields: false,
                        estimatedTimeOfArrivalFrom: null,
                        estimatedTimeOfArrivalTo: null,
                        shipperIdList: [],
                        consigneeIdList: [],
                        notifyIdList: [],
                        pointOfLoadingList: [],
                        pointOfUnloadingList: [],
                        destinationList: [],
                        warehouseList: [],
                        description: "",
                        remark: "",
                        statusList: [],
                        itemIdList: [],
                        shippingInstructionIdList: [],
                        recordStatusList: ["ACTIVE"],
                        originList: [],
                        customerIdList: [],
                      });
                    }}
                  >
                    Clear Filters
                  </Button>
                </Grid>
              </Grid>
            </Box>
          )}

          <Box sx={{ width: "100%", mt: 2 }}>
            <Paper sx={{ width: "100%", mb: 2 }}>
              <EnhancedTableToolbar
                numSelected={selected.length}
                showFilters={showFilters}
                setShowFilters={setShowFilters}
                setAddView={setAddView}
                selected={selected}
                setExportSIPopup={setExportSIPopup}
                exportSIPopup={exportSIPopup}
                setExportShippingDetailsPopup={setExportShippingDetailsPopup}
                exportShippingDetailsPopup={exportShippingDetailsPopup}
                setExportProformaDetailsPopup={setExportProformaDetailsPopup}
                exportProformaDetailsPopup={exportProformaDetailsPopup}
                selectedData={selectedData}
                visibleColumns={visibleColumns}
                setVisibleColumns={setVisibleColumns}
                selectedColumns={selectedColumns}
                setSelectedColumns={setSelectedColumns}
                selectColumnsDialogOpen={selectColumnsDialogOpen}
                setSelectColumnsDialogOpen={setSelectColumnsDialogOpen}
                columnsOrder={columnsOrder}
                setColumnsOrder={setColumnsOrder}
                filterShippingInstruction={filterShippingInstruction}
                setFilterShippingInstruction={setFilterShippingInstruction}
                rows={rows}
                setRows={setRows}
              />
              <ShippingInstructionTable
                visibleRows={visibleRows}
                dense={dense}
                isSelected={isSelected}
                handleClick={handleClick}
                emptyRows={emptyRows}
                visibleColumns={visibleColumns}
                order={order}
                orderBy={orderBy}
                onRequestSort={handleRequestSort}
                numSelected={selected.length}
                rowCount={rows.length}
                onSelectAllClick={handleSelectAllClick}
                setEditShippingInstruction={setEditShippingInstruction}
                retrieveShippingInstructionByIdApi={retrieveShippingInstructionByIdApi}
                setInvoiceData={setInvoiceData}
                setCloseDialogOpen={setCloseDialogOpen}
                setUploadDialogOpen={setUploadDialogOpen}
                cancelShippingInstruction={cancelShippingInstruction}
                loadingRecord={loadingRecord}
                setEditCustomerOrder={setEditCustomerOrder}
                setEditItem={setEditItem}
                setEditShipmentRequest={setEditShipmentRequest}
                setEditFreightOffer={setEditFreightOffer}
                setEditVendorOrder={setEditVendorOrder}
                handleDepartureCellClick={handleDepartureCellClick}
                isAdditionalDepartureTimesVisible={isAdditionalDepartureTimesVisible}
                handleToggleAllocations={handleToggleAllocations}
                batchCountMap={batchCountMap}
                // allocation details are handled via dialog in parent
              />
              {/*<TableContainer style={{ maxHeight: 700 }}>
                <Table
                  stickyHeader
                  aria-label="sticky table"
                  sx={{
                    minWidth: 750,
                    "& .MuiTableCell-root": {
                      borderRight: "1px solid rgba(224, 224, 224, 1)",
                    },
                    "& .MuiTableCell-head": {
                      backgroundColor: "#20315d",
                      color: "white",
                      borderRight: "1px solid rgba(49, 64, 128, 1)",
                    },
                  }}
                  aria-labelledby="tableTitle"
                  size={dense ? "small" : "medium"}
                  style={{ width: "max-content" }}
                >
                  <EnhancedTableHead
                    numSelected={selected.length}
                    order={order}
                    orderBy={orderBy}
                    onSelectAllClick={handleSelectAllClick}
                    onRequestSort={handleRequestSort}
                    rowCount={rows.length}
                    visibleColumns={visibleColumns}
                  />
                  <TableBody>
                    {visibleRows.map((row, index) => {
                      const isItemSelected = isSelected(row.id);
                      const labelId = `enhanced-table-checkbox-${index}`;

                      return (
                        <React.Fragment key={row.id}>
                        <TableRow
                          style={
                            isSelected(row.id)
                              ? { background: "#d7e7fc" }
                              : row?.status === "Closed"
                              ? { background: "#c8e6c9" }
                              : index % 2
                              ? { background: "#f0f0f0" }
                              : { background: "white" }
                          }
                          hover
                          onClick={(event) => handleClick(event, row.id, row)}
                          role="checkbox"
                          aria-checked={isItemSelected}
                          tabIndex={-1}
                          key={row.id}
                          selected={isItemSelected}
                          sx={{ cursor: "pointer" }}
                        >
                          <TableCell padding="checkbox">
                            <Checkbox
                              color="primary"
                              checked={isItemSelected}
                              inputProps={{
                                "aria-labelledby": labelId,
                              }}
                            />
                          </TableCell>
                          <TableCell padding="checkbox">
                            <Button
                              size="small"
                              onClick={(event) => handleToggleAllocations(event, row)}
                            >
                              {expandedSiId === row.id ? "▲" : "▼"}
                            </Button>
                          </TableCell>
                          {visibleColumns.includes('editButton') && <TableCell padding="normal">
                            <Tooltip
                              title={
                                row?.status === "Cancelled"
                                  ? "Cancelled SIs cannot be edited."
                                  : ""
                              }
                              componentsProps={{
                                tooltip: {
                                  sx: {
                                    fontSize: "1rem",
                                  },
                                },
                              }}
                            >
                              <span style={{ display: "inline-block" }}>
                                <Button
                                  disabled={row?.status === "Cancelled"}
                                  onClick={(e) => {
                                    if (!row?.id) {
                                      alert("Please refresh the page.");
                                      return;
                                    }
                                    if (row?.status !== "Cancelled") {
                                      setEditShippingInstruction({
                                        visible: true,
                                        data: row,
                                        index: index,
                                      });
                                    }
                                    e.preventDefault();
                                  }}
                                >
                                  Edit
                                </Button>
                              </span>
                            </Tooltip>
                          </TableCell>}

                          {visibleColumns.includes('closeSiButton') && <TableCell padding="normal">
                            <Button
                              disabled={row?.status === "Cancelled"}
                              variant="outlined"
                              onClick={(e) => {
                                if (!row?.id) {
                                  alert("Please refresh the page.");
                                  return;
                                }
                                e.preventDefault();
                                const {
                                  siFolderLink,
                                  containsARInvoice,
                                  containsSupplierInvoice,
                                  containsInsurance,
                                  containsFreight,
                                  containsBLLink,
                                  containsWeightListLink,
                                  billOfLadingNumber,
                                  goodsReceiptNumber,
                                  landedCostNumber,
                                  deliveryNumber,
                                  bookingNumber,
                                  shippingLine,
                                  vesselName,
                                  voyageNumber,
                                } = row;

                                const missingFields = [];

                                if (!siFolderLink)
                                  missingFields.push("SI Folder Link");
                                if (!containsARInvoice)
                                  missingFields.push("AR Invoice");
                                if (!containsSupplierInvoice)
                                  missingFields.push("Supplier Invoice");
                                if (!containsInsurance)
                                  missingFields.push("Insurance Link");
                                if (!containsFreight)
                                  missingFields.push("Freight Link");
                                if (!containsBLLink)
                                  missingFields.push("BL Link");
                                if (!billOfLadingNumber)
                                  missingFields.push("BL Number");
                                if (!containsWeightListLink)
                                  missingFields.push("Weight List Link");
                                if (!goodsReceiptNumber)
                                  missingFields.push("GR Number");
                                if (!landedCostNumber)
                                  missingFields.push("LC Number");
                                if (!deliveryNumber)
                                  missingFields.push("Del Number");
                                if (!bookingNumber)
                                  missingFields.push("Booking Number");
                                if (!shippingLine)
                                  missingFields.push("Shipping Line");
                                if (!vesselName)
                                  missingFields.push("Vessel Name");
                                if (!voyageNumber)
                                  missingFields.push("Voyage Number");

                                if (missingFields.length > 0) {
                                  const warningMessage = `The following fields are missing:\n\n ${missingFields.join(
                                    ",\n ",
                                  )}.\n\n Do you still want to close the SI?`;

                                  if (!window.confirm(warningMessage)) {
                                    return;
                                  }
                                }
                                retrieveShippingInstructionByIdApi(row?.id)
                                 .then((response) => {
                                   setInvoiceData(response?.data);
                                   setCloseDialogOpen(true);
                                 })
                                 .catch((error) => {
                                   console.log(error.response?.data);
                                   window.alert("Failed to retrieve shipping instructions. Please try again later.");
                                 });
                              }}
                            >
                              Close SI
                            </Button>
                          </TableCell>}
                          {visibleColumns.includes('uploadFileButton') && <TableCell padding="normal">
                            <Button
                              disabled={row?.status === "Cancelled"}
                              variant="outlined"
                              onClick={(e) => {
                                if (!row?.id) {
                                  alert("Please refresh the page.");
                                  return;
                                }
                                retrieveShippingInstructionByIdApi(row?.id)
                                .then((response) => {
                                 setInvoiceData(response?.data);
                                 setUploadDialogOpen(true);
                                })
                                .catch((error) => {console.log(error.response?.data);
                                  window.alert("Failed to retrieve shipping instructions. Please try again later.");
                                })
                              }}
                            >
                              Upload File
                            </Button>
                          </TableCell>}
                          {visibleColumns.includes('historyButton') && <TableCell align="center">
                            <ShippingInstructionHistoryButton
                              fetchHistoryApi={
                                retrieveFilteredShippingInstructionsApi
                              }
                              currentRow={row}
                            />
                          </TableCell>}
                          {visibleColumns.includes('cancelShippingInstructionButton') && <TableCell padding="normal">
                          {loadingRecord === row?.id ? (
                             <ClipLoader color="#000000" loadingRecord={loadingRecord} size={35} />
                              ) : (
                            <Tooltip
                              title={
                                row?.recordStatus === "PASSIVE" ||
                                row?.status === "Closed"
                                  ? "Closed SIs cannot be cancelled. Please open it first."
                                  : row?.status === "Cancelled"
                                  ? "SI already cancelled."
                                  : ""
                              }
                              arrow
                            >
                              <span>
                                <Button
                                  style={{ whiteSpace: "nowrap" }}
                                  variant="outlined"
                                  color="warning"
                                  disabled={
                                    row?.recordStatus === "PASSIVE" ||
                                    row?.status === "Closed" ||
                                    row?.status === "Cancelled"
                                  }
                                  onClick={() => {
                                    if (!row?.id) {
                                      alert("Please refresh the page.");
                                      return;
                                    }
                                    if (
                                      window.confirm(
                                        `Are you sure you want to cancel SI ${
                                          row?.finalShippingInstructionNumber ||
                                          ""
                                        }`,
                                      )
                                    ) {
                                      retrieveShippingInstructionByIdApi(row?.id)
                                      .then((response) => {
                                        cancelShippingInstruction(response?.data);
                                      })
                                      .catch((error) => {console.log(error.response?.data);
                                        window.alert("Failed to retrieve shipping instruction. Please try again later.");
                                      })
                                    }
                                  }}
                                >
                                  Cancel SI
                                </Button>
                              </span>
                            </Tooltip>
                            )}
                          </TableCell>}
                          {visibleColumns.includes('id') && <TableCell
                            align="center"
                            sx={{
                              position: "sticky",
                              left: 0,
                              background: "inherit",
                              zIndex: 1,
                            }}
                          >
                            {row?.id}
                          </TableCell>}
                          {visibleColumns.includes('shipmentRequestId') && <TableCell align="center">
                          <ShipmentRequestButton
                              row={row}
                              id={row?.shipmentRequestId}
                              setEditShipmentRequest={setEditShipmentRequest}
                            />
                          </TableCell>}
                          {visibleColumns.includes('shipmentRequestType') && <TableCell align="center" id="tableCellId1">
                            {row?.shipmentRequestType}
                          </TableCell>}
                          {visibleColumns.includes('shipmentQuantity') && <TableCell align="center">
                            {row?.shipmentQuantity
                              ? `${new Intl.NumberFormat("en-US", {
                                  style: "decimal",
                                  minimumFractionDigits: 2,
                                }).format(
                                  row.shipmentQuantity,
                                )} ${
                                  row?.shipmentQuantityUnit
                                }`
                              : ""}
                          </TableCell>}
                          {visibleColumns.includes('shipmentRequestStorageQuantity') && <TableCell align="center">
                            {row?.shipmentRequestStorageQuantity
                              ? `${new Intl.NumberFormat("en-US", {
                                  style: "decimal",
                                  minimumFractionDigits: 2,
                                }).format(row.shipmentRequestStorageQuantity)}`
                              : ""}
                          </TableCell>}
                          {visibleColumns.includes('finalShippingInstructionNumber') && <TableCell
                            align="center"
                            sx={{
                              position: "sticky",
                              left: 50,
                              background: "inherit",
                              zIndex: 1,
                                }`
                              : ""}
                          </TableCell>}
                        </TableRow>
                        {expandedSiId === row.id && (
                          <TableRow>
                            <TableCell colSpan={visibleColumns.length + 2}>
                              {expandedSiAllocations && expandedSiAllocations.length > 0 ? (
                                <Table size="small">
                                  <TableHead>
                                    <TableRow>
                                      <TableCell align="center">Allocation ID</TableCell>
                                      <TableCell align="center">Batch</TableCell>
                                      <TableCell align="center">Allocated Qty (kg)</TableCell>
                                      <TableCell align="center">Allocated Value (EUR)</TableCell>
                                    </TableRow>
                                  </TableHead>
                                  <TableBody>
                                    {expandedSiAllocations.map((alloc) => (
                                      <TableRow key={alloc.id}>
                                        <TableCell align="center">{alloc.id}</TableCell>
                                        <TableCell align="center">{alloc.batchNumber || alloc.batchId}</TableCell>
                                        <TableCell align="center">{alloc.allocatedQuantityKg}</TableCell>
                                        <TableCell align="center">{alloc.allocatedValueEur}</TableCell>
                                      </TableRow>
                                    ))}
                                  </TableBody>
                                </Table>
                              ) : (
                                <span>No batch allocations for this SI.</span>
                              )}
                            </TableCell>
                          </TableRow>
                        )}
                        </React.Fragment>
                          </TableCell>}
                          {visibleColumns.includes('shippingInstructionDate') && <TableCell align="center">
                            {row?.shippingInstructionDate
                              ? format(
                                  new Date(row?.shippingInstructionDate),
                                  "dd/MM/yyyy",
                                )
                              : ""}
                          </TableCell>}
                          {visibleColumns.includes('shipmentRequestTo') && <TableCell align="center">
                            {row?.shipmentRequestTo}
                          </TableCell>}
                          {visibleColumns.includes('purchaseOrderId') && <TableCell align="center">
                          <OrderButton
                              row={row}
                              id={row?.purchaseOrderId}
                              setEditOrder={setEditVendorOrder}
                            />
                          </TableCell> }
                          {visibleColumns.includes('purchaseOrderCompany') && <TableCell align="center">
                            {row?.purchaseOrderCompany}
                          </TableCell> }
                          {visibleColumns.includes('purchaseOrderNumber') && <TableCell align="center">
                            {
                              row?.purchaseOrderNumber
                            }
                          </TableCell>}
                          {visibleColumns.includes('purchaseOrderIncoterm') && <TableCell align="center">
                            {row?.purchaseOrderIncoterm}
                          </TableCell>}
                          {visibleColumns.includes('salesOrderId') && <TableCell align="center">
                          <OrderButton
                              row={row}
                              id={row?.salesOrderId}
                              setEditOrder={setEditCustomerOrder}
                            />
                          </TableCell>}
                          {visibleColumns.includes('salesOrderCompany') && <TableCell align="center">
                            {row?.salesOrderCompany}
                          </TableCell>}
                          {visibleColumns.includes('salesOrderNumber') && <TableCell align="center">
                            {row?.salesOrderNumber}
                          </TableCell>}
                          {visibleColumns.includes('salesOrderIncoterm') && <TableCell align="center">
                            {row?.salesOrderIncoterm}
                          </TableCell>}
                          {visibleColumns.includes('itemId') && <TableCell align="center">
                          <ItemButton
                              row={row}
                              id={row?.salesOrderItemId ||
                                row?.purchaseOrderItemId ||
                                ""}
                              setEditItem={setEditItem}
                            />
                          </TableCell>}
                          {visibleColumns.includes('supplierGradeMark') && <TableCell align="center">
                            {row?.salesOrderItemBuyingGrade ||
                              row?.purchaseOrderItemBuyingGrade ||
                              ""}
                          </TableCell>}
                          {visibleColumns.includes('shipmentRequestCustomerGradeMark') && <TableCell align="center">
                            {row?.shipmentRequestCustomerGradeMark}
                          </TableCell>}
                          {visibleColumns.includes('origin') && <TableCell align="center">
                            {row?.salesOrderItemOrigin ||
                            row?.purchaseOrderItemOrigin }
                          </TableCell>}
                          {visibleColumns.includes('type') && <TableCell align="center">
                            {row?.salesOrderItemType ||
                            row?.purchaseOrderItemType }
                          </TableCell>}
                          {visibleColumns.includes('crop') && <TableCell align="center">
                            {row?.salesOrderItemCrop ||
                            row?.purchaseOrderItemCrop }
                          </TableCell>}
                          {visibleColumns.includes('dateOfLoadingRemark') && <TableCell align="center">
                            {row?.dateOfLoadingRemark}
                          </TableCell>}
                          {visibleColumns.includes('warehouse') && <TableCell align="center">{row?.warehouse}
                          </TableCell>}
                          {visibleColumns.includes('destination') && <TableCell align="center">
                            {row?.destination}
                          </TableCell>}
                          {visibleColumns.includes('pointOfLoading') && <TableCell align="center">
                            {row?.pointOfLoading}
                          </TableCell>}
                          {visibleColumns.includes('pointOfUnloading') && <TableCell align="center">
                            {row?.pointOfUnloading}
                          </TableCell>}
                          {visibleColumns.includes('freightOfferId') && <TableCell align="center">
                          <FreightOfferButton
                              row={row}
                              id={row?.freightOfferId}
                              setEditFreightOffer={setEditFreightOffer}
                            />
                          </TableCell>}
                          {visibleColumns.includes('transportationContact') && <TableCell align="center">
                            {row?.transportationContact}
                          </TableCell>}
                          {visibleColumns.includes('freightRemark') && <TableCell align="center">
                            {row?.freightRemark}
                          </TableCell>}
                          {visibleColumns.includes('shipmentRequestNumberOfCases') && <TableCell align="center">
                            {row?.shipmentRequestNumberOfCases}
                          </TableCell>}
                          {visibleColumns.includes('shipmentRequestNetWeightPerCase') && <TableCell align="center">
                            {row?.shipmentRequestNetWeightPerCase}
                          </TableCell>}
                          {visibleColumns.includes('cartonNumber') && <TableCell align="center">
                            {row?.cartonNumber}
                          </TableCell>}
                          {visibleColumns.includes('shippedBy') && <TableCell align="center">{row?.shippedBy}
                          </TableCell>}
                          {visibleColumns.includes('shipperName') && <TableCell align="center">
                            {row?.shipperName}
                          </TableCell>}
                          {visibleColumns.includes('toBeShippedBy20') && <TableCell align="center">
                            {row?.toBeShippedBy20}
                          </TableCell>}
                          {visibleColumns.includes('toBeShippedBy40') && <TableCell align="center">
                            {row?.toBeShippedBy40}
                          </TableCell>}
                          {visibleColumns.includes('toBeShippedBy40HC') && <TableCell align="center">
                            {row?.toBeShippedBy40HC}
                          </TableCell>}
                          {visibleColumns.includes('toBeShippedByFtl') && <TableCell align="center">
                            {row?.toBeShippedByFtl}
                          </TableCell>}
                          {visibleColumns.includes('billOfLadingNumber') && <TableCell align="center">
                            {row?.billOfLadingNumber}
                          </TableCell>}
                          {visibleColumns.includes('billOfLadingDate') && <TableCell align="center">
                            {row?.billOfLadingDate
                              ? format(
                                  new Date(row?.billOfLadingDate),
                                  "dd/MM/yyyy",
                                )
                              : ""}
                          </TableCell>}
                          {visibleColumns.includes('cmrNumber') &&  <TableCell align="center">{row?.cmrNumber}</TableCell>}
                          {visibleColumns.includes('cmrDate') &&  <TableCell align="center">
                            {row?.cmrDate
                              ? format(new Date(row?.cmrDate), "dd/MM/yyyy")
                              : ""}
                          </TableCell>}
                          {visibleColumns.includes('estimatedTimeOfDeparture') && <TableCell
                            align="center"
                            onClick={handleDepartureCellClick}
                            style={{
                              cursor: "pointer",
                              color: "blue",
                              textDecoration: "underline",
                            }}
                          >
                            {row?.estimatedTimeOfDeparture
                              ? format(
                                  new Date(row?.estimatedTimeOfDeparture),
                                  "dd/MM/yyyy",
                                )
                              : ""}
                            {isAdditionalDepartureTimesVisible && (
                              <TableCell align="center">
                                {row?.secondEstimatedTimeOfDeparture
                                  ? ` 2nd Update ${format(
                                      new Date(
                                        row?.secondEstimatedTimeOfDeparture,
                                      ),
                                      "dd/MM/yyyy",
                                    )}`
                                  : ""}
                                <TableCell align="center">
                                  {row?.thirdEstimatedTimeOfDeparture
                                    ? ` 3rd Update ${format(
                                        new Date(
                                          row?.thirdEstimatedTimeOfDeparture,
                                        ),
                                        "dd/MM/yyyy",
                                      )}`
                                    : ""}
                                </TableCell>
                              </TableCell>
                            )}
                          </TableCell>}
                          {visibleColumns.includes('estimatedTimeOfArrival') && <TableCell
                            align="center"
                            onClick={handleDepartureCellClick}
                            style={{
                              cursor: "pointer",
                              color: "blue",
                              textDecoration: "underline",
                            }}
                          >
                            {row?.estimatedTimeOfArrival
                              ? format(
                                  new Date(row?.estimatedTimeOfArrival),
                                  "dd/MM/yyyy",
                                )
                              : ""}
                            {isAdditionalDepartureTimesVisible && (
                              <TableCell align="center">
                                {row?.secondEstimatedTimeOfArrival
                                  ? ` 2nd Update ${format(
                                      new Date(
                                        row?.secondEstimatedTimeOfArrival,
                                      ),
                                      "dd/MM/yyyy",
                                    )}`
                                  : ""}
                                <TableCell align="center">
                                  {row?.thirdEstimatedTimeOfArrival
                                    ? ` 3rd Update ${format(
                                        new Date(
                                          row?.thirdEstimatedTimeOfArrival,
                                        ),
                                        "dd/MM/yyyy",
                                      )}`
                                    : ""}
                                </TableCell>
                              </TableCell>
                            )}
                          </TableCell>}
                          {visibleColumns.includes('actualTimeOfArrival') && <TableCell align="center">
                            {row?.actualTimeOfArrival
                              ? format(new Date(row?.actualTimeOfArrival), "dd/MM/yyyy")
                              : ""}
                          </TableCell>}
                          {visibleColumns.includes('consigneeName') && <TableCell align="center">
                            {row?.consigneeName}
                          </TableCell>}
                          {visibleColumns.includes('notifyName') && <TableCell align="center">
                            {row?.notifyName}
                          </TableCell>}
                          {visibleColumns.includes('description') && <TableCell align="center">
                            {row?.description}
                          </TableCell>}
                          {visibleColumns.includes('revision') && <TableCell align="center">{row?.revision}</TableCell>}
                          {visibleColumns.includes('remark') && <TableCell align="center">{row?.remark}</TableCell>}
                          {visibleColumns.includes('link') && <TableCell align="center">
                            <a
                              href={row?.link}
                              target="_blank"
                              rel="noreferrer"
                            >
                              {row?.link && (
                                <Button
                                  disableElevation
                                  variant="outlined"
                                  size="small"
                                >
                                  SI Link
                                </Button>
                              )}
                            </a>
                          </TableCell>}
                          {visibleColumns.includes('shipmentRequestreferenceShippingInstructionId') && <TableCell align="center">
                            {
                              row?.shipmentRequestreferenceShippingInstructionId
                            }
                            -
                            {
                              row?.shipmentRequestreferenceShippingInstructionNumber
                            }
                          </TableCell>}
                          {visibleColumns.includes('status') && <TableCell align="center">{row?.status}</TableCell>}
                           {visibleColumns.includes('timestamp') && <TableCell align="center">
                            {row?.timestamp
                              ? format(
                                  new Date(row.timestamp),
                                  "dd/MM/yyyy HH:mm",
                                )
                              : ""}
                          </TableCell>}
                          {visibleColumns.includes('creator') && <TableCell align="center">{row?.creator}</TableCell>}
                          {visibleColumns.includes('recordStatus') && <TableCell align="center">
                            {row?.recordStatus}
                          </TableCell>}
                        </TableRow>
                      );
                    })}
                    {emptyRows > 0 && (
                      <TableRow
                        style={{
                          height: (dense ? 33 : 53) * emptyRows,
                        }}
                      >
                        <TableCell colSpan={6} />
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>*/}
              <div style={{ marginTop: "20px", marginLeft: "20px" }}>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    gap: "20px",
                    alignItems: "center",
                  }}
                >
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <span
                      style={{
                        background: "#c8e6c9",
                        padding: "4px 8px",
                        marginRight: "5px",
                        borderRadius: "8px",
                        display: "inline-block",
                      }}
                    >
                      Closed
                    </span>
                    <span>- SI Closed</span>
                  </div>
                </div>
              </div>
              <TablePagination
                rowsPerPageOptions={[5, 10, 25, 50]}
                component="div"
                count={rows.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </Paper>
            <FormControlLabel
              control={<Switch checked={dense} onChange={handleChangeDense} />}
              label="Dense padding"
            />
          </Box>
        </>
      )}
    </div>
  );
}
